import * as React from "react";
import amazonImage from "../../assets/images/amazon.png";
import googleImage from "../../assets/images/google.png";
import microsoftImage from "../../assets/images/microsoft.png";
import youtubeImage from "../../assets/images/youtube.png";
import bloombergImage from "../../assets/images/bloomberg.png";
import spotifyImage from "../../assets/images/spotify.png";
import wixImage from "../../assets/images/wix.png";
import hsbcImage from "../../assets/images/hsbc.png";
// import clientLogo from "../../assets/images/client-logo-2.png";
import caseStudyImg from "../../assets/images/case-study.png";
// import Ata from "../../images/ata.png";
import Img from "../../assets/gh.jpeg";

// import Availability from "../../assets/svg/24-7-availability";

import amazonLogo from "../../assets/images/client_logo/amazon_1.png";
import bloombergLogo from "../../assets/images/client_logo/bloomberg.svg";
import googleLogo from "../../assets/images/client_logo/google.svg";
import hsbcLogo from "../../assets/images/client_logo/hsbc.svg";
import mgmLogo from "../../assets/images/client_logo/mgm_1.png";
import microsoftLogo from "../../assets/images/client_logo/microsoft.svg";
import SAPLogo from "../../assets/images/client_logo/SAP_1.png";
import spotifyLogo from "../../assets/images/client_logo/spotify_1.svg";
import wixLogo from "../../assets/images/client_logo/wix_1.svg";
import youtubeLogo from "../../assets/images/client_logo/youtube.svg";
import ParisImage from "../../assets/images/Paris-2024-banner.webp";
import ISO from "../../images/iso.png";
import images from "../../assets/images/translationcost.jpg";
/** Dummy Top Hero Section data. */

import Berlin from "../../assets/images/office_locations/Brelin.png";
import Bremen from "../../assets/images/office_locations/Bremen.png";

export const LanguageTransServiceData = {
  title:
    "Language translation services allow you to be understood properly and connect strongly with your target audience.",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.  ",
};

export const AccreditedData = {
  title: "Certified for Private and Public Institutions",
  description:
    "Our certified translation services come with the Tomedes guarantee. Our translation certificates are universally accepted in institutions worldwide, and in the USA, like the USCIS, as well as certified by the American Translator’s Association (ATA), the International Organization for Standardization (ISO).",
  highlightWords: ["certified", "translation", "services"],
  highlightedColor: "yellow",
  bottomSeal: [
    {
      url: "https://www.tomedes.com/static/ata-41203743717d3de6324cd98baebcfcb4.png",
      label: "ISO 9001:2015 Certification No. 108179",
    },
    {
      url: "https://www.tomedes.com/static/ata-41203743717d3de6324cd98baebcfcb4.png",
      label: "ISO 9001:2015 Certification No. 108179",
    },
    {
      url: "https://www.tomedes.com/static/ata-41203743717d3de6324cd98baebcfcb4.png",
      label: "ISO 9001:2015 Certification No. 108179",
    },
  ],
  //   img2: "",
};

export const TranslationGridData = {
  title: "Translate any document from any number of complex industries",
  description:
    "Tomedes’ document translation services have provided the highest quality of translations to businesses and organizations worldwide, in any language. We don’t just translate words–we capture your true meaning.",
  highlightWords: ["document", "translation", "services"],
  highlightedColor: "yellow",
  feed: [
    {
      id: 1,
      title: "Legal Translation",
      description:
        "Legal translation is a highly specialized field. Our professional legal translators are adept in the various fields of law. We translate affidavits, patents, contracts, and other legal documents. If you’re in need of legal translation, our legal experts are up for the task. Learn more today.",
      highlightWords: [
        "We",
        "translate",
        "affidavits",
        "patents",
        "contracts",
        "and",
        "other",
        "legal",
        "documents",
      ],
      highlightedColor: "yellow",
      banner: "https://via.placeholder.com/409x190.png?text=Tomedes",
      linktext: "GET STARTED",
      linkto: "#",
    },
    {
      id: 2,
      title: "Medical Translation",
      description:
        "Translation is an integral part of healthcare, abiding by regulations from the FDA and backed by an in-depth understanding of the life sciences. We translate vital medical documents, discharge records, patient forms and academic journals. Medical translation can cover your bases and make sure there are no misunderstandings in every patient interaction. Contact us for your relevant services..",
      highlightWords: [
        "We",
        "translate",
        "vital",
        "medical",
        "documents",
        "discharge",
        "records",
        "patient",
        "forms",
        "and",
        "academic",
        "journals",
      ],
      highlightedColor: "yellow",
      banner: "https://via.placeholder.com/409x190.png?text=Tomedes",
      linktext: "GET STARTED",
      linkto: "#",
    },
    {
      id: 3,
      title: "Financial Translation",
      description:
        "Financial translation is here to support the bottomline of your business. We translate loan documents, contracts, mortgage papers, financial documents, statements of accounts, credit reports and more. Provided by experts in finance and financial terminology, our financial translation combines linguistic accuracy and attention to detail. Try it out today.",
      highlightWords: [
        "We",
        "translate",
        "affidavits",
        "patents",
        "contracts",
        "and",
        "other",
        "legal",
        "documents",
      ],
      highlightedColor: "yellow",
      banner: "https://via.placeholder.com/409x190.png?text=Tomedes",
      linktext: "GET STARTED",
      linkto: "#",
    },
    {
      id: 4,
      title: "Technical Translation",
      description:
        "Technical translation should transform even the most complex procedures for global use. We translate technical documentation in any language: from manuals , architectural plans, and more. Our technical translation combines the best of all worlds–languages, applied sciences, advanced mathematics, and more. Look no further.",
      highlightWords: [
        "We",
        "translate",
        "vital",
        "medical",
        "documents",
        "discharge",
        "records",
        "patient",
        "forms",
        "and",
        "academic",
        "journals",
      ],
      highlightedColor: "yellow",
      banner: "https://via.placeholder.com/409x190.png?text=Tomedes",
      linktext: "GET STARTED",
      linkto: "#",
    },
  ],
  //   img2: "",
};

export const TopHeroData = {
  topLinks: {
    email: {
      default: "contact@tomedes.com",
      en: "contact@tomedes.com",
      fr: "contact@tomedes.com",
    },
    phone: {
      default: "US: +1 985 239 0142",
      en: "US: +1 985 239 0142",
      fr: "US: +1 985 239 0142",
    },
    phone2: {
      default: "UK: +44 (0)16 1509 6140",
      en: "UK: +44 (0)16 1509 6140",
      fr: "UK: +44 (0)16 1509 6140",
    },
  },
  blogMenuData: [
    {
      label: {
        default: "SIGN IN",
        en: "SIGN IN",
        fr: "Connexion",
      },
      link: "#",
    },
    {
      label: {
        default: "Contact us",
        en: "Contact us",
        fr: "Contactez-nous",
      },
      link: "#",
    },
    {
      label: {
        default: "LIVE HELP",
        en: "LIVE HELP",
        fr: "Add french Live",
      },
      link: "#",
    },
  ],
  menuData: [
    {
      id: 1,
      label: {
        default: "SERVICES",
        en: "SERVICES",
        fr: "SERVICES",
      },
      link: "",
      type: "multicolumn",
      submenuData: [
        {
          label: {
            default: "Translation Services",
            en: "Translation Services",
            fr: "Services de traduction",
          },
          items: [
            {
              label: {
                default: "Document Translation",
                en: "Document Translation",
                fr: "Traduction de document",
              },
              link: "",
            },
            {
              label: {
                default: "Legal Translation",
                en: "Legal Translation",
                fr: "Traduction juridique",
              },
              link: "",
            },
            {
              label: {
                default: "Marketing Translation",
                en: "Marketing Translation",
                fr: "Traduction marketing",
              },
              link: "",
            },
            {
              label: {
                default: "Medical Translation",
                en: "Medical Translation",
                fr: "Traduction médicale",
              },
              link: "",
            },
            {
              label: {
                default: "Financial Translation",
                en: "Financial Translation",
                fr: "Traduction financière",
              },
              link: "",
            },
            {
              label: {
                default: "Technology Translation",
                en: "Technology Translation",
                fr: "Traduction technique",
              },
              link: "",
            },
            {
              label: {
                default: "Sworn Translation",
                en: "Sworn Translation",
                fr: "Traduction assermentée",
              },
              link: "",
            },
          ],
        },
        {
          label: {
            default: "Localization Services",
            en: "Localization Services",
            fr: "Services de localisation",
          },
          items: [
            {
              label: {
                default: "Website Translation",
                en: "Website Translation",
                fr: "Traduction de site web",
              },
              link: "",
            },
            {
              label: {
                default: "Mobile App Localization",
                en: "Mobile App Localization",
                fr: "Traduction d’application mobile",
              },
              link: "",
            },
            {
              label: {
                default: "Software Localization",
                en: "Software Localization",
                fr: "Traduction de logiciel",
              },
              link: "",
            },
            {
              label: {
                default: "Video Translation",
                en: "Video Translation",
                fr: "Traduction de jeux vidéo",
              },
              link: "",
            },
          ],
        },
        {
          label: {
            default: "Medical Translation",
            en: "Medical Translation",
            fr: "Services linguistique",
          },
          items: [
            {
              label: {
                default: "Language One",
                en: "Language One",
                fr: "Rédaction de contenu",
              },
              link: "",
            },
            {
              label: {
                default: "Language Two",
                en: "Language Two",
                fr: "Voix off",
              },
              link: "",
            },
            {
              label: {
                default: "Language Three",
                en: "Language Three",
                fr: "Sous-titrage multilingue ",
              },
              link: "",
            },
            {
              label: {
                default: "Language Four",
                en: "Language Four",
                fr: "Interprétation",
              },
              link: "",
            },
            {
              label: {
                default: "More",
                en: "More",
                fr: "Relecture et révision de texte",
              },
              link: "",
            },
            {
              label: {
                default: "six",
                en: "six",
                fr: "Transcription",
              },
              link: "",
            },
            {
              label: {
                default: "seven",
                en: "seven",
                fr: "PAO multilingue",
              },
              link: "",
            },
          ],
        },
        {
          label: {
            default: "Add English",
            en: "Add English",
            fr: "Services aux entreprises",
          },
          items: [
            {
              label: {
                default: "Language One",
                en: "Language One",
                fr: "SEO",
              },
              link: "",
            },
            {
              label: {
                default: "Language Two",
                en: "Language Two",
                fr: "Coût par clic",
              },
              link: "",
            },
            {
              label: {
                default: "Language Three",
                en: "Language Three",
                fr: "Marketing international",
              },
              link: "",
            },
            {
              label: {
                default: "Language Four",
                en: "Language Four",
                fr: "Marketing des médias sociaux",
              },
              link: "",
            },
            {
              label: {
                default: "More",
                en: "More",
                fr: "Consultation en internationalisation",
              },
              link: "",
            },
            {
              label: {
                default: "six",
                en: "six",
                fr: "Services de test",
              },
              link: "",
            },
            {
              label: {
                default: "seven",
                en: "seven",
                fr: "Service à la clientèle",
              },
              link: "",
            },
            {
              label: {
                default: "eight",
                en: "eight",
                fr: "Placement et recrutement",
              },
              link: "",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      label: {
        default: "LANGUAGES",
        en: "LANGUAGES",
        fr: "LANGUES",
      },
      link: "",
      type: "simple",
      submenuData: [
        {
          label: {
            default: "Languages One",
            en: "Languages One",
            fr: "Anglais",
          },
          link: "",
        },
        {
          label: {
            default: "Languages Two",
            en: "Languages Two",
            fr: "Portugais",
          },
          link: "",
        },
        {
          label: {
            default: "Languages Three",
            en: "Languages Three",
            fr: "Allemand",
          },
          link: "",
        },
        {
          label: {
            default: "Languages Four",
            en: "Languages Four",
            fr: "Espagnol",
          },
          link: "",
        },
        {
          label: {
            default: "Languages Five",
            en: "Languages Five",
            fr: "Chinois",
          },
          link: "",
        },
        {
          label: {
            default: "Languages six",
            en: "Languages six",
            fr: "Italien",
          },
          link: "",
        },
        {
          label: {
            default: "Languages More Language",
            en: "Languages More Language",
            fr: "Plus de langues ",
          },
          link: "",
        },
      ],
    },
    {
      id: 3,
      label: {
        default: "About",
        en: "About",
        fr: "À PROPOS",
      },
      link: "",
      type: "simple",
      submenuData: [
        {
          label: {
            default: "About Us",
            en: "About Us",
            fr: "À propos de nous",
          },
          link: "",
        },
        {
          label: {
            default: "Contact Us",
            en: "Contact Us",
            fr: "Contact",
          },
          link: "",
        },
        {
          label: {
            default: "Customers",
            en: "Customers",
            fr: "Clients",
          },
          link: "",
        },
        {
          label: {
            default: "Reviews",
            en: "Reviews",
            fr: "Témoignages",
          },
          link: "",
        },
      ],
    },
    {
      id: 4,
      label: {
        default: "CASE STUDIES",
        en: "CASE STUDIES",
        fr: "Étude de cas",
      },
      link: "/traductions-recentes",
      type: "simple",
      submenuData: [],
    },
    {
      id: 5,
      label: {
        default: "LOCATIONS",
        en: "LOCATIONS",
        fr: "Agences",
      },
      link: "/agences",
      type: "simple",
      submenuData: [],
    },
  ],
  buttonDetails: {
    text: {
      default: "Translate Now",
      en: "Translate Now",
      fr: "Devis gratuit",
    },
    href: "/quote",
  },
  defaultLanguage: {
    default: "USA - EN",
    en: "USA - EN",
    fr: "FR",
  },
  languages: [
    {
      text: "English",
      hreflang: "en-us",
      href: "https://www.tomedes.com/",
    },
    {
      text: "Español",
      hreflang: "es",
      href: "https://es.tomedes.com/",
    },
    {
      text: "简体中文",
      hreflang: "cn",
      href: "https://cn.tomedes.com/",
    },
    {
      text: "中國傳統的",
      hreflang: "cn",
      href: "https://tw.tomedes.com/",
    },
    {
      text: "Deutsch",
      hreflang: "de",
      href: "https://de.tomedes.com/",
    },
    {
      text: "Français",
      hreflang: "fr",
      href: "https://fr.tomedes.com/",
    },
    {
      text: "Nederlands",
      hreflang: "nl",
      href: "https://nl.tomedes.com/",
    },
    {
      text: "עברית",
      hreflang: "he",
      href: "https://www.tomedes.co.il/",
    },
    {
      text: "日本語",
      hreflang: "ja",
      href: "https://jp.tomedes.com",
    },
    {
      text: "한국어",
      hreflang: "ko",
      href: "https://kr.tomedes.com/",
    },
    {
      text: "Norsk",
      hreflang: "nb",
      href: "https://no.tomedes.com/",
    },
    {
      text: "Polski",
      hreflang: "pl",
      href: "https://pl.tomedes.com/",
    },
    {
      text: "Româna",
      hreflang: "ro",
      href: "https://ro.tomedes.com/",
    },
    {
      text: "Svenska",
      hreflang: "sv",
      href: "https://sv.tomedes.com/",
    },
    {
      text: "Türk",
      hreflang: "tr",
      href: "https://tr.tomedes.com/",
    },
    {
      text: "Русский",
      hreflang: "ru",
      href: "https://ru.tomedes.com/",
    },
  ],
  account: {
    text: {
      default: "Account",
      en: "Account",
      fr: "Connexion",
    },
    href: "/user/auth/login",
  },
};

export const HeroBannerData = {
  title: {
    default: "Professional Translation Services On A Global Scale",
    en: "Professional Translation Services On A Global Scale",
    fr: "Add french translation",
  },
  description: {
    default:
      "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    en: "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    fr: "Add french translation",
  },

  buttonDetails: {
    text: {
      default: "TRANSLATE NOW",
      en: "TRANSLATE NOW",
      fr: "Add french translation",
    },
    link: "/quote",
  },
  svgsTitle: {
    default: "Trusted by Satisfied Clients Worldwide",
    en: "Trusted by Satisfied Clients Worldwide",
    fr: "Add french translation",
  },
  seal: [
    {
      icon: "guarantee",
      text: {
        default: "1 Year Guarantee",
        en: "1 Year Guarantee",
        fr: "Add french translation",
      },
    },
    {
      icon: "availability",
      text: {
        default: "24/7 Availability",
        en: "24/7 Availability",
        fr: "Add french translation",
      },
    },
    {
      icon: "rapid-delivery",
      text: {
        default: "Rapid Delivery",
        en: "Rapid Delivery",
        fr: "Add french translation",
      },
    },
  ],
  enquiry_form: {
    title: {
      default: "Parlez-nous de vous et de votre projet",
      en: "Add english translation",
      fr: "Parlez-nous de vous et de votre projet",
    },
    highlightWords: {
      default: ["Parlez-nous"],
      en: ["Parlez-nous"],
      fr: ["Parlez-nous"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default:
        "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
      en: "Add english translation",
      fr: "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
    },

    placeholder: {
      name: {
        default: "Name",
        en: "Name",
        fr: "Add french translation",
      },
      email: {
        default: "Email Address",
        en: "Email Address",
        fr: "Add french translation",
      },
      tellUs: {
        default: "Tell us more about your needs",
        en: "Tell us more about your needs",
        fr: "Add french translation",
      },
    },

    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "Add french translation",
    },
  },
};

export const languesHeroBannerData = {
  title: {
    default: "Add default translation.",
    en: "Add English translation.",
    fr: "Langues traduites",
  },
  description: {
    default: "Add default translation.",
    en: "Add English translation.",
    fr: "Notre vaste réseau d’experts-traducteurs répartis à travers le monde nous permet de prendre en charge vos traductions vers et depuis plus de 120 langues. Près de 950 combinaisons linguistiques sont possibles.",
  },

  buttonDetails: {
    text: {
      default: "Add default translation.",
      en: "Add English translation.",
      fr: "DEMANDE DE DEVIS",
    },
    link: "/quote",
  },
  svgsTitle: {
    default: "Trusted by Satisfied Clients Worldwide",
    en: "Trusted by Satisfied Clients Worldwide",
    fr: "Add french translation",
  },
  seal: [
    {
      icon: "guarantee",
      text: {
        default: "1 Year Guarantee",
        en: "1 Year Guarantee",
        fr: "1 an de garantie",
      },
    },
    {
      icon: "availability",
      text: {
        default: "24/7 Availability",
        en: "24/7 Availability",
        fr: "Service client 24h/24 - 7j/7",
      },
    },
    {
      icon: "rapid-delivery",
      text: {
        default: "Rapid Delivery",
        en: "Rapid Delivery",
        fr: "Livraison express",
      },
    },
  ],
  enquiry_form: {
    title: {
      default: "Add default translation",
      en: "Add english translation",
      fr: "Obtenez votre devis gratuit",
    },
    highlightWords: {
      default: ["default"],
      en: ["english"],
      fr: ["Obtenez"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default: "Add default translation",
      en: "Add english translation",
      fr: "Un projet en cours, un besoin spécifique? Envoyez-nous un message, nous vous répondons en moins de 30 minutes !",
    },

    placeholder: {
      name: {
        default: "Name",
        en: "Name",
        fr: "Nom complet",
      },
      email: {
        default: "Email Address",
        en: "Email Address",
        fr: "Adresse e-mail",
      },
      message: {
        default: "Tell us more about your needs",
        en: "Tell us more about your needs",
        fr: "En quoi pouvons-nous vous aider ?",
      },
    },

    fieldRequired: {
      default: "This field is required",
      en: "This field is required",
      fr: "Add french translation",
    },

    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "ENVOYER",
    },
  },
};

export const agencesHeroBannerData = {
  title: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Tomedes France",
  },
  description: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "En France, en Europe et ailleurs, Tomedes est leader de la traduction et des services linguistiques. Nos services de traduction ont déjà permis à plus de 70 millions de clients exigeants de s’ouvrir à l’international.",
  },

  buttonDetails: {
    text: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "DEMANDE DE DEVIS",
    },
    link: "/quote",
  },
  svgsTitle: {
    default: "Trusted by Satisfied Clients Worldwide",
    en: "Trusted by Satisfied Clients Worldwide",
    fr: "Add french translation",
  },
  seal: [
    {
      icon: "guarantee",
      text: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "1 an de garantie",
      },
    },
    {
      icon: "availability",
      text: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Service client 24h/24 - 7j/7",
      },
    },
    {
      icon: "rapid-delivery",
      text: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Livraison express",
      },
    },
  ],
  enquiry_form: {
    title: {
      default: "Add english translation",
      en: "Add english translation",
      fr: "Parlez-nous de vous et de votre projet",
    },
    highlightWords: {
      default: ["english"],
      en: ["english"],
      fr: ["Parlez-nous"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default: "Add english translation",
      en: "Add english translation",
      fr: "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
    },

    placeholder: {
      name: {
        default: "Name",
        en: "Name",
        fr: "Nom complet",
      },
      email: {
        default: "Email Address",
        en: "Email Address",
        fr: "Adresse e-mail",
      },
      message: {
        default: "Tell us more about your needs",
        en: "Tell us more about your needs",
        fr: "En quoi pouvons-nous vous aider ?",
      },
    },

    fieldRequired: {
      default: "This field is required",
      en: "This field is required",
      fr: "Add french translation",
    },

    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "ENVOYER",
    },
  },
};

export const TestimonialsData = {
  title: {
    default: "What Our Clients are Saying About Us",
    en: "What Our Clients are Saying About Us",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["Clients"],
    en: ["Clients"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  ratingText: {
    default: "4.9 out of 5 stars (1,798 overall reviews)",
    en: "4.9 out of 5 stars (1,798 overall reviews)",
    fr: "Add french translation",
  },
  testimonials: [
    {
      id: 1,
      title: {
        default: '"Speedy return & reasonably priced"',
        en: '"Speedy return & reasonably priced"',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "A translation company well equipped with knowledge of hundreds of different languages - speedy return & reasonably priced.",
        en: "A translation company well equipped with knowledge of hundreds of different languages - speedy return & reasonably priced.",
        fr: "Add french translation",
      },
      user: {
        default: "Katherine Lindsay",
        en: "Katherine Lindsay",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#3a7aff"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#3a7aff"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
    },
    {
      id: 2,
      title: {
        default:
          '"Tomedes has been nothing but kind, knowledgeable and efficient!"',
        en: '"Tomedes has been nothing but kind, knowledgeable and efficient!"',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "Tomedes has been nothing but kind, knowledgeable and efficient!...Everything was seamless! I trusted Tomedes so much they’re now working...with an even bigger project: interpreting a multi-language Zoom meeting!",
        en: "Tomedes has been nothing but kind, knowledgeable and efficient!...Everything was seamless! I trusted Tomedes so much they’re now working...with an even bigger project: interpreting a multi-language Zoom meeting!",
        fr: "Add french translation",
      },
      user: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#3a7aff"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#3a7aff"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
    },
    {
      id: 3,
      title: {
        default: '"Efficient and very good customer service."',
        en: '"Efficient and very good customer service."',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "The Tomedes team was very responsive and quick to help us address any issues related to timeline and quality of translation...I would recommend the Tomedes team to any computer science curriculum providers.",
        en: "The Tomedes team was very responsive and quick to help us address any issues related to timeline and quality of translation...I would recommend the Tomedes team to any computer science curriculum providers.",
        fr: "Add french translation",
      },
      user: {
        default: "Jorge Castro",
        en: "Jorge Castro",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#3a7aff"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#3a7aff"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
    },
  ],
};

/** homepage data **/

export const ServiceClientsData = {
  title: {
    default: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
    en: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
    fr: "Add french translation",
  },

  highlightWords: {
    default: ["95,000"],
    en: ["95,000"],
    fr: ["french"],
  },

  highlightedColor: "yellow",

  subtitle: {
    default:
      "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
    en: "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
    fr: "Add french translation",
  },

  clients: [
    {
      id: 1,
      title: {
        default: "Amazon",
        en: "Amazon",
        fr: "Add french translation",
      },
      icon: "amazon",
      className: "w-24 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Google",
        en: "Google",
        fr: "Add french translation",
      },
      icon: "google",
      className: "w-20 h-auto",
    },
    {
      id: 3,
      title: {
        default: "Microsoft",
        en: "Microsoft",
        fr: "Add french translation",
      },
      icon: "microsoft",
      className: "w-24 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Youtube",
        en: "Youtube",
        fr: "Add french translation",
      },
      icon: "youtube",
      className: "w-24 h-auto",
    },
    {
      id: 5,
      title: {
        default: "Bloomberg",
        en: "Bloomberg",
        fr: "Add french translation",
      },
      icon: "bloomberg",
      className: "w-24 h-auto",
    },
    {
      id: 6,
      title: {
        default: "Spotify",
        en: "Spotify",
        fr: "Add french translation",
      },
      icon: "spotify",
      className: "w-20 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Wix",
        en: "Wix",
        fr: "Add french translation",
      },
      icon: "wix",
      className: "w-20 h-auto",
    },
    {
      id: 8,
      title: {
        default: "HSBC",
        en: "HSBC",
        fr: "Add french translation",
      },
      icon: "hsbc",
      className: "w-24 h-auto",
    },
    {
      id: 9,
      title: {
        default: "Canon",
        en: "Canon",
        fr: "Add french translation",
      },
      icon: "canon",
      className: "w-24 h-auto",
    },
    {
      id: 10,
      title: {
        default: "MGM",
        en: "MGM",
        fr: "Add french translation",
      },
      icon: "mgm",
      className: "w-11 h-auto",
    },
    {
      id: 11,
      title: {
        default: "Code",
        en: "Code",
        fr: "Add french translation",
      },
      icon: "code",
      className: "w-9 h-auto",
    },
    {
      id: 12,
      title: {
        default: "SAP",
        en: "SAP",
        fr: "Add french translation",
      },
      icon: "sap",
      className: "w-12 h-auto",
    },
  ],
};
export const languesServiceClientsData = {
  // title: {
  //   default: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
  //   en: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
  //   fr: "Add french translation",
  // },

  // highlightWords: {
  //   default: ["95,000"],
  //   en: ["95,000"],
  //   fr: ["french"],
  // },

  // highlightedColor: "yellow",

  // subtitle: {
  //   default:
  //     "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
  //   en: "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
  //   fr: "Add french translation",
  // },

  clients: [
    {
      id: 1,
      title: {
        default: "Amazon",
        en: "Amazon",
        fr: "Amazone",
      },
      icon: "amazon-white",

      className: "w-24 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Google",
        en: "Google",
        fr: "Google",
      },
      icon: "google",

      className: "w-20 h-auto",
    },
    {
      id: 3,
      title: {
        default: "Microsoft",
        en: "Microsoft",
        fr: "Microsoft",
      },
      icon: "microsoft-white",
      className: "w-24 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Youtube",
        en: "Youtube",
        fr: "Youtube",
      },
      icon: "youtube-white",
      className: "w-24 h-auto",
    },
    {
      id: 5,
      title: {
        default: "Bloomberg",
        en: "Bloomberg",
        fr: "Bloomberg",
      },
      icon: "bloomberg-white",
      className: "w-24 h-auto",
    },
    {
      id: 6,
      title: {
        default: "Spotify",
        en: "Spotify",
        fr: "Spotify",
      },
      icon: "spotify",
      className: "w-20 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Wix",
        en: "Wix",
        fr: "Wix",
      },
      icon: "wix-white",
      className: "w-20 h-auto",
    },
    {
      id: 8,
      title: {
        default: "HSBC",
        en: "HSBC",
        fr: "HSBC",
      },
      icon: "hsbc-white",
      className: "w-24 h-auto",
    },
    {
      id: 9,
      title: {
        default: "Canon",
        en: "Canon",
        fr: "Canon",
      },
      icon: "canon-white",
      className: "w-24 h-auto",
    },
    {
      id: 10,
      title: {
        default: "MGM",
        en: "MGM",
        fr: "MGM",
      },
      icon: "mgm",
      className: "w-11 h-auto",
    },
    {
      id: 11,
      title: {
        default: "HP",
        en: "HP",
        fr: "HP",
      },
      icon: "hp",
      className: "w-9 h-auto",
    },
    {
      id: 12,
      title: {
        default: "SAP",
        en: "SAP",
        fr: "SAP",
      },
      icon: "sap",
      className: "w-12 h-auto",
    },
  ],
};

export const languageData = {
  title: {
    default: "Nos traducteurs professionnels dans plus de 120 Langues",
    en: "Add English translation",
    fr: "Nos traducteurs professionnels dans plus de 120 Langues",
  },

  highlightWords: {
    default: ["120 Langues"],
    en: ["English"],
    fr: ["120 Langues"],
  },

  highlightedColor: "yellow",

  page_content: {
    default:
      "Your transcript can be translated into over 120 languages and 950+ language pairs. We can translate transcripts to English from Arabic, French from German, Portuguese from Spanish and more. We support rare and hard-to-find languages as well, so you can be sure to have your pick from our large repertoire of languages.",
    en: "Your transcript can be translated into over 120 languages and 950+ language pairs. We can translate transcripts to English from Arabic, French from German, Portuguese from Spanish and more. We support rare and hard-to-find languages as well, so you can be sure to have your pick from our large repertoire of languages.",
    fr: "Add french translation",
  },

  languages: [
    {
      id: 0,
      text: {
        default: "Spanish",
        en: "Spanish",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 1,
      text: {
        default: "Chinese",
        en: "Chinese",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 2,
      text: {
        default: "Arabic",
        en: "Arabic",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 3,
      text: {
        default: "French",
        en: "French",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 4,
      text: {
        default: "Italian",
        en: "Italian",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 5,
      text: {
        default: "German",
        en: "German",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 6,
      text: {
        default: "Korean",
        en: "Korean",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 7,
      text: {
        default: "Japanese",
        en: "Japanese",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 8,
      text: {
        default: "Portuguese",
        en: "Portuguese",
        fr: "Add french translation",
      },
      link: "/",
    },
    {
      id: 9,
      text: {
        default: "Vietnamese",
        en: "Vietnamese",
        fr: "Add french translation",
      },
      link: "/",
    },
  ],

  footer_text: {
    default:
      "If you’re interested in translating now, here are our languages available.",
    en: "If you’re interested in translating now, here are our languages available.",
    fr: "Add french translation",
  },

  cta: {
    text: {
      default: "LEARN MORE",
      en: "LEARN MORE",
      fr: "Add french translation",
    },
    href: "/",
  },
};

export const languageDataHomePage = {
  title: {
    default: "Nos traducteurs professionnels dans plus de 120 Langues",
    en: "Add English translation",
    fr: "Obtenez vos traductions dans plus de 120 langues",
  },

  highlightWords: {
    default: ["120 Langues"],
    en: ["English"],
    fr: ["120 Langues"],
  },

  highlightedColor: "yellow",

  page_content: {
    default:
      "Your transcript can be translated into over 120 languages and 950+ language pairs. We can translate transcripts to English from Arabic, French from German, Portuguese from Spanish and more. We support rare and hard-to-find languages as well, so you can be sure to have your pick from our large repertoire of languages.",
    en: "Your transcript can be translated into over 120 languages and 950+ language pairs. We can translate transcripts to English from Arabic, French from German, Portuguese from Spanish and more. We support rare and hard-to-find languages as well, so you can be sure to have your pick from our large repertoire of languages.",
    fr: "Présents sur tous les continents et sous tous les fuseaux horaires, nos traducteurs sont à même de traduire votre contenu dans plus de 120 langues.<br />Ce sont en tout plus de 950 combinaisons qui vous sont offertes entre la langue d’origine et celle de destination. Nous maîtrisons aussi bien les langues les plus couramment parlées que les plus rares.",
  },

  languages: [],

  footer_text: {
    default:
      "If you’re interested in translating now, here are our languages available.",
    en: "If you’re interested in translating now, here are our languages available.",
    fr: "Add french translation",
  },

  cta: {
    text: {
      default: "LEARN MORE",
      en: "LEARN MORE",
      fr: "EN SAVOIR PLUS",
    },
    href: "/",
  },
};

export const dummyData = {
  title: "Insert H2 here (Highlight) Lorem ipsum",
  highlightWords: ["(Highlight)"],
  highlightedColor: "yellow",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  imgurl:
    "https://www.pngitem.com/pimgs/m/314-3145380_corporate-girl-png-transparent-png.png",
  seal: [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 16.614 22"
        >
          <defs></defs>
          <g transform="translate(-0.002 0.001)">
            <path
              fill="#ff7b16"
              className="a"
              d="M15.475,367.509a2.646,2.646,0,0,1-3.038-1.106,2.652,2.652,0,0,1-1.593-.617q-.085-.072-.164-.15l-1.437,3.007a.653.653,0,0,0,.733.918l2.881-.653,1.3,2.652a.653.653,0,0,0,.586.365h0a.653.653,0,0,0,.585-.371l1.671-3.5a2.652,2.652,0,0,1-1.529-.55Zm0,0"
              transform="translate(-8.783 -349.926)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M201.538,365.786a2.652,2.652,0,0,1-1.593.617,2.646,2.646,0,0,1-3.038,1.106,2.652,2.652,0,0,1-1.529.55l1.67,3.5a.653.653,0,0,0,.586.371h0a.653.653,0,0,0,.586-.365l1.3-2.652,2.881.653a.653.653,0,0,0,.733-.918l-1.437-3.007Q201.624,365.715,201.538,365.786Zm0,0"
              transform="translate(-186.982 -349.926)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M16.331,8.012a1.342,1.342,0,0,0-.346-1.965.652.652,0,0,1-.275-.755,1.342,1.342,0,0,0-1-1.728A.653.653,0,0,1,14.2,2.95a1.342,1.342,0,0,0-1.528-1.282.653.653,0,0,1-.7-.4A1.341,1.341,0,0,0,10.1.583a.653.653,0,0,1-.791-.14,1.342,1.342,0,0,0-1.995,0,.653.653,0,0,1-.791.14,1.341,1.341,0,0,0-1.875.682.652.652,0,0,1-.7.4A1.342,1.342,0,0,0,2.421,2.95a.653.653,0,0,1-.516.615,1.342,1.342,0,0,0-1,1.727.653.653,0,0,1-.275.755A1.342,1.342,0,0,0,.286,8.012a.653.653,0,0,1,0,.8A1.342,1.342,0,0,0,.633,10.78a.653.653,0,0,1,.275.755,1.342,1.342,0,0,0,1,1.728.653.653,0,0,1,.516.615A1.342,1.342,0,0,0,3.95,15.161a.653.653,0,0,1,.7.4,1.342,1.342,0,0,0,1.875.682.653.653,0,0,1,.791.139,1.342,1.342,0,0,0,1.995,0,.653.653,0,0,1,.791-.139,1.342,1.342,0,0,0,1.875-.682.653.653,0,0,1,.7-.4A1.342,1.342,0,0,0,14.2,13.878a.653.653,0,0,1,.516-.615,1.342,1.342,0,0,0,1-1.728.653.653,0,0,1,.275-.755,1.341,1.341,0,0,0,.346-1.965.653.653,0,0,1,0-.8ZM8.309,14.133a5.719,5.719,0,1,1,5.719-5.719,5.726,5.726,0,0,1-5.719,5.719Zm0,0"
              transform="translate(0)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M95.015,93.105a4.414,4.414,0,1,0,4.414,4.414A4.419,4.419,0,0,0,95.015,93.105Zm-2.757,3.6a.653.653,0,0,1,.923,0l1.3,1.3,2.367-2.367a.653.653,0,0,1,.923.923L94.944,99.4a.653.653,0,0,1-.923,0l-1.762-1.762A.653.653,0,0,1,92.258,96.71Zm0,0"
              transform="translate(-86.707 -89.105)"
            />
          </g>
        </svg>
      ),
      text: "1 Year Guarantee",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 22 22"
        >
          <defs></defs>
          <path
            className="a"
            fill="#ff7b16"
            d="M3.406,176.733H.645a.645.645,0,0,0-.645.645v6.9a.645.645,0,0,0,.645.645H3.406a.645.645,0,0,0,.645-.645v-6.9A.645.645,0,0,0,3.406,176.733Z"
            transform="translate(0 -169.139)"
          />
          <path
            className="a"
            fill="#ff7b16"
            d="M269.2,183.169a.645.645,0,0,0,.645-.645V181.1h.046a.645.645,0,0,0,0-1.289h-.046v-3.5a.645.645,0,0,0-1.1-.456l-2.966,2.965a2.333,2.333,0,0,0-.674,1.633.645.645,0,0,0,.645.645h2.807v1.427A.645.645,0,0,0,269.2,183.169Zm-2.579-3.36a1.011,1.011,0,0,1,.07-.078l1.865-1.864v1.942Z"
            transform="translate(-253.709 -168.118)"
          />
          <path
            className="a"
            fill="#ff7b16"
            d="M133.275,182.525a.645.645,0,0,0-.645-.645h-2.579a1,1,0,0,1,.07-.078l2.965-2.964a.644.644,0,0,0,.189-.456v-.345a2.37,2.37,0,0,0-4.741,0h0a.645.645,0,0,0,1.289,0,1.081,1.081,0,0,1,2.163,0v.078l-2.778,2.776a2.333,2.333,0,0,0-.674,1.633.645.645,0,0,0,.645.645h3.452a.645.645,0,0,0,.644-.645Z"
            transform="translate(-123.011 -168.119)"
          />
          <path
            className="a"
            fill="#ff7b16"
            d="M77.623,1.289a6.962,6.962,0,0,1,6.732,5.22,1.921,1.921,0,0,1,.863-.2h.415a8.239,8.239,0,0,0-16.018,0h.415a1.921,1.921,0,0,1,.863.2,6.962,6.962,0,0,1,6.732-5.22Z"
            transform="translate(-66.623)"
          />
          <path
            className="a"
            fill="#ff7b16"
            d="M217.5,391.057a4.194,4.194,0,0,1-3.844,2.527h-.842a2.025,2.025,0,1,0,0,1.289h.842a5.486,5.486,0,0,0,5.124-3.544h-.292a1.921,1.921,0,0,1-.988-.273Z"
            transform="translate(-199.892 -374.254)"
          />
          <path
            className="a"
            fill="#ff7b16"
            d="M421.139,176.733h-2.762a.645.645,0,0,0-.644.645v6.9a.645.645,0,0,0,.644.645h2.762a.645.645,0,0,0,.645-.645v-6.9A.645.645,0,0,0,421.139,176.733Z"
            transform="translate(-399.784 -169.139)"
          />
        </svg>
      ),
      text: "24/7 Availability",
    },
    {
      // icon: (
      //   <svg
      //     xmlns="http://www.w3.org/2000/svg"
      //     width="30"
      //     height="30"
      //     viewBox="0 0 24.934 22"
      //   >
      //     <defs></defs>
      //     <g transform="translate(-4 -11.686)">
      //       <g transform="translate(4 11.686)">
      //         <rect
      //           className="a"
      //           fill="#ff7b16"
      //           width="5.188"
      //           height="2.964"
      //           rx="1.482"
      //           transform="translate(13.208 0)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M48.551,188H44.594a.594.594,0,0,0,0,1.187h3.958a.594.594,0,0,0,0-1.187Z"
      //           transform="translate(-42.021 -179.06)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M33.145,284.594a.594.594,0,0,0-.594-.594H28.594a.594.594,0,1,0,0,1.187h3.958A.594.594,0,0,0,33.145,284.594Z"
      //           transform="translate(-26.813 -270.311)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M63.364,332h-2.77a.594.594,0,0,0,0,1.187h2.77a.594.594,0,0,0,0-1.187Z"
      //           transform="translate(-57.23 -315.937)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M10.332,236.594A.594.594,0,0,0,9.739,236H4.594a.594.594,0,1,0,0,1.187H9.739A.594.594,0,0,0,10.332,236.594Z"
      //           transform="translate(-4 -224.686)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M198.728,142.728V136a6.728,6.728,0,1,0,6.728,6.728Z"
      //           transform="translate(-182.699 -129.633)"
      //         />
      //         <path
      //           className="a"
      //           fill="#ff7b16"
      //           d="M163.416,75.827l.637-.637a.594.594,0,1,0-.84-.84l-.663.662a8.868,8.868,0,0,0-4.458-1.945V72h-2.375v1.069a8.868,8.868,0,0,0-4.458,1.944l-.663-.662a.594.594,0,1,0-.84.84l.637.637a8.9,8.9,0,1,0,13.023,0ZM156.9,89.216a7.322,7.322,0,1,1,7.322-7.322,7.322,7.322,0,0,1-7.322,7.322Z"
      //           transform="translate(-140.876 -68.799)"
      //         />
      //       </g>
      //     </g>
      //   </svg>
      // ),
      text: "Rapid Delivery",
      id: 1,
      title: "ISO 9001:2015",
      icon: "iso9001:2015",
      className: "w-14 h-14",
    },
    {
      id: 2,
      title: "ISO 9001:2015",
      icon: "iso9001:2015",
      className: "w-14 h-14",
    },
    {
      id: 3,
      title: "ISO 9001:2015",
      icon: "iso9001:2015",
      className: "w-14 h-14",
    },
  ],
  footer_text:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
};

export const dummyDataCertified = {
  title: "Certified Translation Services You Can Be Assured Of",
  highlightWords: ["Certified"],
  highlightedColor: "yellow",
  items: [
    {
      id: 1,
      title: "Title",
      icon: "icon-name",
      className: "w-auto h-auto",
      heading: "Certified for Acceptance in Public and Private Institutions",
      maintext:
        "Our certified translations are guaranteed for acceptance in public and private institutions such as the United States Citizenship and Immigration Services (USCIS). If you need NAATI-certified translators, we can provide them. If you need certifications for the UK, we can also provide them. Our certified translations can be accepted in virtually any country. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    },
  ],
};

export const data2colgrid = {
  title: "Common Uses for Translated <br/> Birth Certificates",
  highlightWords: ["Birth Certificates"],
  highlightedColor: "yellow",
  subtitle:
    "Do you have a dream use that you aspire to when it comes to your birth certificate translation? Usually, these translations are part of larger processes of applications. Make sure you’re ready for these types of use cases:",
  maindata: [
    {
      id: 1,
      heading: "USCIS Application",
      maintext:
        "With all immigration and migration processes, it takes hard work to go with your aspiration to migrate. Tomedes takes the work out of your equation, because we’re verified to provide USCIS birth certificate translations. The United States Citizenship and Immigration Service (USCIS) requires English language documents as a condition for approving work, study and citizenship applications.",
    },
    {
      id: 2,
      heading: "University Applications",
      maintext:
        "Your dream school is waiting for you, all you have to do is aspire with Tomedes. Whether it’s for your first year of college, your study abroad, or your transfer to a university, your birth certificates need to be translated in the language of the school. Tomedes’ official birth certificate translations are certified in order to provide you with acceptable admission to your dream school abroad.",
    },
    {
      id: 3,
      heading: "Corporate Onboarding",
      maintext:
        "When you combine your corporate aspirations with Tomedes’ birth certificate translation company, your dream job awaits you. Many corporations require translated birth certificates as part of their onboarding process. When you sign up for a corporate onboarding process, all your documents should be translated into the language of the company, including your birth certificate.",
    },
    {
      id: 4,
      heading: "Government Submissions",
      maintext:
        "Submitting original documents for everything that you’re applying for at government agencies such as the DMV, the Foreign Affairs Department, and all other departments takes huge leaps to make your aspirations come to life. Translating your birth certificate is one of those leaps, making your application understandable and error-free.",
    },
  ],
};

export const reviewsData = {
  clients: [
    {
      link: "https://search.google.com/local/reviews?placeid=ChIJDZbF04sNlVQRbsAJdqiC_uw",
      src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_US.svg",
      alt: {
        default: "google reviews USA",
        en: "google reviews USA",
        fr: "avis google États-Unis",
      },
    },
    {
      link: "https://search.google.com/local/reviews?placeid=ChIJV2mjZn1LHRURjGNyBoW-qUs",
      src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_IL.svg",
      alt: {
        default: "google reviews Israel",
        en: "google reviews Israel",
        fr: "avis google Israël",
      },
    },
    {
      link: "https://clutch.co/profile/tomedes-1#reviews",
      src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/clutch.svg",
      alt: {
        default: "clutch reviews",
        en: "clutch reviews",
        fr: "critiques d'embrayage",
      },
    },
    {
      link: "https://www.goodfirms.co/company/tomedes",
      src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/goodfirms.svg",
      alt: {
        default: "goodfirms reviews",
        en: "goodfirms reviews",
        fr: "avis de goodfirms",
      },
    },
    {
      link: "https://www.trustpilot.com/review/www.tomedes.com",
      src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/trustpilot.svg",
      alt: {
        default: "trustpilot reviews",
        en: "trustpilot reviews",
        fr: "avis trustpilot",
      },
    },
    {
      link: "https://www.g2.com/products/tomedes/reviews",
      src: "https://tomedes.gumlet.io/assets/images/g2_review.svg",
      alt: {
        default: "g2 reviews",
        en: "g2 reviews",
        fr: "avis g2",
      },
    },
    {
      link: "https://www.facebook.com/Tomedes.translation/reviews",
      src: "https://tomedes.gumlet.io/assets/images/facebook_review.svg",
      alt: {
        default: "fb reviews",
        en: "fb reviews",
        fr: "avis fb",
      },
    },
    {
      link: "https://www.featuredcustomers.com/vendor/tomedes",
      src: "https://tomedes.gumlet.io/assets/images/featured_review.svg",
      alt: {
        default: "featured reviews",
        en: "featured reviews",
        fr: "critiques en vedette",
      },
    },
  ],
};

export const statsData = {
  title: {
    default: "What makes our translation services different?",
    en: "What makes our translation services different?",
    fr: "Pourquoi choisir Tomedes",
  },
  highlightWords: {
    default: ["document"],
    en: ["document"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  stats: [
    {
      name: {
        default: "Customer Satisfaction Rate",
        en: "Customer Satisfaction Rate",
        fr: "Customer Satifaction Rate",
      },
      value: {
        default: "98%",
        en: "98%",
        fr: "98%",
      },
      description: {
        default:
          "Our customers agree that Tomedes is the translation company to beat.",
        en: "Our customers agree that Tomedes is the translation company to beat.",
        fr: "Add french translation",
      },
    },
    {
      name: {
        default: "Native Translators",
        en: "Native Translators",
        fr: "Native Translators",
      },
      value: {
        default: "20k",
        en: "20k",
        fr: "20k",
      },
      description: {
        default:
          "A global pool of native translators at your service, anytime, anywhere.",
        en: "A global pool of native translators at your service, anytime, anywhere.",
        fr: "Add french translation",
      },
    },
    {
      name: {
        default: "Years Of Professional Translation Experience",
        en: "Years Of Professional Translation Experience",
        fr: "Years of Experience",
      },
      value: {
        default: "15",
        en: "15",
        fr: "15",
      },
      description: {
        default:
          "We’ve had more than a decade of experience optimizing our services.",
        en: "We’ve had more than a decade of experience optimizing our services.",
        fr: "Add french translation",
      },
    },
    {
      name: {
        default: "Languages & 950+ Language Pairs",
        en: "Languages & 950+ Language Pairs",
        fr: "Languages & 950+ Pairs",
      },
      value: {
        default: "120",
        en: "120",
        fr: "120",
      },
      description: {
        default:
          "We have the language pair you need to bring meaning to your words.",
        en: "We have the language pair you need to bring meaning to your words.",
        fr: "Add french translation",
      },
    },
  ],
};

export const contactModalData = {
  tagline: {
    default: "Language and Globalization Solutions",
    en: "Language and Globalization Solutions",
    fr: "Add french translation",
  },
  title: {
    default: "Contact Us",
    en: "Contact Us",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["Contact"],
    en: ["Contact"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Enter your details and we will get back to you within a few minutes",
    en: "Enter your details and we will get back to you within a few minutes",
    fr: "Add french translation",
  },
  nameInputLabel: {
    default: "Name*",
    en: "Name*",
    fr: "Add french translation",
  },
  emailInputLabel: {
    default: "Email Address*",
    en: "Email Address*",
    fr: "Add french translation",
  },
  messageInputLabel: {
    default: "Tell Us about your Needs",
    en: "Tell Us about your Needs",
    fr: "Add french translation",
  },
  nameInputError: {
    default: "This field is required.",
    en: "This field is required.",
    fr: "Add french Error",
  },
  emailInputError: {
    default: "This field is required.",
    en: "This field is required.",
    fr: "Add french Error",
  },
  placeholders: {
    name: "Name",
    email: "Your Email Address",
    message: "One member of our team will contact you within a few minutes",
  },
  buttonTitle: {
    default: "Submit",
    en: "Submit",
    fr: "Add french",
  },
};

export const translateFormData = {
  translateFrom: {
    title: "Translate from",
    listData: ["English", "Spanish", "Arabic", "Turkish"],
    placeholder: "Select language",
    // onSelect:onSelect,
  },
  translateTo: {
    title: "Translate to",
    // listData: ["English", "Spanish", "Arabic", "Turkish"],
    listData: [
      {
        priority: 10,
        source_language: "English",
        target_language: ["Afrikaans", "Albanian", "Arabic", "Armenian"],
        target_language2: [
          "Abkhazian",
          "Afar",
          "Afrikaans",
          "Albanian",
          "Amharic",
        ],
      },
      {
        priority: 9,
        source_language: "French",
        target_language: [
          "Arabic",
          "Chinese simplified",
          "Dutch",
          "English-UK",
        ],
        target_language2: [
          "Abkhazian",
          "Afar",
          "Afrikaans",
          "Albanian",
          "Amharic",
        ],
      },
    ],
    placeholder: "Select language",
    // onSelect:onSelect,
  },
  Wordcount: {
    title: "Wordcount / Upload your file",
    listData: ["English", "Spanish", "Arabic", "Turkish"],
    placeholder: "Number of words",
    // onSelect:onSelect,
  },
  Service: {
    title: "Service",
    listData: ["Document", "Text translation"],
    placeholder: "Document / Text translation",
    // onSelect:onSelect,
  },
  Subject: {
    title: "Subject",
    listData: ["General Business", "Spanish", "Arabic", "Turkish"],
    placeholder: "General Business",
    // onSelect:onSelect,
  },
  AboutUs: {
    title: "How did you hear about us?",
    listData: ["Social Media", "Spanish", "Arabic", "Turkish"],
    placeholder: "Social Media",
    // onSelect:onSelect,
  },
};

export const contactUsData = {
  title: {
    default: "Contact Us 24/7 </br> We will respond within 15 minutes",
    en: "Contact Us 24/7 </br> We will respond within 15 minutes",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["Contact Us 24/7"],
    en: ["Contact Us 24/7"],
    fr: ["Add french translation"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "The client has always been at the heart of Tomedes’ corporate philosophy, which is why we have cost-effective translation prices. We guarantee 15-minute response to quote and project inquiries, 24/7 support, and a full-year accuracy warranty on each project.",
    en: "The client has always been at the heart of Tomedes’ corporate philosophy, which is why we have cost-effective translation prices. We guarantee 15-minute response to quote and project inquiries, 24/7 support, and a full-year accuracy warranty on each project.",
    fr: "Add french translation",
  },
  inputPlaceholder: {
    default: "Enter email address here",
    en: "Enter email address here",
    fr: "Add french translation",
  },
  cta: {
    text: {
      default: "Submit",
      en: "Submit",
      fr: "Add french translation",
    },
    href: "/contactus.php",
  },
};

export const languesContactUsData = {
  title: {
    default: "Add default translation",
    en: "Add English translation",
    fr: "Besoin d’une langue spécifique ? Contactez-nous pour d’autres combinaisons",
  },
  highlightWords: {
    default: ["Add"],
    en: ["Add"],
    fr: ["Besoin"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "Add default translation",
    en: "Add English translation",
    fr: "Parlez-nous de votre projet et obtenez un retour en 30 minutes",
  },

  cta: {
    text: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "CONTACTEZ-NOUS",
    },
    href: "/contactus.php",
  },
};

export const agencesContactUsData = {
  title: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Des questions sur nos services de traduction et de localisation ? Un besoin spécifique ?",
  },
  highlightWords: {
    default: ["English"],
    en: ["English"],
    fr: ["questions"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Complétez le formulaire ci-dessous, nous vous répondrons d’ici 30 minutes !",
  },
  cta: {
    text: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "CONTACTEZ-NOUS",
    },
    href: "/contactus.php",
  },
};

export const serviceDataTraduction = {
  title: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Nos traducteurs professionnels dans plus de 120 Langues",
  },
  highlightWords: ["Traduction"],
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    fr: "Sur 5 continents. Plus de 120 langues et 950 combinaisons disponibles. Nos traducteurs natifs, bilingues, certifiés et experts en linguistique sont prêts à travailler sur tous vos projets. Qualité et excellence des services",
  },
  clients: [
    {
      id: 1,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Anglais",
      },
    },
    {
      id: 2,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Portugais",
      },
    },
    {
      id: 3,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Arabe",
      },
    },
    {
      id: 4,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Japonais",
      },
    },
    {
      id: 5,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Allemand",
      },
    },
    {
      id: 6,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Italien",
      },
    },
    {
      id: 7,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Néerlandais",
      },
    },
    {
      id: 8,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Turc",
      },
    },
    {
      id: 9,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Espangnol",
      },
    },
    {
      id: 10,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Chinois",
      },
    },
    {
      id: 12,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Russe",
      },
    },
    // {
    //   id: 13,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
    // {
    //   id: 14,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
    // {
    //   id: 15,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
    // {
    //   id: 16,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
    // {
    //   id: 17,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
    // {
    //   id: 18,
    //   title: {
    //     default: "Add english translation",
    //     en: "Add english translation",
    //     fr: "Add translation"
    //   }
    // },
  ],
};

export const fullWidthImageData = {
  image:
    "https://livetomedes.s3.amazonaws.com/ServicePageBannerImage/1649247043screenshot-xd.adobe.com-2022.04.06-13_18_55.png",
};

export const globalCtaData = {
  heading:
    "Do you need a quote for a translation project? We will get back to you quickly!",
  text: "TRANSLATE NOW",
  href: "/quote",
};

export const ratingData = {
  achievedstars: "4.9",

  totalstars: {
    default: "out of 5",
    en: "out of 5",
    fr: "Add french translation",
  },
  Ratinghead: {
    default: "Aggregate Rating",
    en: "Aggregate Rating",
    fr: "Nos clients en parlent le mieux",
  },
  ratingsummary: {
    default: " (Out of 1798 Verified Reviews Online)",
    en: " (Out of 1798 Verified Reviews Online)",
    fr: " (add french translation)",
  },
  achievedstarsfigure: "5",
  ratingcontent: {
    description: {
      default:
        "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
      en: "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
      fr: "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
    },
    highlightWords: {
      default: ["1,798 online reviews."],
      en: ["1,798 online reviews."],
      fr: ["french"],
    },
    highlightedColor: "blue font-bold",
  },
  cta: {
    text: {
      default: "SEE ALL REVIEWS",
      en: "SEE ALL REVIEWS",
      fr: "Add french translation",
    },
    href: "/reviews.php",
  },
  testimonialhead: {
    default: "See what our clients have to say about us:",
    en: "See what our clients have to say about us:",
    fr: "Add french translation",
  },
  testimonialdata: [
    {
      content: {
        default: "Speedy return & reasonably priced",
        en: "Speedy return & reasonably priced",
        fr: "Add french translation",
      },
      name: {
        default: "Katherine Lindsay",
        en: "Katherine Lindsay",
        fr: "Add french translation",
      },
      id: 1,
      title: {
        default: "BBC",
        en: "BBC",
        fr: "Add french translation",
      },
      icon: "bbc",
      className: "w-16 h-5",
      href: "https://www.trustpilot.com/users/60db02325f811c001128d575",
    },
    {
      content: {
        default:
          "Tomedes has been nothing but kind, knowledgeable and efficient!",
        en: "Tomedes has been nothing but kind, knowledgeable and efficient!",
        fr: "Add french translation",
      },
      name: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      id: 2,
      title: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      icon: "ashrena",
      className: "w-9 h-9",
      href: "https://www.trustpilot.com/users/60945782a8fc63001b6f847b",
    },
    {
      content: {
        default: "Tomedes is a high quality translation provider",
        en: "Tomedes is a high quality translation provider",
        fr: "Add french translation",
      },
      name: {
        default: "Jorge Castro",
        en: "Jorge Castro",
        fr: "Add french translation",
      },
      id: 3,
      title: {
        default: "CODE",
        en: "CODE",
        fr: "Add french translation",
      },
      icon: "code",
      className: "w-9 h-9",
      href: "https://www.trustpilot.com/reviews/61b11ffd2b49257fe29a48fa",
    },
  ],
};

export const contactData = {
  title: {
    default: "Contact",
    en: "Contact",
    fr: "CONTACT",
  },
  description: {
    default:
      "Birth Certificate Translation is a way for you to broaden horizons to the rest of the world. Why? Because translating your birth certificate will grant you access to your aspirations abroad, in whatever institution you’re applying for. Certified birth certification translation and USCIS birth certificate translation are your gateway to your future.",
    en: "Birth Certificate Translation is a way for you to broaden horizons to the rest of the world. Why? Because translating your birth certificate will grant you access to your aspirations abroad, in whatever institution you’re applying for. Certified birth certification translation and USCIS birth certificate translation are your gateway to your future.",
    fr: "Add french translation",
  },
  addresses: [
    {
      title: {
        default: "ROYAUME-UNI",
        en: "ROYAUME-UNI",
        fr: "ROYAUME-UNI",
      },
      address: {
        default:
          "International House, 12 Constance Street, London, E16 2DQ Call : +44 (0)16 1509 6140",
        en: "International House, 12 Constance Street, London, E16 2DQ Call : +44 (0)16 1509 6140",
        fr: "International House, 12 Constance Street, London, E16 2DQ Call: +44 (0)16 1509 6140",
      },
    },
    {
      title: {
        default: "ÉTATS UNIS",
        en: "ÉTATS UNIS",
        fr: "ÉTATS UNIS",
      },
      address: {
        default:
          "Tomedes Ltd - USA 9450 SW Gemini Dr #34540, Beaverton, OR 97008-7105 Call : +1 985 239 0142",
        en: "Tomedes Ltd - USA 9450 SW Gemini Dr #34540, Beaverton, OR 97008-7105 Call : +1 985 239 0142",
        fr: "Tomedes Ltd - USA 9450 SW Gemini Dr #34540, Beaverton, OR 97008-7105 Call : +1 985 239 0142",
      },
    },
  ],

  enquiryForm: {
    title: {
      default: "Translate your birth certificate now",
      en: "Translate your birth certificate now",
      fr: "Add french translation",
    },
    highlightWords: {
      default: ["Translate"],
      en: ["Translate"],
      fr: ["french"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default: "Get in touch with us in real-time, any time.",
      en: "Get in touch with us in real-time, any time.",
      fr: "Add french translation",
    },
  },

  inputLabelAndPlaceholder: {
    firstName: {
      default: "First Name",
      en: "First Name",
      fr: "Prénom",
    },

    firstNamePlaceholder: {
      default: "First Name",
      en: "First Name",
      fr: "Votre prénom",
    },

    lastName: {
      default: "Last Name",
      en: "Last Name",
      fr: "Nom",
    },

    lastNamePlaceholder: {
      default: "Last Name",
      en: "Last Name",
      fr: "Votre nom de famille",
    },
    emailAddress: {
      default: "Email Address",
      en: "Email Address",
      fr: "Adresse email",
    },

    emailAddressPlaceholder: {
      default: "Email Address",
      en: "Email Address",
      fr: "Votre adresse email",
    },

    tellUs: {
      default: "Tell Us About Your Needs",
      en: "Tell Us About Your Needs",
      fr: "Message",
    },

    tellUsPlaceholder: {
      default: "Tell us more about your needs",
      en: "Tell us more about your needs",
      fr: "Un membre de notre équipe vous contactera dans quelques minutes",
    },

    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "Envoyer",
    },

    fieldRequired: {
      default: "This field is required",
      en: "This field is required",
      fr: "Add french translation",
    },
  },
};

export const OrderStepsdata = {
  TextData: {
    default: {
      step1: { title: "Step 1: Project Details", isActive: true },
      step2: { title: "Step 2: Purchase Options", isActive: true },
      step3: { title: "Step 3: Place Order", isActive: false },
    },

    en: {
      step1: { title: "Step 1: Project Details", isActive: true },
      step2: { title: "Step 2: Purchase Options", isActive: true },
      step3: { title: "Step 3: Place Order", isActive: false },
    },

    fr: {
      step1: { title: "Add french translation", isActive: true },
      step2: { title: "Add french translation", isActive: true },
      step3: { title: "Add french translation", isActive: false },
    },
  },
};

export const OrderStepsdataFinal = {
  step1: { title: "Step 1: Project Details", isActive: true },
  step2: { title: "Step 2: Purchase Options", isActive: true },
  step3: { title: "Step 3: Place Order", isActive: true },
};

export const whyChooseUsLightdata = {
  title: {
    default: "Pourquoi choisir Tomedes",
    en: "Add English translation",
    fr: "Pourquoi choisir Tomedes",
  },
  // highlightWords: ["Why"],
  // highlightedColor: "yellow",
  services: [
    {
      id: 1,
      title: {
        default: "24/7 Customer Service",
        en: "24/7 Customer Service",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#ff7b16"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#ff7b16"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Personal project manager",
            en: "Personal project manager",
            fr: "Add french translation",
          },
        },
        {
          text: {
            default: "Support and assistance via email, phone and chat",
            en: "Support and assistance via email, phone and chat",
            fr: "Add french translation",
          },
        },
      ],
    },
    {
      id: 2,
      title: {
        default: "1-year guarantee",
        en: "1-year guarantee",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.021"
          height="46.752"
          viewBox="0 0 31.021 46.752"
        >
          <defs></defs>
          <g transform="translate(-85.732)">
            <path
              fill="#ff7b16"
              className="a"
              d="M139.388,306.35l-3.52-6.1-.853-.311v19.234h2.912l6.721-7.116v-7.624Z"
              transform="translate(-44.761 -272.423)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M112.362,9.33l-1-5.645h-5.732L101.243,0,96.851,3.685H91.119l-1,5.645-4.391,3.685L88.6,17.979l-1,5.645,5.387,1.961,2.866,4.964,5.387-1.961,5.387,1.961,2.866-4.964,5.387-1.961-1-5.645,2.866-4.964ZM98.743,19.956l-3.592-4.19,2.09-1.791,1.913,2.232,6.308-4.731,1.651,2.2Z"
              transform="translate(0)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M278.754,300.1l-3.52,6.1-5.219-1.9v7.6l6.748,7.123h2.886V299.779Z"
              transform="translate(-167.376 -272.275)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Post-completion project support",
            en: "Post-completion project support",
            fr: "Add french translation",
          },
        },
        {
          text: {
            default: "Comprehensive quality assurance",
            en: "Comprehensive quality assurance",
            fr: "Add frenh translation",
          },
        },
      ],
    },
    {
      id: 3,
      title: {
        default: "Fast Delivery",
        en: "Fast Delivery",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.57"
          height="37.57"
          viewBox="0 0 37.57 37.57"
        >
          <defs></defs>
          <path
            fill="#ff7b16"
            className="a"
            d="M22.16,3.375A18.785,18.785,0,1,0,40.945,22.16,18.782,18.782,0,0,0,22.16,3.375Zm1.264,20.411A1.268,1.268,0,0,1,22.16,25.05H13.49a1.264,1.264,0,1,1,0-2.529H20.9V10.6a1.264,1.264,0,1,1,2.529,0Z"
            transform="translate(-3.375 -3.375)"
          />
        </svg>
      ),
      content: [
        {
          text: {
            default: "Availability for urgent orders",
            en: "Availability for urgent orders",
            fr: "Add french translation",
          },
        },
        {
          text: {
            default:
              "Working around the clock to provide the best, fastest service",
            en: "Working around the clock to provide the best, fastest service",
            fr: "Add french translation",
          },
        },
      ],
    },
    {
      id: 4,
      title: {
        default: "75,000 Business Customers",
        en: "75,000 Business Customers",
        fr: "Add french translation",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="41.115"
          height="34.263"
          viewBox="0 0 41.115 34.263"
        >
          <defs></defs>
          <g transform="translate(0 -2)">
            <path
              fill="#3a7aff"
              className="a"
              d="M19.992,9.709A1.714,1.714,0,0,1,18.279,8V5.426H11.426V8A1.713,1.713,0,1,1,8,8V5.426A3.43,3.43,0,0,1,11.426,2h6.853a3.43,3.43,0,0,1,3.426,3.426V8A1.714,1.714,0,0,1,19.992,9.709Z"
              transform="translate(5.705 0)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M21.774,18.061a3.529,3.529,0,0,1-1.216.206,3.754,3.754,0,0,1-1.319-.24L0,11.62V24.691A4.708,4.708,0,0,0,4.711,29.4H36.4a4.708,4.708,0,0,0,4.711-4.711V11.62Z"
              transform="translate(0 6.86)"
            />
            <path
              fill="#ff7b16"
              className="a"
              d="M41.115,9.711v3.923L20.969,20.35a1.268,1.268,0,0,1-.822,0L0,13.634V9.711A4.708,4.708,0,0,1,4.711,5H36.4A4.708,4.708,0,0,1,41.115,9.711Z"
              transform="translate(0 2.139)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Fortune 500 companies trust Tomedes translation agency",
            en: "Fortune 500 companies trust Tomedes translation agency",
            fr: "Add french translation",
          },
        },
        {
          text: {
            default: "Official and selected Google and Android partner",
            en: "Official and selected Google and Android partner",
            fr: "Add french translation",
          },
        },
      ],
    },
  ],
};

export const whyChoseUsData = {
  title: {
    default: "Pourquoi choisir Tomedes",
    en: "Add English translation",
    fr: "Pourquoi choisir Tomedes",
  },
  highlightWords: {
    default: ["Pourquoi"],
    en: ["English"],
    fr: ["Pourquoi"],
  },
  highlightedColor: "regal-blue",
  services: [
    {
      id: 1,
      title: {
        default: "24/7 Customer Service",
        en: "24/7 Customer Service",
        fr: "Service client 24h/24 - 7j/7",
      },

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#3a7aff"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#3a7aff"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Personal project manager",
            en: "Personal project manager",
            fr: "Un chargé de projet dédié",
          },
        },
        {
          text: {
            default: "Support and assistance via email, phone and chat",
            en: "Support and assistance via email, phone and chat",
            fr: "Une assistance par e-mail, téléphone et chat",
          },
        },
      ],
    },
    {
      id: 2,
      title: {
        default: "1-year guarantee",
        en: "1-year guarantee",
        fr: "1 an de garantie",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.021"
          height="46.752"
          viewBox="0 0 31.021 46.752"
        >
          <defs></defs>
          <g transform="translate(-85.732)">
            <path
              fill="#3a7aff"
              className="a"
              d="M139.388,306.35l-3.52-6.1-.853-.311v19.234h2.912l6.721-7.116v-7.624Z"
              transform="translate(-44.761 -272.423)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M112.362,9.33l-1-5.645h-5.732L101.243,0,96.851,3.685H91.119l-1,5.645-4.391,3.685L88.6,17.979l-1,5.645,5.387,1.961,2.866,4.964,5.387-1.961,5.387,1.961,2.866-4.964,5.387-1.961-1-5.645,2.866-4.964ZM98.743,19.956l-3.592-4.19,2.09-1.791,1.913,2.232,6.308-4.731,1.651,2.2Z"
              transform="translate(0)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M278.754,300.1l-3.52,6.1-5.219-1.9v7.6l6.748,7.123h2.886V299.779Z"
              transform="translate(-167.376 -272.275)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Post-completion project support",
            en: "Post-completion project support",
            fr: "Accompagnement post-traduction",
          },
        },
        {
          text: {
            default: "Comprehensive quality assurance",
            en: "Comprehensive quality assurance",
            fr: "Contrôle de qualité suivi",
          },
        },
      ],
    },
    {
      id: 3,
      title: {
        default: "Fast Delivery",
        en: "Fast Delivery",
        fr: "Meilleurs délais",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.57"
          height="37.57"
          viewBox="0 0 37.57 37.57"
        >
          <defs></defs>
          <path
            fill="#3a7aff"
            className="a"
            d="M22.16,3.375A18.785,18.785,0,1,0,40.945,22.16,18.782,18.782,0,0,0,22.16,3.375Zm1.264,20.411A1.268,1.268,0,0,1,22.16,25.05H13.49a1.264,1.264,0,1,1,0-2.529H20.9V10.6a1.264,1.264,0,1,1,2.529,0Z"
            transform="translate(-3.375 -3.375)"
          />
        </svg>
      ),
      content: [
        {
          text: {
            default: "Availability for urgent orders",
            en: "Availability for urgent orders",
            fr: "Traductions urgentes disponibles",
          },
        },
        {
          text: {
            default:
              "Working around the clock to provide the best, fastest service",
            en: "Working around the clock to provide the best, fastest service",
            fr: "Tomedes oeuvre 24h/24 pour vous satisfaire",
          },
        },
      ],
    },
    {
      id: 4,
      title: {
        default: "75,000 Business Customers",
        en: "75,000 Business Customers",
        fr: "Plus de 95 000 clients convaincus",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="41.115"
          height="34.263"
          viewBox="0 0 41.115 34.263"
        >
          <defs></defs>
          <g transform="translate(0 -2)">
            <path
              fill="#3a7aff"
              className="a"
              d="M19.992,9.709A1.714,1.714,0,0,1,18.279,8V5.426H11.426V8A1.713,1.713,0,1,1,8,8V5.426A3.43,3.43,0,0,1,11.426,2h6.853a3.43,3.43,0,0,1,3.426,3.426V8A1.714,1.714,0,0,1,19.992,9.709Z"
              transform="translate(5.705 0)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M21.774,18.061a3.529,3.529,0,0,1-1.216.206,3.754,3.754,0,0,1-1.319-.24L0,11.62V24.691A4.708,4.708,0,0,0,4.711,29.4H36.4a4.708,4.708,0,0,0,4.711-4.711V11.62Z"
              transform="translate(0 6.86)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M41.115,9.711v3.923L20.969,20.35a1.268,1.268,0,0,1-.822,0L0,13.634V9.711A4.708,4.708,0,0,1,4.711,5H36.4A4.708,4.708,0,0,1,41.115,9.711Z"
              transform="translate(0 2.139)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Fortune 500 companies trust Tomedes translation agency",
            en: "Fortune 500 companies trust Tomedes translation agency",
            fr: "De grands noms du CAC 40",
          },
        },
        {
          text: {
            default: "Official and selected Google and Android partner",
            en: "Official and selected Google and Android partner",
            fr: "Des structures aussi bien locales qu’internationales",
          },
        },
      ],
    },
  ],
};

export const languesWhyChoseUsData = {
  title: {
    default: "Pourquoi choisir Tomedes",
    en: "Add English translation",
    fr: "Pourquoi choisir Tomedes",
  },
  highlightWords: {
    default: ["Pourquoi"],
    en: ["English"],
    fr: ["Pourquoi"],
  },
  highlightedColor: "regal-blue",
  services: [
    {
      id: 1,
      title: {
        default: "24/7 Customer Service",
        en: "24/7 Customer Service",
        fr: "Service client 24h/24 - 7j/7",
      },

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.303"
          height="48.654"
          viewBox="0 0 43.303 48.654"
        >
          <defs></defs>
          <g transform="translate(-25.274)">
            <g transform="translate(25.274)">
              <path
                fill="#3a7aff"
                className="a"
                d="M60.658,282.093a10.581,10.581,0,0,1-8.565,4.37H47.159a3.943,3.943,0,0,1-3.706-2.6,12.514,12.514,0,0,1-1.993-.788,13.422,13.422,0,0,1-3.722-2.755A15.893,15.893,0,0,0,25.274,295.84v.993a2.472,2.472,0,0,0,2.472,2.472H66.1a2.472,2.472,0,0,0,2.472-2.472v-.993A15.882,15.882,0,0,0,60.658,282.093Z"
                transform="translate(-25.274 -250.652)"
              />
              <path
                fill="#3a7aff"
                className="a"
                d="M94.423,24.575a2.814,2.814,0,0,0,2.467-1.458l.038.1.011.031a10.987,10.987,0,0,0,6.2,6.523,3.938,3.938,0,0,1,3.337-1.845h4.934a2.762,2.762,0,0,0,1.352-.363,5.577,5.577,0,0,0,1.594-1.841,14.229,14.229,0,0,0,1.234-2.608,2.829,2.829,0,0,0,.778.9v1.21a4.964,4.964,0,0,1-4.958,4.958h-4.934a1.689,1.689,0,1,0,0,3.378h4.934a8.346,8.346,0,0,0,8.336-8.336v-1.21a2.811,2.811,0,0,0,1.126-2.252V14.714a2.811,2.811,0,0,0-1.169-2.283,13.5,13.5,0,0,0-26.923,0,2.811,2.811,0,0,0-1.169,2.283V21.76A2.816,2.816,0,0,0,94.423,24.575Zm11.815-21.2A10.14,10.14,0,0,1,116.315,12.5a2.825,2.825,0,0,0-.791.978c-1.594-4.158-5.152-7.053-9.285-7.053-4.223,0-7.724,2.995-9.279,7.037l-.006.017a2.825,2.825,0,0,0-.791-.978A10.141,10.141,0,0,1,106.238,3.378Z"
                transform="translate(-84.587)"
              />
            </g>
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Personal project manager",
            en: "Personal project manager",
            fr: "Un chargé de projet dédié",
          },
        },
        {
          text: {
            default: "Support and assistance via email, phone and chat",
            en: "Support and assistance via email, phone and chat",
            fr: "Une assistance par e-mail, téléphone et chat",
          },
        },
      ],
    },
    {
      id: 2,
      title: {
        default: "1-year guarantee",
        en: "1-year guarantee",
        fr: "1 an de garantie",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.021"
          height="46.752"
          viewBox="0 0 31.021 46.752"
        >
          <defs></defs>
          <g transform="translate(-85.732)">
            <path
              fill="#3a7aff"
              className="a"
              d="M139.388,306.35l-3.52-6.1-.853-.311v19.234h2.912l6.721-7.116v-7.624Z"
              transform="translate(-44.761 -272.423)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M112.362,9.33l-1-5.645h-5.732L101.243,0,96.851,3.685H91.119l-1,5.645-4.391,3.685L88.6,17.979l-1,5.645,5.387,1.961,2.866,4.964,5.387-1.961,5.387,1.961,2.866-4.964,5.387-1.961-1-5.645,2.866-4.964ZM98.743,19.956l-3.592-4.19,2.09-1.791,1.913,2.232,6.308-4.731,1.651,2.2Z"
              transform="translate(0)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M278.754,300.1l-3.52,6.1-5.219-1.9v7.6l6.748,7.123h2.886V299.779Z"
              transform="translate(-167.376 -272.275)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Post-completion project support",
            en: "Post-completion project support",
            fr: "Accompagnement post-traduction",
          },
        },
        {
          text: {
            default: "Comprehensive quality assurance",
            en: "Comprehensive quality assurance",
            fr: "Contrôle de qualité suivi",
          },
        },
      ],
    },
    {
      id: 3,
      title: {
        default: "Fast Delivery",
        en: "Fast Delivery",
        fr: "Meilleurs délais",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.57"
          height="37.57"
          viewBox="0 0 37.57 37.57"
        >
          <defs></defs>
          <path
            fill="#3a7aff"
            className="a"
            d="M22.16,3.375A18.785,18.785,0,1,0,40.945,22.16,18.782,18.782,0,0,0,22.16,3.375Zm1.264,20.411A1.268,1.268,0,0,1,22.16,25.05H13.49a1.264,1.264,0,1,1,0-2.529H20.9V10.6a1.264,1.264,0,1,1,2.529,0Z"
            transform="translate(-3.375 -3.375)"
          />
        </svg>
      ),
      content: [
        {
          text: {
            default: "Availability for urgent orders",
            en: "Availability for urgent orders",
            fr: "Traductions urgentes disponibles",
          },
        },
        {
          text: {
            default:
              "Working around the clock to provide the best, fastest service",
            en: "Working around the clock to provide the best, fastest service",
            fr: "Tomedes oeuvre 24h/24 pour vous satisfaire",
          },
        },
      ],
    },
    {
      id: 4,
      title: {
        default: "75,000 Business Customers",
        en: "75,000 Business Customers",
        fr: "Plus de 95 000 clients convaincus",
      },
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="41.115"
          height="34.263"
          viewBox="0 0 41.115 34.263"
        >
          <defs></defs>
          <g transform="translate(0 -2)">
            <path
              fill="#3a7aff"
              className="a"
              d="M19.992,9.709A1.714,1.714,0,0,1,18.279,8V5.426H11.426V8A1.713,1.713,0,1,1,8,8V5.426A3.43,3.43,0,0,1,11.426,2h6.853a3.43,3.43,0,0,1,3.426,3.426V8A1.714,1.714,0,0,1,19.992,9.709Z"
              transform="translate(5.705 0)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M21.774,18.061a3.529,3.529,0,0,1-1.216.206,3.754,3.754,0,0,1-1.319-.24L0,11.62V24.691A4.708,4.708,0,0,0,4.711,29.4H36.4a4.708,4.708,0,0,0,4.711-4.711V11.62Z"
              transform="translate(0 6.86)"
            />
            <path
              fill="#3a7aff"
              className="a"
              d="M41.115,9.711v3.923L20.969,20.35a1.268,1.268,0,0,1-.822,0L0,13.634V9.711A4.708,4.708,0,0,1,4.711,5H36.4A4.708,4.708,0,0,1,41.115,9.711Z"
              transform="translate(0 2.139)"
            />
          </g>
        </svg>
      ),
      content: [
        {
          text: {
            default: "Fortune 500 companies trust Tomedes translation agency",
            en: "Fortune 500 companies trust Tomedes translation agency",
            fr: "De grands noms du CAC 40",
          },
        },
        {
          text: {
            default: "Official and selected Google and Android partner",
            en: "Official and selected Google and Android partner",
            fr: "Des structures aussi bien locales qu’internationales",
          },
        },
      ],
    },
  ],
};

export const btcData = {
  title: "Business Translation Center",
  posts: [
    {
      title: "Tomedes Announces the Merge of SEO and Website Localization",
      created: "21/02/2022",
      breadcrumb: { root: "CATEGORY", current: "Translation news" },
      image:
        "https://tomedes.gumlet.io/CustomerLogo/1645514772pexels-photo-270637.jpeg",
      short_description:
        "Tomedes has announced their move to offer multilingual SEO services for translated content.",
      link: "#",
      read_time: "2 mins read",
    },
    {
      title:
        "Overcoming Language Barriers. The Central Role of Translation and Localization for Global Business",
      created: "16/09/2021",
      breadcrumb: { root: "CATEGORY", current: "Languages" },
      image:
        "https://tomedes.gumlet.io/CustomerLogo/world-2747353_1280_16-9-21_09-06-24.png",
      short_description:
        "Language barriers have a broad and profound impact on international trade, content, media, marketing, management, and business operations.",
      link: "#",
      read_time: "6 mins read",
    },
  ],
  categories: [
    {
      id: 1,
      title: "Translation news",
      link: "#",
    },
    {
      id: 2,
      title: "Translation services",
      link: "#",
    },
    {
      id: 3,
      title: "Business translation",
      link: "#",
    },
    {
      id: 4,
      title: "Finance",
      link: "#",
    },
    {
      id: 5,
      title: "Marketing",
      link: "#",
    },
    {
      id: 6,
      title: "Freelancing",
      link: "#",
    },
    {
      id: 7,
      title: "Coronavirus",
      link: "#",
    },
    {
      id: 8,
      title: "Languages",
      link: "#",
    },
  ],
  newsletter: {
    title: "STAY INFORMED",
    highlightWords: ["STAY"],
    highlightedColor: "yellow",
    description: "Subscribe to receive all the latest updates from Tomedes.",
    cta: "KEEP ME UPDATED",
  },
  social: {
    fblink: "https://www.facebook.com/Tomedes.translation/",
    fbicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="25"
        viewBox="0 0 10.712 20"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          fill="#00173a"
          d="M11.619,11.25l.555-3.62H8.7V5.282a1.81,1.81,0,0,1,2.041-1.955h1.579V.245A19.255,19.255,0,0,0,9.518,0c-2.86,0-4.73,1.734-4.73,4.872V7.63H1.609v3.62H4.789V20H8.7V11.25Z"
          transform="translate(-1.609)"
        />
      </svg>
    ),
    twitterlink: "https://twitter.com/Tomedes",
    twittericon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="21"
        viewBox="0 0 20 16.244"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          fill="#00173a"
          d="M17.944,7.429c.013.178.013.355.013.533A11.582,11.582,0,0,1,6.294,19.624,11.583,11.583,0,0,1,0,17.784a8.48,8.48,0,0,0,.99.051,8.209,8.209,0,0,0,5.089-1.751,4.106,4.106,0,0,1-3.833-2.843,5.169,5.169,0,0,0,.774.063,4.335,4.335,0,0,0,1.079-.14A4.1,4.1,0,0,1,.812,9.142V9.091a4.128,4.128,0,0,0,1.853.52A4.105,4.105,0,0,1,1.4,4.129,11.651,11.651,0,0,0,9.848,8.419a4.627,4.627,0,0,1-.1-.939,4.1,4.1,0,0,1,7.094-2.8,8.07,8.07,0,0,0,2.6-.99,4.088,4.088,0,0,1-1.8,2.259A8.217,8.217,0,0,0,20,5.31a8.811,8.811,0,0,1-2.056,2.119Z"
          transform="translate(0 -3.381)"
        />
      </svg>
    ),
    linkedinlink: "https://www.linkedin.com/company/tomedes.com",
    linkedinicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 19.476 19.476"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          fill="#00173a"
          d="M4.36,19.476H.322v-13H4.36ZM2.338,4.7A2.35,2.35,0,1,1,4.677,2.339,2.358,2.358,0,0,1,2.338,4.7ZM19.472,19.476H15.443v-6.33c0-1.509-.03-3.443-2.1-3.443-2.1,0-2.421,1.639-2.421,3.334v6.438H6.889v-13h3.873V8.247h.057a4.243,4.243,0,0,1,3.82-2.1c4.086,0,4.838,2.691,4.838,6.186v7.143Z"
          transform="translate(0 0)"
        />
      </svg>
    ),
    youtubelink: "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    youtubeicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="20"
        viewBox="0 0 20 15.003"
      >
        <defs></defs>
        <path
          fill="#00173a"
          className="a"
          d="M19.87,7.813a3.037,3.037,0,0,0-2.891-3.172c-2.164-.1-4.372-.141-6.626-.141h-.7c-2.25,0-4.462.039-6.626.141A3.044,3.044,0,0,0,.137,7.821C.039,9.212,0,10.6,0,11.993s.039,2.782.133,4.176A3.047,3.047,0,0,0,3.02,19.353c2.274.105,4.606.152,6.978.148s4.7-.039,6.978-.148a3.048,3.048,0,0,0,2.891-3.184c.094-1.395.137-2.786.133-4.18S19.963,9.208,19.87,7.813ZM8.087,15.826V8.149l5.665,3.836Z"
          transform="translate(0 -4.5)"
        />
      </svg>
    ),
  },
};

export const busunessDetailsData = {
  title: {
    default: "Business Center Details",
    en: "Business Center Details",
    fr: "Blog du traducteur",
  },
  post: {
    title:
      "Les prévisions économiques mondiales favorables créent un environnement idéal pour la traduction professionnelle.",
    created: "21/02/2022",
    breadcrumb: { root: "CATEGORY", current: "Translation news" },
    image:
      "https://skins.tomedes.com/CustomerLogo/Webp_15-7-18_19-00-44.net-resizeimage%20(2)",
    description:
      "<p>D&rsquo;apr&egrave;s la Banque mondiale, la croissance &eacute;conomique internationale va passer &agrave; 3,1&nbsp;% en 2018 apr&egrave;s avoir atteint un taux beaucoup plus &eacute;lev&eacute; que pr&eacute;vu en 2017. Un tel contexte financier apporte de meilleures perspectives &agrave; de nombreuses entreprises, et un certain nombre d&rsquo;entre elles n&rsquo;&eacute;prouve plus aucune crainte &agrave; s&rsquo;attaquer au march&eacute; international. Il y a donc fort &agrave; parier que le secteur de la traduction b&eacute;n&eacute;ficiera de ce contexte et qu&rsquo;elle jouera un r&ocirc;le d&eacute;terminent dans le d&eacute;veloppement d&rsquo;une &eacute;conomie mondiale plus prosp&egrave;re.</p><p>Selon les chiffres du &laquo;&thinsp;Bureau of Labor Statistics&thinsp;&raquo; am&eacute;ricain, le secteur de la traduction et de l&rsquo;interpr&eacute;tation conna&icirc;tra une croissance de 18&nbsp;% entre 2016 et 2026.</p><p>&Eacute;tant donn&eacute; que l&rsquo;&eacute;conomie mondiale se porte bien, les entreprises s&rsquo;appuient de plus en plus sur les derni&egrave;res &eacute;volutions technologiques pour &eacute;tendre leurs activit&eacute;s sur de nouveaux march&eacute;s. Elles disposent d&eacute;sormais d&rsquo;outils de communication instantan&eacute;s, de r&eacute;seaux de livraisons internationales en 48 heures et de l&rsquo;&eacute;norme potentiel de marketing des r&eacute;seaux sociaux.</p><p>Toutes les conditions sont donc r&eacute;unies et les professionnels de la traduction sont l&agrave; pour briser la barri&egrave;re de la langue. Qu&rsquo;elles aient besoin de traduire des lettres commerciales, des documents administratifs, des pr&eacute;sentations marketing ou des documents juridiques, les entreprises qui souhaitent &eacute;tendre leurs activit&eacute;s au niveau international coop&egrave;rent de plus en plus avec les professionnels du secteur de la traduction, car elles sont bien conscientes que la traduction automatique ferait &eacute;chouer leur entreprise.</p><p>Le grand d&eacute;fi du secteur de la traduction sera donc de faire preuve d&rsquo;un maximum de flexibilit&eacute; pour s&rsquo;adapter aux besoins d&rsquo;une client&egrave;le toujours plus nombreuse et vari&eacute;e, sans jamais faire aucun compromis sur la qualit&eacute;. Nous souhaitons apporter notre pierre &agrave; l&rsquo;&eacute;difice en vous proposant &laquo;&thinsp;Tomedes Summarizer&thinsp;&raquo;. Cet outil extrait instantan&eacute;ment le texte des sites Web pour gagner du temps et r&eacute;pondre plus rapidement aux besoins de vos clients.</p><p>Les &eacute;v&eacute;nements politiques des deux derni&egrave;res ann&eacute;es ont montr&eacute; qu&rsquo;il est difficile de pr&eacute;dire l&rsquo;avenir de la sc&egrave;ne internationale, mais les entreprises ont d&eacute;sormais la possibilit&eacute; de saisir de nouvelles opportunit&eacute;s, et les professionnels de la traduction peuvent les aider &agrave;</p>",
    link: "#",
  },

  tomedesAdvice: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Tomedes vous conseille",
  },

  postComments: {
    text: {
      default: "Post your comments",
      en: "Post your comments",
      fr: "Add french translation",
    },
    highlightedText: {
      default: ["french"],
      en: ["french"],
      fr: ["french"],
    },
    highlightedColor: "yellow",
  },

  comments: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Commentaires",
  },

  categoryHeading: {
    default: "CATEGORIES",
    en: "Add french translation",
    fr: "CATÉGORIES",
  },

  categories: [
    {
      id: 1,
      title: "Translation news",
      link: "#",
    },
    {
      id: 2,
      title: "Translation services",
      link: "#",
    },
    {
      id: 3,
      title: "Business translation",
      link: "#",
    },
    {
      id: 4,
      title: "Finance",
      link: "#",
    },
    {
      id: 5,
      title: "Marketing",
      link: "#",
    },
    {
      id: 6,
      title: "Freelancing",
      link: "#",
    },
    {
      id: 7,
      title: "Coronavirus",
      link: "#",
    },
    {
      id: 8,
      title: "Languages",
      link: "#",
    },
  ],

  newsletter: {
    title: {
      default: "STAY INFORMED",
      en: "STAY INFORMED",
      fr: "RESTEZ INFORMÉ",
    },
    highlightWords: {
      default: ["STAY"],
      en: ["STAY"],
      fr: ["RESTEZ"],
    },
    highlightedColor: "yellow",
    description: {
      default: "Subscribe to receive all the latest updates from Tomedes.",
      en: "Subscribe to receive all the latest updates from Tomedes.",
      fr: "Inscrivez-vous pour recevoir toutes les dernières mises à jour de Tomedes.",
    },
    inputPlaceholder: {
      default: "Enter your business email",
      en: "Enter your business email",
      fr: "Saisissez votre e-mail",
    },
    cta: {
      default: "KEEP ME UPDATED",
      en: "KEEP ME UPDATED",
      fr: "TENEZ MOI AU COURANT",
    },
    errorMsg: {
      default: "Please enter email id",
      en: " Please enter email id",
      fr: "Veuillez saisir l'identifiant e-mail",
    },
  },

  followUs: {
    default: "FOLLOW US",
    en: "FOLLOW US",
    fr: "SUIVEZ-NOUS",
  },
  social: {
    fblink: "https://www.facebook.com/Tomedes.translation/",
    fbicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="25"
        viewBox="0 0 10.712 20"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M11.619,11.25l.555-3.62H8.7V5.282a1.81,1.81,0,0,1,2.041-1.955h1.579V.245A19.255,19.255,0,0,0,9.518,0c-2.86,0-4.73,1.734-4.73,4.872V7.63H1.609v3.62H4.789V20H8.7V11.25Z"
          transform="translate(-1.609)"
        />
      </svg>
    ),
    twitterlink: "https://twitter.com/Tomedes",
    twittericon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="21"
        viewBox="0 0 20 16.244"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M17.944,7.429c.013.178.013.355.013.533A11.582,11.582,0,0,1,6.294,19.624,11.583,11.583,0,0,1,0,17.784a8.48,8.48,0,0,0,.99.051,8.209,8.209,0,0,0,5.089-1.751,4.106,4.106,0,0,1-3.833-2.843,5.169,5.169,0,0,0,.774.063,4.335,4.335,0,0,0,1.079-.14A4.1,4.1,0,0,1,.812,9.142V9.091a4.128,4.128,0,0,0,1.853.52A4.105,4.105,0,0,1,1.4,4.129,11.651,11.651,0,0,0,9.848,8.419a4.627,4.627,0,0,1-.1-.939,4.1,4.1,0,0,1,7.094-2.8,8.07,8.07,0,0,0,2.6-.99,4.088,4.088,0,0,1-1.8,2.259A8.217,8.217,0,0,0,20,5.31a8.811,8.811,0,0,1-2.056,2.119Z"
          transform="translate(0 -3.381)"
        />
      </svg>
    ),
    linkedinlink: "https://www.linkedin.com/company/tomedes.com",
    linkedinicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 19.476 19.476"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M4.36,19.476H.322v-13H4.36ZM2.338,4.7A2.35,2.35,0,1,1,4.677,2.339,2.358,2.358,0,0,1,2.338,4.7ZM19.472,19.476H15.443v-6.33c0-1.509-.03-3.443-2.1-3.443-2.1,0-2.421,1.639-2.421,3.334v6.438H6.889v-13h3.873V8.247h.057a4.243,4.243,0,0,1,3.82-2.1c4.086,0,4.838,2.691,4.838,6.186v7.143Z"
          transform="translate(0 0)"
        />
      </svg>
    ),
    youtubelink: "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    youtubeicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="20"
        viewBox="0 0 20 15.003"
      >
        <defs></defs>
        <path
          // fill="#00173a"
          className="a"
          d="M19.87,7.813a3.037,3.037,0,0,0-2.891-3.172c-2.164-.1-4.372-.141-6.626-.141h-.7c-2.25,0-4.462.039-6.626.141A3.044,3.044,0,0,0,.137,7.821C.039,9.212,0,10.6,0,11.993s.039,2.782.133,4.176A3.047,3.047,0,0,0,3.02,19.353c2.274.105,4.606.152,6.978.148s4.7-.039,6.978-.148a3.048,3.048,0,0,0,2.891-3.184c.094-1.395.137-2.786.133-4.18S19.963,9.208,19.87,7.813ZM8.087,15.826V8.149l5.665,3.836Z"
          transform="translate(0 -4.5)"
        />
      </svg>
    ),
  },
};

export const tbData = {
  title: {
    default: "Translators Blog",
    en: "Translators Blog",
    fr: "Blog du traducteur",
  },

  categoryText: {
    default: "CATEGORY /",
    en: "CATEGORY /",
    fr: "CATÉGORIE /",
  },

  readMoreText: {
    default: "Read More",
    en: "Read More",
    fr: "En savoir plus",
    hreflink: "/",
  },

  posts: [
    {
      title: {
        default: "Tomedes Announces the Merge of SEO and Website Localization",
        en: "Tomedes Announces the Merge of SEO and Website Localization",
        fr: "Add french translation",
      },
      image:
        "https://tomedes.gumlet.io/CustomerLogo/1645514772pexels-photo-270637.jpeg",
      created: "21/02/2022",
      breadcrumb: {
        root: {
          default: "CATEGORY",
          en: "CATEGORY",
          fr: "Add french translation",
        },
        current: {
          default: "Translation news",
          en: "Translation news",
          fr: "Add french translation",
        },
      },
      short_description: {
        default:
          "Tomedes has announced their move to offer multilingual SEO services for translated content.",
        en: "Tomedes has announced their move to offer multilingual SEO services for translated content.",
        fr: "Add french translation",
      },
      link: "#",
      read_time: {
        default: "2 mins read",
        en: "2 mins read",
        fr: "2 add french translation",
      },
    },
    {
      title: {
        default:
          "Overcoming Language Barriers. The Central Role of Translation and Localization for Global Business",
        en: "Overcoming Language Barriers. The Central Role of Translation and Localization for Global Business",
        fr: "Add french translation",
      },

      image:
        "https://tomedes.gumlet.io/CustomerLogo/world-2747353_1280_16-9-21_09-06-24.png",
      created: "16/09/2021",
      breadcrumb: {
        root: {
          default: "CATEGORY",
          en: "CATEGORY",
          fr: "Add french translation",
        },
        current: {
          default: "Languages",
          en: "Languages",
          fr: "Add french translation",
        },
      },
      short_description: {
        default:
          "Language barriers have a broad and profound impact on international trade, content, media, marketing, management, and business operations.",
        en: "Language barriers have a broad and profound impact on international trade, content, media, marketing, management, and business operations.",
        fr: "Add french translation",
      },
      link: "#",
      read_time: {
        default: "6 mins read",
        en: "6 mins read",
        fr: "6 add french translation",
      },
    },
  ],

  categoriesText: {
    default: "CATEGORIES",
    en: "CATEGORIES",
    fr: "CATÉGORIES",
  },

  categories: [
    {
      id: 1,
      title: {
        default: "Translation news",
        en: "Translation news",
        fr: "Langues",
      },
      link: "#",
    },
    {
      id: 2,
      title: {
        default: "Translation services",
        en: "Translation services",
        fr: "Services de traduction",
      },
      link: "#",
    },
    {
      id: 3,
      title: {
        default: "Business translation",
        en: "Business translation",
        fr: "Traduction commerciale",
      },
      link: "#",
    },
    {
      id: 4,
      title: {
        default: "Finance",
        en: "Finance",
        fr: "Finance",
      },
      link: "#",
    },
    {
      id: 5,
      title: {
        default: "Marketing",
        en: "Marketing",
        fr: "Marketing",
      },
      link: "#",
    },
    {
      id: 6,
      title: {
        default: "Freelancing",
        en: "Freelancing",
        fr: "Indépendante",
      },
      link: "#",
    },
    {
      id: 7,
      title: {
        default: "Coronavirus",
        en: "Coronavirus",
        fr: "Coronavirus",
      },
      link: "#",
    },
    {
      id: 8,
      title: {
        default: "Languages",
        en: "Languages",
        fr: "Langues",
      },
      link: "#",
    },
  ],
  newsletter: {
    title: {
      default: "STAY INFORMED",
      en: "STAY INFORMED",
      fr: "RESTEZ INFORMÉ",
    },
    highlightWords: {
      default: ["STAY"],
      en: ["STAY"],
      fr: ["RESTEZ"],
    },
    highlightedColor: "white lg:text-yellow",
    description: {
      default: "Subscribe to receive all the latest updates from Tomedes.",
      en: "Subscribe to receive all the latest updates from Tomedes.",
      fr: "Inscrivez-vous pour recevoir toutes les dernières mises à jour de Tomedes.",
    },

    errMsg: {
      default: "Please enter email id",
      en: "Please enter email id",
      fr: "Add french translation",
    },
    emailPlaceholder: {
      default: "Enter your business email",
      en: "Enter your business email",
      fr: "Saisissez votre e-mail",
    },

    cta: {
      default: "KEEP ME UPDATED",
      en: "KEEP ME UPDATED",
      fr: "TENEZ MOI AU COURANT",
    },
  },
  social: {
    title: {
      default: "FOLLOW US",
      en: "FOLLOW US",
      fr: "SUIVEZ-NOUS",
    },

    fblink: "https://www.facebook.com/Tomedes.translation/",
    fbicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="25"
        viewBox="0 0 10.712 20"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M11.619,11.25l.555-3.62H8.7V5.282a1.81,1.81,0,0,1,2.041-1.955h1.579V.245A19.255,19.255,0,0,0,9.518,0c-2.86,0-4.73,1.734-4.73,4.872V7.63H1.609v3.62H4.789V20H8.7V11.25Z"
          transform="translate(-1.609)"
        />
      </svg>
    ),
    twitterlink: "https://twitter.com/Tomedes",
    twittericon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="21"
        viewBox="0 0 20 16.244"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M17.944,7.429c.013.178.013.355.013.533A11.582,11.582,0,0,1,6.294,19.624,11.583,11.583,0,0,1,0,17.784a8.48,8.48,0,0,0,.99.051,8.209,8.209,0,0,0,5.089-1.751,4.106,4.106,0,0,1-3.833-2.843,5.169,5.169,0,0,0,.774.063,4.335,4.335,0,0,0,1.079-.14A4.1,4.1,0,0,1,.812,9.142V9.091a4.128,4.128,0,0,0,1.853.52A4.105,4.105,0,0,1,1.4,4.129,11.651,11.651,0,0,0,9.848,8.419a4.627,4.627,0,0,1-.1-.939,4.1,4.1,0,0,1,7.094-2.8,8.07,8.07,0,0,0,2.6-.99,4.088,4.088,0,0,1-1.8,2.259A8.217,8.217,0,0,0,20,5.31a8.811,8.811,0,0,1-2.056,2.119Z"
          transform="translate(0 -3.381)"
        />
      </svg>
    ),
    linkedinlink: "https://www.linkedin.com/company/tomedes.com",
    linkedinicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 19.476 19.476"
      >
        <defs>{/* <style>.a{fill="#c5c5c5"}</style> */}</defs>
        <path
          className="a"
          // fill="#00173a"
          d="M4.36,19.476H.322v-13H4.36ZM2.338,4.7A2.35,2.35,0,1,1,4.677,2.339,2.358,2.358,0,0,1,2.338,4.7ZM19.472,19.476H15.443v-6.33c0-1.509-.03-3.443-2.1-3.443-2.1,0-2.421,1.639-2.421,3.334v6.438H6.889v-13h3.873V8.247h.057a4.243,4.243,0,0,1,3.82-2.1c4.086,0,4.838,2.691,4.838,6.186v7.143Z"
          transform="translate(0 0)"
        />
      </svg>
    ),
    youtubelink: "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    youtubeicon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="20"
        viewBox="0 0 20 15.003"
      >
        <defs></defs>
        <path
          // fill="#00173a"
          className="a"
          d="M19.87,7.813a3.037,3.037,0,0,0-2.891-3.172c-2.164-.1-4.372-.141-6.626-.141h-.7c-2.25,0-4.462.039-6.626.141A3.044,3.044,0,0,0,.137,7.821C.039,9.212,0,10.6,0,11.993s.039,2.782.133,4.176A3.047,3.047,0,0,0,3.02,19.353c2.274.105,4.606.152,6.978.148s4.7-.039,6.978-.148a3.048,3.048,0,0,0,2.891-3.184c.094-1.395.137-2.786.133-4.18S19.963,9.208,19.87,7.813ZM8.087,15.826V8.149l5.665,3.836Z"
          transform="translate(0 -4.5)"
        />
      </svg>
    ),
  },
};

export const TranslationBannerData = {
  title: {
    default: "Mexican Divorce Certificate Translation | Tomedes",
    en: "Mexican Divorce Certificate Translation | Tomedes",
    fr: "L’agence de traduction qui vous ouvre les portes du monde",
  },

  description: {
    default:
      "There are many translation jobs that require careful, discreet handling, and the translation of divorce certificates is right up there with them. Divorces don’t tend to be happy occasions, so it’s important to work with the client in a supportive and understanding way.",
    en: "There are many translation jobs that require careful, discreet handling, and the translation of divorce certificates is right up there with them. Divorces don’t tend to be happy occasions, so it’s important to work with the client in a supportive and understanding way.",
    fr: "Tomedes est la première agence de traduction entièrement digitale dédiée aux professionnels de France et aux francophones. Bénéficiez d’un service sur-mesure, optimisez votre visibilité auprès du monde entier avec Tomedes",
  },

  bgurl: require("../../assets/images/amazon.png"),

  seal: [
    {
      icon: "availability",
      text: {
        default: "Available Online 24/7",
        en: "Available Online 24/7",
        fr: "Add french translation",
      },
    },
    {
      icon: "guarantee",
      text: {
        default: "1-Year Guarantee",
        en: "1-Year Guarantee",
        fr: "Add french translation",
      },
    },
    {
      icon: "business-customers",
      text: {
        default: "95,000 Business Customers",
        en: "95,000 Business Customers",
        fr: "Add french translation",
      },
    },
  ],
  button: {
    translateNow: {
      default: "Translate Now",
      en: "Translate Now",
      fr: "Devis gratuit",
    },
    contactUs: {
      default: "Contact us",
      en: "Contact us",
      fr: "Contactez-nous",
    },
  },
};

//mark

export const LocationContentData = {
  authoricon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.614"
      height="22"
      viewBox="0 0 16.614 22"
    >
      <defs></defs>
      <g transform="translate(-0.002 0.001)">
        <path
          fill="#ff7b16"
          className="a"
          d="M15.475,367.509a2.646,2.646,0,0,1-3.038-1.106,2.652,2.652,0,0,1-1.593-.617q-.085-.072-.164-.15l-1.437,3.007a.653.653,0,0,0,.733.918l2.881-.653,1.3,2.652a.653.653,0,0,0,.586.365h0a.653.653,0,0,0,.585-.371l1.671-3.5a2.652,2.652,0,0,1-1.529-.55Zm0,0"
          transform="translate(-8.783 -349.926)"
        />
        <path
          fill="#ff7b16"
          className="a"
          d="M201.538,365.786a2.652,2.652,0,0,1-1.593.617,2.646,2.646,0,0,1-3.038,1.106,2.652,2.652,0,0,1-1.529.55l1.67,3.5a.653.653,0,0,0,.586.371h0a.653.653,0,0,0,.586-.365l1.3-2.652,2.881.653a.653.653,0,0,0,.733-.918l-1.437-3.007Q201.624,365.715,201.538,365.786Zm0,0"
          transform="translate(-186.982 -349.926)"
        />
        <path
          fill="#ff7b16"
          className="a"
          d="M16.331,8.012a1.342,1.342,0,0,0-.346-1.965.652.652,0,0,1-.275-.755,1.342,1.342,0,0,0-1-1.728A.653.653,0,0,1,14.2,2.95a1.342,1.342,0,0,0-1.528-1.282.653.653,0,0,1-.7-.4A1.341,1.341,0,0,0,10.1.583a.653.653,0,0,1-.791-.14,1.342,1.342,0,0,0-1.995,0,.653.653,0,0,1-.791.14,1.341,1.341,0,0,0-1.875.682.652.652,0,0,1-.7.4A1.342,1.342,0,0,0,2.421,2.95a.653.653,0,0,1-.516.615,1.342,1.342,0,0,0-1,1.727.653.653,0,0,1-.275.755A1.342,1.342,0,0,0,.286,8.012a.653.653,0,0,1,0,.8A1.342,1.342,0,0,0,.633,10.78a.653.653,0,0,1,.275.755,1.342,1.342,0,0,0,1,1.728.653.653,0,0,1,.516.615A1.342,1.342,0,0,0,3.95,15.161a.653.653,0,0,1,.7.4,1.342,1.342,0,0,0,1.875.682.653.653,0,0,1,.791.139,1.342,1.342,0,0,0,1.995,0,.653.653,0,0,1,.791-.139,1.342,1.342,0,0,0,1.875-.682.653.653,0,0,1,.7-.4A1.342,1.342,0,0,0,14.2,13.878a.653.653,0,0,1,.516-.615,1.342,1.342,0,0,0,1-1.728.653.653,0,0,1,.275-.755,1.341,1.341,0,0,0,.346-1.965.653.653,0,0,1,0-.8ZM8.309,14.133a5.719,5.719,0,1,1,5.719-5.719,5.726,5.726,0,0,1-5.719,5.719Zm0,0"
          transform="translate(0)"
        />
        <path
          fill="#ff7b16"
          className="a"
          d="M95.015,93.105a4.414,4.414,0,1,0,4.414,4.414A4.419,4.419,0,0,0,95.015,93.105Zm-2.757,3.6a.653.653,0,0,1,.923,0l1.3,1.3,2.367-2.367a.653.653,0,0,1,.923.923L94.944,99.4a.653.653,0,0,1-.923,0l-1.762-1.762A.653.653,0,0,1,92.258,96.71Zm0,0"
          transform="translate(-86.707 -89.105)"
        />
      </g>
    </svg>
  ),
  authorname: "OFER TIROSH",
  data: [
    {
      title: "Mexican Divorce Certificate Translation | Tomedes",
      content:
        "There are many translation jobs that require careful, discreet handling, and the translation of divorce certificates is right up there with them. Divorces don’t tend to be happy occasions, so it’s important to work with the client in a supportive and understanding way. Over the years, Tomedes has handled many divorce certificate translation jobs. Our most recent was for a client who needed a divorce translation from Spanish to English.",
    },
    {
      title: "Divorce Certificate from a Client in Tijuana, Mexico",
      content:
        "Our client needed a translation of his Mexican divorce certificate. He spoke Spanish fluently and English pretty well, so started off by looking for a Mexican divorce certificate translation template online. However, after a spot of research, he realised that this wasn’t the kind of job to undertake without professional support. As such, he got in touch with the Tomedes team and we were delighted to be able to help. The client asked us for a Tijuana divorce certificate sample translation as evidence of our experience in this area. We didn’t have a Tijuana one to show him but were able to share our Mexican divorce certificate translation template, which turned out to be precisely the reassurance that the client needed. Our divorce certificate translation from Spanish to English template delivered the professional finish that the client needed. With access to in-house, multilingual desktop publishing skills, Tomedes has a range of documents available for inspection by anyone wanting to review a divorce certificate translation sample before committing to proceed with their translation. For the translation of a divorce certificate, a template works particularly well, as it delivers not just the language skills that are required, but also the typesetting element that makes the translated certificate look similar to the original.",
    },
    {
      title: "Certified Divorce Certificate Translation – Quality Guaranteed",
      content:
        "Once he had inspected our divorce certificate translation sample, the client was happy to proceed. He needed his divorce decree in Spanish translated into US English and certified. We were happy to oblige! Certified translation is a means of proving the authenticity of a translated document. A certificate of translation is issued that asserts that the translated document is a true and accurate copy of the original, just in another language. The quality of the translation was a key driver behind the client choosing Tomedes in the first place. He had read up on our one-year translation guarantee and our policy of always using native speakers of the target language, as well as proofreading each of our translations. It was our strong commitment to both translation quality and customer service that initially prompted him to get in touch.",
    },
    {
      title: "Spanish to English Translation",
      content:
        "For the client’s divorce certificate translation from Spanish to English, our template perfectly fitted the bill. As English tends to use slightly fewer words than Spanish to say the same thing, our template used a slightly larger font than that in the client’s original document, to achieve the same look overall. We deliver this kind of divorce certificate format in multiple languages – in this case, for the translation of Mexican Spanish to US English. This is an oft-demanded language pairing due to the steady trade that takes place between Mexico and the US. The two countries’ proximity to one another means that plenty of personal customers want translations too, from birth and marriage certificates to, in this case, divorce certificates. Mexico is home to more Spanish speakers than any other country. Including both first and second language speakers, 98.5% of the population speaks Spanish – a total of more than 110 million people. That’s more than double the next highest number of Spanish speakers, at just over 50 million in the US. Spain itself only ranks third in terms of total speaker numbers, at 46 million. Mexican Spanish has its own particular linguistic quirks, just as US English does. That’s why using a Spanish to English translation service that is familiar with both of the regional languages is so important.",
    },
    {
      title: "Translating a Divorce Certificate",
      content:
        "If you need a divorce certificate translation, there are certain key elements to look out for as part of the language conversion process. We’ve outlined them here for your convenience.",
    },
    {
      title: "Project Management",
      content:
        "It’s important that your translation is viewed in context, as a project. Which organisation has requested the translation and why? How quickly is the translation needed? Does it need to be certified? A decent agency will assess all this and more, to ensure that it provides the perfect translation at the right time.",
    },
    {
      title:
        "Getting Hold of a Spanish to English Divorce Certificate Translator",
      content:
        "It’s important to use a translator with relevant experience. In this instance, for example, that didn’t mean using a language professional who specialised only in translating Spanish to English, but also who could demonstrate extensive experience of certificate translation.",
    },
    {
      title: "Certifying the Translation",
      content:
        "There are all sorts of reasons why you might need a translation to be certified. If you do, include this in the initial discussion with your chosen translation agency. Bear in mind that a ‘certified translation’ means different things in different countries. Your translation agency will need to comply with the definition of this in the target country – that is, the locale for which the translation is intended.",
    },
    {
      title: "Delivery",
      content:
        "The translation agency that you choose also needs to have a track record of delivering on time. It’s pointless having an accurate, beautifully presented translation if it’s delivered too late for you to use it! Be clear from the outset what your timescale is, so that the translation company can work around your requirements.",
    },
    {
      title: "Get a Free Quote for Your Divorce Translation",
      content:
        "If you’re wondering about the cost of divorce certification translation, why not use our translation quote to obtain a free, no obligation price? We work with over 100 languages, so wherever you’re based and whatever you need, we’re confident that we can help. Call, email or live chat with us to find out more! Our friendly, multilingual customer service team is here to help 24/7.",
    },
  ],
  Blogmainhead: "About this Case Study",
  BlogData: [
    {
      heading: "Service/s provided:",
      list: ["Certificate Translation", " Birth Certificate Translation"],
    },
    {
      heading: "Translation Language/s:",
      list: ["Certificate Translation", " Birth Certificate Translation"],
    },
  ],
};
export const CaseStudyData = {
  data: {
    heading: "Related Case Studies",
    list: [
      {
        id: 1,
        img: caseStudyImg,
        title:
          "Certified Translation of a Marriage Certificate from Spanish to English",
      },
      {
        id: 2,
        img: caseStudyImg,
        title:
          "The Spanish to English Marriage Certificate Translation Process",
      },
      {
        id: 3,
        img: caseStudyImg,
        title: "Certified Vietnamese Birth Certificate Translation",
      },
    ],
  },
};

export const FlagsData = {
  componentCss: "md:px-0 pt-16 pb-10",
  heading: {
    text: {
      default: "Nos langues populaires en France",
      en: "Add English translation",
      fr: "Nos langues populaires en France",
    },
    css: "text-4xl text-slate font-medium font-primary mb-10",
  },

  flagsGridCss:
    "grid place-content-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-2.5 sm:gap-x-6",
  flagBoxCss:
    "w-44 350px:w-60 p-3 border border-grey text-white hover:bg-blue hover:border-blue",
  flagCss:
    "flex items-center justify-start text-slate hover:text-yellow font-semibold text-primary",
  flagImageCss: "pr-2.5 w-14",
  spanCss: "text-sm",

  flags: [
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/us.svg",
      country: {
        default: "Anglais",
        en: "Add English translation",
        fr: "Anglais",
      },
      altTag: {
        default: "Anglais Drapeau",
        en: "Add English translation",
        fr: "Anglais Drapeau",
      },
      linkAddress: "traduction-anglais",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/dutch.svg",
      country: {
        default: "Néerlandais",
        en: "Add English translation",
        fr: "Néerlandais",
      },
      altTag: {
        default: "Néerlandais Drapeau",
        en: "Add English translation",
        fr: "Néerlandais Drapeau",
      },
      linkAddress: "traduction-neerlandais",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/french.svg",
      country: {
        default: "Français",
        en: "Add English translation",
        fr: "Français",
      },
      altTag: {
        default: "Français Drapeau",
        en: "Add English translation",
        fr: "Français Drapeau",
      },
      linkAddress: "",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/italy.svg",
      country: {
        default: "Italien",
        en: "Add English translation",
        fr: "Italien",
      },
      altTag: {
        default: "Italien Drapeau",
        en: "Add English translation",
        fr: "Italien Drapeau",
      },
      linkAddress: "traduction-italien",
    },

    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/spanish.svg",
      country: {
        default: "Espagnol",
        en: "Add English translation",
        fr: "Espagnol",
      },
      altTag: {
        default: "Espagnol Drapeau",
        en: "Add English translation",
        fr: "Espagnol Drapeau",
      },
      linkAddress: "traduction-espagnol",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/chinese.svg",
      country: {
        default: "Chinois",
        en: "Add English translation",
        fr: "Chinois",
      },
      altTag: {
        default: "Chinois Drapeau",
        en: "Add English translation",
        fr: "Chinois Drapeau",
      },
      linkAddress: "traduction-chinois",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/russian.svg",
      country: {
        default: "Russe",
        en: "Add English translation",
        fr: "Russe",
      },
      altTag: {
        default: "Russe Drapeau",
        en: "Add English translation",
        fr: "Russe Drapeau",
      },
      linkAddress: "",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/german.svg",
      country: {
        default: "Allemand",
        en: "Add English translation",
        fr: "Allemand",
      },
      altTag: {
        default: "Allemand Drapeau",
        en: "Add English translation",
        fr: "Allemand Drapeau",
      },
      linkAddress: "traduction-allemand",
    },

    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/japanese.svg",
      country: {
        default: "Japonais",
        en: "Add English translation",
        fr: "Japonais",
      },
      altTag: {
        default: "Japonais Drapeau",
        en: "Add English translation",
        fr: "Japonais Drapeau",
      },
      linkAddress: "traduction-japonais",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/turkish.svg",
      country: {
        default: "Turc",
        en: "Add English translation",
        fr: "Turc",
      },
      altTag: {
        default: "Turc Drapeau",
        en: "Add English translation",
        fr: "Turc Drapeau",
      },
      linkAddress: "",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/portugese.svg",
      country: {
        default: "Portugais",
        en: "Add English translation",
        fr: "Portugais",
      },
      altTag: {
        default: "Portugais Drapeau",
        en: "Add English translation",
        fr: "Portugais Drapeau",
      },
      linkAddress: "traduction-portugais",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/poland/Mask_Group456_polish.svg",
      country: {
        default: "Polonais",
        en: "Add English translation",
        fr: "Polonais",
      },
      altTag: {
        default: "Polonais Drapeau",
        en: "Add English translation",
        fr: "Polonais Drapeau",
      },
      linkAddress: "",
    },

    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/bulgaria.svg",
      country: {
        default: "Bulgare",
        en: "Add English translation",
        fr: "Bulgare",
      },
      altTag: {
        default: "Bulgare Drapeau",
        en: "Add English translation",
        fr: "Bulgare Drapeau",
      },
      linkAddress: "",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/korean.svg",
      country: {
        default: "Coréen",
        en: "Add English translation",
        fr: "Coréen",
      },
      altTag: {
        default: "Coréen Drapeau",
        en: "Add English translation",
        fr: "Coréen Drapeau",
      },
      linkAddress: "traduction-coreen",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/vietnamese.svg",
      country: {
        default: "Vietnamien",
        en: "Add English translation",
        fr: "Vietnamien",
      },
      altTag: {
        default: "Vietnamien Drapeau",
        en: "Add English translation",
        fr: "Vietnamien Drapeau",
      },
      linkAddress: "",
    },
    {
      flagSrc:
        "https://skins.tomedes.com/frontend/images/trans-img/flags/thai.svg",
      country: {
        default: "Thaïlandais",
        en: "Add English translation",
        fr: "Thaïlandais",
      },
      altTag: {
        default: "Thaïlandais Drapeau",
        en: "Add English translation",
        fr: "Thaïlandais Drapeau",
      },
      linkAddress: "",
    },
  ],
};

export const languesHeadingParaColData1 = {
  css: "flex 0px:flex-col lg:flex-row py-7 0ps:px-4 xs:px-8 gap-y-10 lg:px-24 bg-blue",
  headingContainerCss: "basis-1/2 pr-4 -mt-2",
  heading: {
    text1: {
      default: "Add default translation",
      en: "Add English translation",
      fr: "Plus de 120 langues traduites,",
    },
    highlightedText: {
      default: ["default"],
      en: ["English"],
      fr: ["Plus"],
    },
    highlightedColor: "yellow",
    text2: {
      default: "Add default translation",
      en: "Add English translation",
      fr: "près de 950 combinaisons possibles",
    },
    headingContainerCss: "flex flex-col",
    css: "text-primary text-slate text-4xl leading-snug font-medium",
  },
  paraContainerCss: "basis-1/2 lg:pl-4",
  para1: {
    text: {
      default: "Add default translation",
      en: "Add English translation",
      fr: "Des langues les plus rares aux plus communes, confiez vos projets de traduction à une équipe de linguistes renommés. Adaptez votre message à la culture du pays destinataire de vos campagnes et boostez votre présence à l’international.",
    },
    css: "text-mediumGrey text-base font-opensans mb-12",
  },
  para2: {
    text: {
      default: "Add default translation",
      en: "Add English translation",
      fr: "Nous serions fiers de vous compter parmi plus de 95 000 clients satisfaits.",
    },
    css: "text-mediumGrey text-base font-opensans mb-11",
  },

  // button: {
  //   text: {
  //     default: "EN SAVOIR PLUS",
  //     en: "Add English translation",
  //     fr: "EN SAVOIR PLUS",
  //   },
  //   css: "bg-regal-blue text-white px-8 py-2.5 font-opensans, font-bold rounded-3xl text-sm hover:bg-turquoiseBlue61",
  //   link: "/",
  // },
};

export const languesHeadingParaColData2 = {
  css: "flex 0px:flex-col lg:flex-row py-7 xs:px-0 sm:px-12 md:px-24 lg:px-0",
  headingContainerCss: "basis-1/2 pr-4",
  heading: {
    text1: {
      default: "Un réseau de",
      en: "Add English translation",
      fr: "Un réseau de",
    },
    highlightedText: {
      default: ["Un"],
      en: ["English"],
      fr: ["Un"],
    },
    text2: {
      default: "traducteurs natifs",
      en: "Add English translation",
      fr: "traducteurs natifs",
    },
    headingContainerCss: "flex flex-col",
    css: "text-primary text-slate text-4xl leading-snug font-medium",
  },
  paraContainerCss: "basis-1/2 lg:pl-4 pt-4 lg:pt-0",
  para1: {
    text: {
      default:
        "Parce que nous sommes orientés vers la perfection et le résultat, nous recrutons nos collaborateurs en fonction d’un cahier des charges rigoureux.",
      en: "Add English translation",
      fr: "Parce que nous sommes orientés vers la perfection et le résultat, nous recrutons nos collaborateurs en fonction d’un cahier des charges rigoureux.",
    },
    css: "text-mediumGrey text-base font-opensans mb-12",
  },
  para2: {
    text: {
      default:
        "Tous nos traducteurs, linguistes et interprètes sont spécialistes de leur langue natale. Vous êtes certain de bénéficier de la meilleure qualité de traduction, dans les meilleurs délais.",
      en: "Add English translation",
      fr: "Tous nos traducteurs, linguistes et interprètes sont spécialistes de leur langue natale. Vous êtes certain de bénéficier de la meilleure qualité de traduction, dans les meilleurs délais.",
    },
    css: "text-mediumGrey text-base font-opensans mb-11",
  },

  button: {
    text: {
      default: "EN SAVOIR PLUS",
      en: "Add English translation",
      fr: "EN SAVOIR PLUS",
    },
    css: "bg-regal-blue text-white px-8 py-2.5 font-opensans, font-bold rounded-3xl text-sm hover:bg-turquoiseBlue61",
    link: "/contactus.php",
  },
};

export const languesHeadingParaRowData = {
  css: "pt-12 pb-16 px-18 lg:px-28 xl:px-44",
  headingContainerCss: "",
  heading: {
    text1: {
      default: "Plus de 50 spécialités",
      en: "Add English translation",
      fr: "Plus de 50 spécialités",
    },
    highlightedText: {
      default: ["Plus"],
      en: ["English"],
      fr: ["Plus"],
    },
    highlightedColor: "yellow",
    headingContainerCss: "",
    css: "text-center text-primary text-slate text-4xl font-medium mb-3",
  },
  paraContainerCss: "",
  para1: {
    text: {
      default:
        "Bien plus que des traducteurs, nos collaborateurs-linguistes sont également spécialisés dans leur domaine d’études. Pour vos besoins en traduction assermentée, traduction médicale ou encore technique, vous avez l’assurance que vos documents sont entre les mains expertes.",
      en: "Add English translation",
      fr: "Bien plus que des traducteurs, nos collaborateurs-linguistes sont également spécialisés dans leur domaine d’études. Pour vos besoins en traduction assermentée, traduction médicale ou encore technique, vous avez l’assurance que vos documents sont entre les mains expertes.",
    },
    css: "text-mediumGrey text-base font-opensans text-center",
  },
};

/* This component is replaced by ContactUs */
export const FooterwithFormData = {
  heading: "GET IN TOUCH",
  location: [
    {
      title: "UNITED STATES",
      address:
        "Tomedes Ltd - USA 9450 SW Gemini Dr #34540, Beaverton, OR 97008-7105 <br/> Call : +1 985 239 0142",
    },
    {
      title: "MIDDLE EAST",
      address:
        "Gruzenberg St 14 Tel Aviv, Israel 6581117 <br/> Call: +972 (0)72 220 0700",
    },
    {
      title: "EUROPE",
      address:
        "International House, 12 Constance Street, London, E16 2DQ <br/> Call: +44 (0)16 1509 6140",
    },
  ],

  inputLabelAndPlaceholder: {
    firstName: "First Name",
    firstNamePlaceholder: "First Name",
    lastName: "Last Name",
    lastNamePlaceholder: "Last Name",
    emailAddress: "Email Address",
    emailAddressPlaceholder: "Email Address",
    tellUs: "Tell Us About Your Needs",
    tellUsPlaceholder: "Tell us more about your needs",
    submitButtonText: "SUBMIT",
    fieldRequired: "This field is required",
  },
};

export const bannerWithContentData = {
  title: {
    default: "Legal Interpreting in 120 Languages and 950+ Language Pairs",
    en: "Legal Interpreting in 120 Languages and 950+ Language Pairs",
    fr: "Add french translation",
  },

  highlightWords: {
    default: ["Legal"],
    en: ["Legal"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "For businesses and individuals, legal interpreting is available at Tomedes in 120 languages and 950+ language pairs. All our interpreting services are backed with a 1-year guarantee, ensuring language services that suit your needs. Our legal interpreters have the world-wide qualification of two or more languages, as well as certifiable legal knowledge.",
    en: "For businesses and individuals, legal interpreting is available at Tomedes in 120 languages and 950+ language pairs. All our interpreting services are backed with a 1-year guarantee, ensuring language services that suit your needs. Our legal interpreters have the world-wide qualification of two or more languages, as well as certifiable legal knowledge.",
    fr: "Add french translation",
  },
  cta: {
    text: {
      default: "SEE OUR SUPPORTED LANGUAGES",
      en: "SEE OUR SUPPORTED LANGUAGES",
      fr: "Add french translation",
    },
    link: "/",
  },
};

// export const FooterwithFormData = {
//   inputLabelAndPlaceholder: {
//     firstName: 'First Name',
//     firstNamePlaceholder: 'Enter First Name',
//     lastName: 'Last Name',
//     lastNamePlaceholder: 'Last Name Placeholder',
//     emailAddress: 'Email',
//     emailAddressPlaceholder: 'Enter Email Id',
//     tellUs: 'Tell Us About Your Query',
//     tellUsPlaceholder: 'Enter your query here',
//     submitButtonText: 'SUBMIT',
//     fieldRequired: 'This field is required'
//   },
//   heading: "GET IN TOUCH",
//   location: [
//     {
//       title: "UNITED STATES",
//       address:
//         "Tomedes Ltd - USA 9450 SW Gemini Dr #34540, Beaverton, OR 97008-7105 <br/> Call : +1 985 239 0142",
//     },
//     {
//       title: "MIDDLE EAST",
//       address:
//         "Gruzenberg St 14 Tel Aviv, Israel 6581117 <br/> Call: +972 (0)72 220 0700",
//     },
//     {
//       title: "EUROPE",
//       address:
//         "International House, 12 Constance Street, London, E16 2DQ <br/> Call: +44 (0)16 1509 6140",
//     },
//   ],
// };

export const TrustedClientData = {
  heading: "Trusted by 95,000+ Satisfied Clients Worldwide",
  highlight: ["95,000+"],
  color: "yellow",
  maincontent:
    "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
  clientsimg: [
    amazonLogo,
    googleLogo,
    microsoftLogo,
    youtubeLogo,
    bloombergLogo,
    spotifyLogo,
    wixLogo,
    hsbcLogo,
    mgmLogo,
    SAPLogo,
  ],
};
export const TDocData = {
  heading: "Translate any document from any number of complex industries",
  maincontent:
    "Tomedes’ document translation services have provided the highest quality of translations to businesses and organizations worldwide, in any language. We don’t just translate words–we capture your true meaning.",
  highlight: ["document translation services"],
  color: "yellow",
  list: [
    {
      img: ParisImage,

      heading: "Legal Translation",
      content:
        "Legal translation is a highly specialized field. Our professional legal translators are adept in the various fields of law. We translate affidavits, patents, contracts, and other legal documents. If you’re in need of legal translation, our legal experts are up for the task. Learn more today.",
      //     coloredcontent:
      //   content2:
      url: "#",
      highlight: [
        "We translate affidavits, patents, contracts, and other legal documents.",
      ],
      color: "yellow",
    },
    {
      img: ParisImage,
      heading: "Medical Translation",
      content:
        "Translation is an integral part of healthcare, abiding by regulations from the FDA and backed by an in-depth understanding of the life sciences. We translate vital medical documents, discharge records, patient forms and academic journals. Medical translation can cover your bases and make sure there are no misunderstandings in every patient interaction. Contact us for your relevant services.",
      highlight: [
        "We translate vital medical documents, discharge records, patient forms and academic journals.",
      ],

      color: "yellow",
      url: "#",
    },
    {
      img: ParisImage,

      heading: "Financial Translation",
      content:
        "Financial translation is here to support the bottomline of your business. We translate loan documents, contracts, mortgage papers, financial documents, statements of accounts, credit reports and more. Provided by experts in finance and financial terminology, our financial translation combines linguistic accuracy and attention to detail. Try it out today.",
      highlight: [
        " We translate loan documents, contracts, mortgage papers, financial documents, statements of accounts, credit reports and more.",
      ],
      color: "yellow",
      url: "#",
    },
    {
      img: ParisImage,

      heading: "Technical Translation",
      content:
        "Technical translation should transform even the most complex procedures for global use. We translate technical documentation in any language: from manuals , architectural plans, and more. Our technical translation combines the best of all worlds–languages, applied sciences, advanced mathematics, and more. Look no further.",
      highlight: [
        "We translate technical documentation in any language: from manuals , architectural plans, and more.",
      ],
      color: "yellow",
      url: "#",
    },
  ],
};
export const PublicPvtData = {
  heading: "Certified for Private and Public Institutions",
  maincontent:
    "Our certified translation services come with the Tomedes guarantee. Our translation certificates are universally accepted in institutions worldwide, and in the USA, like the USCIS, as well as certified by the American Translator’s Association (ATA), the International Organization for Standardization (ISO).",
  highlight: ["certified translation services"],
  color: "yellow",
  certifications: [
    {
      img: ISO,
      iso: "ISO 9001:2015 ",
      certification: "Certification No. 108179",
    },
    {
      img: ISO,
      iso: "ISO 17100 ",
      certification: "Certification No. 108179",
    },
    {
      img: ISO,
      iso: "ISO 18587 ",
      certification: "Certification No. 108179",
    },
  ],
};

export const tabData = [
  {
    id: 1,
    heading: "Entreprises et organisations",
    content: [
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/google-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/volkswagen.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/dhl.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/hilton-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/british-red-cross.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/johnson-johnson-01.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/amazon-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/medtronic.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/youtube.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/symantec.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/british-airways.svg",
      "  https://skins.tomedes.com/frontend/images/customer-logos/corporations/straus.svg ",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/jcb.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/maersk-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/coca-cola.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/keller-williams.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/exxon-mobil.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/warner-bros.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/bnp-paribas.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/nec_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/hitachi-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/craneco-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/sap.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/mgm1.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/nvidia.PNG",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/oracle-6.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/Canon.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/stevemadden_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/kiwi_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/bbc_logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/tedx_en.svg",
      "https://skins.tomedes.com/frontend/images/academy/UN_en.svg",
    ],
  },
  {
    id: 2,
    heading: "Internet et high-tech",
    content: [
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/youtube.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/check-point.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/google-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/yelp.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/amazon-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/cellebrite-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/amdocs.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/wix.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/3m.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/hp.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/spotify.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/verifone.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/motorola.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/corporations/symantec.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/viber.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/broadcom_ltd_logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/hightech-internet/ms.svg",
    ],
  },
  {
    id: 3,
    heading: "Droit et finance",
    content: [
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/credit-suisse-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/hsbc.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/perkins-coie.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/greenberg-traurig.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/moneygram-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/howden_2.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/kpmg.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/krl.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/bloomberg.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/ernst-youngsvg.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/rbc.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/new_york_life_logo.svg",
    ],
  },
  {
    id: 4,
    heading: "Éducation",
    content: [
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/georgetown_university_logotype.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/stanford_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/university_of_london_logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/yale_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/university_of_chicago_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/cornell_university_white.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/ucberkeley.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/law-finance/university_of_minnesota_white.webp",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/weizmann_institute_of_science_logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/university_of_arkansas_logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/uniofmanchesterlogo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/university_of_washington_seal.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/university-of-colorado-springs.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/unt.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/academy/technion_en.svg",
    ],
  },
  {
    id: 5,
    heading: "Applications",
    content: [
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/NVIDIA-TegraZone2.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/snapchat-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/mixcloud.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/zemingo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/tiny-lab-box.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/lupa.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/tabtale.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/newton_by_cloudmagic_logo.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/mobisystems.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/playscape.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/deliveroo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/webpals.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/tonara.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/magoosh-logo.svg",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/cyberghost.png",
      "https://skins.tomedes.com/frontend/images/customer-logos/apps/umake.png",
    ],
  },
];

export const AboutUsHistoryData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Notre histoire",
  },
  highlightedWords: ["histoire"],
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Depuis 2007, date de la création du groupe par Ofer Tirosh, Tomedes accompagne des entreprises souhaitant développer leur activité à l’international. L’idée a germé dans l’esprit de Tirosh en constatant le manque de réactivité de l’industrie de la traduction, à l’ère d’Internet. En voulant tirer profit de cette facilité et rapidité d’échanges à travers le monde, Tirosh créa Tomedes.<br /><br />Il créa d’abord une plateforme de mise en relation de traducteurs et de clients en demande de traduction. Face au succès rencontré et au cours du développement de l’entreprise, Tomedes est peu à peu devenue une entreprise multinationale, disposant de bureaux en Israël, aux USA, au Royaume-Uni et aux Philippines.<br /><br />Notre fierté est aujourd’hui d’avoir accompagné plus de 95 0000 clients à travers le monde, et d’être parvenus à générer un taux de satisfaction client de 97%. Le développement de notre activité s’appuie notamment sur un service client disponible 7j/7, 24h/24, partout dans le monde.",
  },
};

export const AboutUsBannerData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "À propos de nous",
  },
};
export const AboutUsStatsData = {
  value1: {
    default: "Add English",
    en: "Add English",
    fr: "95000+",
  },
  value2: {
    default: "Add English",
    en: "Add English",
    fr: "97%",
  },
  value3: {
    default: "Add English",
    en: "Add English",
    fr: "24h/24 - 7j/7",
  },
  title1: {
    default: "Add English",
    en: "Add English",
    fr: "Clients",
  },
  title2: {
    default: "Add English",
    en: "Add English",
    fr: "de clients satisfaits",
  },
  title3: {
    default: "Add English",
    en: "Add English",
    fr: "Service client",
  },
};
export const CeoMessageData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Un mot de notre PDG",
  },
  highlightWords: {
    default: ["English"],
    en: ["English"],
    fr: ["PDG"],
  },
  highlightedColor: "yellow",
  message: {
    default: "Add English",
    en: "Add English",
    fr: "Nous vivons aujourd’hui dans un monde fortement globalisé. La langue, les cultures peuvent parfois nous diviser, mais elles sont aussi à la base de ce processus de globalisation. Mais cette curiosité envers nos voisins nous permet avant tout d’élargir nos horizons.<br /><br />Les consommateurs d’aujourd’hui ont acquis une certaine clairvoyance quant à leurs possibilités et aux nombreuses options qui leur sont offertes partout dans le monde, et plus seulement autour d’eux.<br /><br />En tant qu’entreprise linguistique leader dans notre domaine, nous contribuons à offrir à nos clients la possibilité de conquérir de nouveaux publics. Mais nous avons surtout vocation à rapprocher les hommes, en brisant les barrières de la langue.",
  },
  name: {
    default: "Ofer Tirosh",
    en: "Ofer Tirosh",
    fr: "Ofer Tirosh",
  },
  nameHighlightWords: {
    default: ["Ofer"],
    en: ["Ofer"],
    fr: ["Ofer"],
  },
  imgurl:
    "https://skins.tomedes.com/frontend/images/aboutus-images/images/ofer_bio.webp",
};

export const OurGoalData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "NOTRE OBJECTIF",
  },
  heading: {
    default: "Add English",
    en: "Add English",
    fr: "Nous sommes là pour",
  },
  mainHeading: {
    default: "Add English",
    en: "Add English",
    fr: "VOUS OFFRIR DE NOUVEAUX HORIZONS",
  },
  highlightWords: {
    default: ["HORIZONS"],
    en: ["HORIZONS"],
    fr: ["HORIZONS"],
  },
  highlightedColor: "regal-blue",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Les différences culturelles, linguistiques et géographiques sont autant d’obstacles que Tomedes contribue à transformer en opportunités, tant pour les individus que pour les entreprises. Pour une entreprise, la traduction est la pierre angulaire d’une stratégie d’internationalisation réussie. Tomedes vous accompagne au quotidien dans votre développement.",
  },
};

export const OurIdentityData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "NOTRE IDENTITÉ:",
  },
  heading: {
    default: "Add English",
    en: "Add English",
    fr: "Nous sommes bien plus que des traducteurs",
  },
  highlightWords: {
    default: ["Add English"],
    en: ["Add English"],
    fr: ["traducteurs"],
  },
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Tomedes apporte son soutien à toutes les entreprises, quelle que soit leur taille et leur domaine d’expertise.<br />Nous sommes bien plus que des traducteurs : nous sommes des marketeurs, des linguistes, des créateurs de contenu, digital, médical, juridique et bien plus encore.<br />Notre expertise et la qualité de nos prestations reposent sur le talent de nos collaborateurs, répartis à travers le monde.<br />Tous nos linguistes, en plus de leur maîtrise de 2 ou plusieurs langues, bénéficient d’une expertise dans leur domaine d’activité, et donc le vôtre.<br />Leur vision sur vos projets linguistiques est à l’image de notre philosophie; élargir vos horizons, plutôt que de les limiter.",
  },
};

export const AboutUsCtaData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Plongez dans un océan de possibilités avec Tomedes",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["possibilités"],
  },
  highlightedColor: "regal-blue",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Êtes-vous prêts à conquérir de nouveaux marchés ? Tomedes vous accompagne dans votre stratégie d’internationalisation.",
  },
  buttonText: {
    default: "Add English",
    en: "Add English",
    fr: "Contactez-nous",
  },
};

export const Accrediteddata = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Une agence de traduction accréditée et détentrice de labels internationaux",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["accréditée"],
  },
  highlightedColor: "regal-blue",
  img1label: {
    default: "ATA Corporate <br/> Member Number 272444",
    en: "ATA Corporate <br/> Member Number 272444",
    fr: "ATA Corporate <br/> Member Number 272444",
  },
};
export const CustomerOpinionData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "L’avis de nos clients",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["clients"],
  },
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Notre taux de satisfaction client est de 97%. Ce score est notamment dû à notre philosophie, qui place le client au cœur de nos ambitions. Découvrez ce que nos clients pensent de nos services.",
  },
  testimonials: [
    {
      id: 1,
      description: {
        default: "Add English",
        en: "Add English",
        fr: "J'ai sollicité Tomedes pour traduire un document très complexe du japonais à l'anglais. Le service était très compétent et les prix très abordables malgré la complexité du projet. Je n'aurais pas pu demander mieux !",
      },
      user: "Marie M.",
    },
    {
      id: 2,
      description: {
        default: "Add English",
        en: "Add English",
        fr: "Tomedes a été génial ! J'avais des délais à respecter. L'équipe était toujours disponible lorsque j'avais des questions. Service rapide, efficace et fiable. Je recommande vivement.",
      },
      user: "Karen W.",
    },
    {
      id: 3,
      description: {
        default: "Add English",
        en: "Add English",
        fr: "Dommage que je n'aie pas sollicité le service de Tomedes plus tôt. C'est à cela que doit ressembler une agence de traduction. Pas de retard, problèmes de qualité ou malentendus. Je recommande donc chaleureusement et ferai appel à leur service à nouveau.",
      },
      user: "Paul F.",
    },
  ],
};

export const CollaborateData = {
  title: "Nous collaborons avec",
  titlecolor:
    "text-slate  text-3xl font-primary leading-[105px] font-bold mt-12",
  clients: [
    {
      id: 1,
      title: "Amazon",
      icon: amazonImage,
    },
    {
      id: 2,
      title: "Google",
      icon: googleImage,
    },
    {
      id: 3,
      title: "Microsoft",
      icon: microsoftImage,
    },
    {
      id: 4,
      title: "Youtube",
      icon: youtubeImage,
    },
    {
      id: 5,
      title: "Bloomberg",
      icon: bloombergImage,
    },
    {
      id: 6,
      title: "Spotify",
      icon: spotifyImage,
    },
    {
      id: 7,
      title: "Wix",
      icon: wixImage,
    },
    {
      id: 8,
      title: "HSBC",
      icon: hsbcImage,
    },
  ],
  // review: {
  //   text: "See our 234 reviews on",
  //   icon: amazonImage,
  // },
};

/* This component (FooterwithForm) is replaced by ContactUs component and data is replaced by contactData */
export const AboutFormData = {
  heading: "CONTACT",
  gridnumber: "grid-cols-2",
  colwidth: "w-9/12 ",
  location: [
    {
      title: "ROYAUME-UNI",
      address:
        "International House, 12 Constance Street, <br/>  London, <br/>  E16 2DQ <br/> Call : +44 (0)16 1509 6140",
    },
    {
      title: "ÉTATS UNIS",
      address:
        "Tomedes Ltd - USA 9450 SW Gemini Dr #34540,<br/>Beaverton,<br/>OR 97008-7105<br/> Call: +972 (0)72 220 0700",
    },
  ],
  inputLabelAndPlaceholder: {
    firstName: "First Name",
    firstNamePlaceholder: "First Name",
    lastName: "Last Name",
    lastNamePlaceholder: "Last Name",
    emailAddress: "Email Address",
    emailAddressPlaceholder: "Email Address",
    tellUs: "Tell Us About Your Needs",
    tellUsPlaceholder: "Tell us more about your needs",
    submitButtonText: "SUBMIT",
    fieldRequired: "This field is required",
  },
};

export const AgencyData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Nos agences",
  },
  btnText: {
    default: "Add English",
    en: "Add English",
    fr: "EN SAVOIR PLUS",
  },
  btnUrl: "https://fr.tomedes.com/agences",
  items: [
    {
      backgroundImage:
        "bg-contactus w-[124px] h-[124px] rounded-full bg-no-repeat",
      backgroundPosition: "-328px",
      location: "Paris",
      mainContent: {
        default: "Add English",
        en: "Add English",
        fr: "Faites rayonner Paris à l’international, profitez d’une gamme de solutions linguistiques sur-mesure au cœur de Paris.",
      },
      texturl: "https://fr.tomedes.com/agences/agence-de-traduction-paris",
    },
    {
      backgroundImage: "bg-contactus w-[124px] h-[124px] rounded-full",
      backgroundPosition: "-163px",
      location: "Lyon",
      mainContent: {
        default: "Add English",
        en: "Add English",
        fr: "Une société de traduction professionnelle à votre service à Lyon pour tous vos besoins linguistiques.",
      },
      texturl: "https://fr.tomedes.com/agences/agence-de-traduction-lyon",
    },
    {
      backgroundImage: "bg-contactus w-[124px] h-[124px] rounded-full",
      backgroundPosition: "",
      location: "Bordeaux",
      mainContent: {
        default: "Add English",
        en: "Add English",
        fr: "Vous êtes situés à Bordeaux ? Nous vous accompagnons dans tous vos projets de traduction et de localisation.",
      },

      texturl: "https://fr.tomedes.com/agences/agence-de-traduction-bordeaux",
    },
  ],
};
export const AgencyData2 = {
  heading: "Nos agences",
  btntext: "EN SAVOIR PLUS",
  btnurl: "https://fr.tomedes.com/agences",
};
export const contactBoxData = {
  title1: {
    default: "Add English",
    en: "Add English",
    fr: "Appelez-nous",
  },
  title1HighlightWords: {
    default: ["English"],
    en: ["English"],
    fr: ["Appelez-"],
  },
  title2: {
    default: "Add English",
    en: "Add English",
    fr: "Écrivez-nous",
  },
  title2HighlightWords: {
    default: ["English"],
    en: ["English"],
    fr: ["Écrivez-"],
  },
  title3: {
    default: "Add English",
    en: "Add English",
    fr: "Suivez-nous",
  },
  title3HighlightWords: {
    default: ["English"],
    en: ["English"],
    fr: ["Suivez-"],
  },
  highlightedColor: "regal-blue",
  tellList: ["US: +1 985 239 0142", "UK: +44 (0)16 1509 6140"],
  email: "contact@tomedes.com",
  list4: ["test@tomedes.com"],
  socialMediaIcons: [
    {
      icon: "facebook",
      href: "https://www.facebook.com/Tomedes.translation/",
    },
    {
      icon: "twitter",
      href: "https://twitter.com/Tomedes",
    },
    {
      icon: "linkedin",
      href: "https://www.linkedin.com/company/tomedes.com",
    },
    {
      icon: "youtube",
      href: "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    },
  ],
};
export const contactFormData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Contactez-nous",
  },
  description: {
    text1: {
      default: "Add English",
      en: "Add English",
      fr: "Besoin d’un renseignement sur nos services ou d’un devis personnalisé ? Contactez-nous dès aujourd’hui, obtenez une réponse en 30 minutes seulement. Vous pouvez également nous contacter par e-mail à l’adresse ",
    },
    email: {
      default: "Add English",
      en: "Add English",
      fr: "contact@tomedes.com",
    },
    text2: {
      fr: " ou par téléphone, au ",
    },
    phoneNumber: "+44 (0)16 15 09 61 40",
  },
  inputLabelAndPlaceholder: {
    firstName: {
      default: "First Name",
      en: "First Name",
      fr: "Prénom",
    },
    firstNamePlaceholder: {
      default: "First Name",
      en: "First Name",
      fr: "Votre prénom",
    },
    lastName: {
      default: "Last Name",
      en: "Last Name",
      fr: "Nom",
    },
    lastNamePlaceholder: {
      default: "Last Name",
      en: "Last Name",
      fr: "Votre nom de famille",
    },
    emailAddress: {
      default: "Email Address",
      en: "Email Address",
      fr: "E-mail",
    },
    phoneNumber: {
      default: "phone",
      en: "phone",
      fr: "Téléphone",
    },
    company: {
      default: "company",
      en: "company",
      fr: "Société",
    },
    country: {
      default: "country",
      en: "country",
      fr: "Pays",
    },
    tellUs: {
      default: "Tell Us About Your Needs",
      en: "Tell Us About Your Needs",
      fr: "Dites-nous en plus sur vos besoins:",
    },
    tellUsPlaceholder: {
      default: "Tell us more about your needs",
      en: "Tell us more about your needs",
      fr: "Un membre de notre équipe vous contactera dans quelques minutes",
    },
    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "Envoyer",
    },
    fieldRequired: {
      default: "This field is required",
      en: "This field is required",
      fr: "Ce champ est obligatoire",
    },
  },
  countryArrayTitle: {
    default: "Select Country",
    en: "Select Country",
    fr: "Sélectionnez un pays",
  },
  chatTitle: {
    default: "Want to chat live ?",
    en: "Want to chat live ?",
    fr: "Vous souhaitez échanger en live ?",
  },
  chatHighlightedWords: {
    default: ["live"],
    en: ["live"],
    fr: ["live"],
  },
  highlightColor: "yellow",
  whatsapplink: "https://api.whatsapp.com/send?phone=972722200700",
  chatDescription: {
    default: "Click on the link and chat with us live!",
    en: "Click on the link and chat with us live!",
    fr: "Cliquez sur le lien et chattez avec nous en direct !",
  },
  quoteFooterText: {
    default: "You can also get a",
    en: "You can also get a",
    fr: "Vous pouvez également obtenir un devis",
  },
  quoteLink: "https://fr.tomedes.com/buyer/quote",
  quoteLinkText: {
    default: "completely free quote here.",
    en: "completely free quote here.",
    fr: "entièrement gratuit ici.",
  },
  captchalabel: "Je suis un humain",

  captchaicon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="46"
      viewBox="0 0 44 46"
      fill="none"
    >
      <path opacity="0.5" d="M30 28H26V32H30V28Z" fill="#0074BF"></path>
      <path opacity="0.7" d="M26 28H22V32H26V28Z" fill="#0074BF"></path>
      <path opacity="0.7" d="M22 28H18V32H22V28Z" fill="#0074BF"></path>
      <path opacity="0.5" d="M18 28H14V32H18V28Z" fill="#0074BF"></path>
      <path opacity="0.7" d="M34 24H30V28H34V24Z" fill="#0082BF"></path>
      <path opacity="0.8" d="M30 24H26V28H30V24Z" fill="#0082BF"></path>
      <path d="M26 24H22V28H26V24Z" fill="#0082BF"></path>
      <path d="M22 24H18V28H22V24Z" fill="#0082BF"></path>
      <path opacity="0.8" d="M18 24H14V28H18V24Z" fill="#0082BF"></path>
      <path opacity="0.7" d="M14 24H10V28H14V24Z" fill="#0082BF"></path>
      <path opacity="0.5" d="M38 20H34V24H38V20Z" fill="#008FBF"></path>
      <path opacity="0.8" d="M34 20H30V24H34V20Z" fill="#008FBF"></path>
      <path d="M30 20H26V24H30V20Z" fill="#008FBF"></path>
      <path d="M26 20H22V24H26V20Z" fill="#008FBF"></path>
      <path d="M22 20H18V24H22V20Z" fill="#008FBF"></path>
      <path d="M18 20H14V24H18V20Z" fill="#008FBF"></path>
      <path opacity="0.8" d="M14 20H10V24H14V20Z" fill="#008FBF"></path>
      <path opacity="0.5" d="M10 20H6V24H10V20Z" fill="#008FBF"></path>
      <path opacity="0.7" d="M38 16H34V20H38V16Z" fill="#009DBF"></path>
      <path d="M34 16H30V20H34V16Z" fill="#009DBF"></path>
      <path d="M30 16H26V20H30V16Z" fill="#009DBF"></path>
      <path d="M26 16H22V20H26V16Z" fill="#009DBF"></path>
      <path d="M22 16H18V20H22V16Z" fill="#009DBF"></path>
      <path d="M18 16H14V20H18V16Z" fill="#009DBF"></path>
      <path d="M14 16H10V20H14V16Z" fill="#009DBF"></path>
      <path opacity="0.7" d="M10 16H6V20H10V16Z" fill="#009DBF"></path>
      <path opacity="0.7" d="M38 12H34V16H38V12Z" fill="#00ABBF"></path>
      <path d="M34 12H30V16H34V12Z" fill="#00ABBF"></path>
      <path d="M30 12H26V16H30V12Z" fill="#00ABBF"></path>
      <path d="M26 12H22V16H26V12Z" fill="#00ABBF"></path>
      <path d="M22 12H18V16H22V12Z" fill="#00ABBF"></path>
      <path d="M18 12H14V16H18V12Z" fill="#00ABBF"></path>
      <path d="M14 12H10V16H14V12Z" fill="#00ABBF"></path>
      <path opacity="0.7" d="M10 12H6V16H10V12Z" fill="#00ABBF"></path>
      <path opacity="0.5" d="M38 8H34V12H38V8Z" fill="#00B9BF"></path>
      <path opacity="0.8" d="M34 8H30V12H34V8Z" fill="#00B9BF"></path>
      <path d="M30 8H26V12H30V8Z" fill="#00B9BF"></path>
      <path d="M26 8H22V12H26V8Z" fill="#00B9BF"></path>
      <path d="M22 8H18V12H22V8Z" fill="#00B9BF"></path>
      <path d="M18 8H14V12H18V8Z" fill="#00B9BF"></path>
      <path opacity="0.8" d="M14 8H10V12H14V8Z" fill="#00B9BF"></path>
      <path opacity="0.5" d="M10 8H6V12H10V8Z" fill="#00B9BF"></path>
      <path opacity="0.7" d="M34 4H30V8H34V4Z" fill="#00C6BF"></path>
      <path opacity="0.8" d="M30 4H26V8H30V4Z" fill="#00C6BF"></path>
      <path d="M26 4H22V8H26V4Z" fill="#00C6BF"></path>
      <path d="M22 4H18V8H22V4Z" fill="#00C6BF"></path>
      <path opacity="0.8" d="M18 4H14V8H18V4Z" fill="#00C6BF"></path>
      <path opacity="0.7" d="M14 4H10V8H14V4Z" fill="#00C6BF"></path>
      <path opacity="0.5" d="M30 0H26V4H30V0Z" fill="#00D4BF"></path>
      <path opacity="0.7" d="M26 0H22V4H26V0Z" fill="#00D4BF"></path>
      <path opacity="0.7" d="M22 0H18V4H22V0Z" fill="#00D4BF"></path>
      <path opacity="0.5" d="M18 0H14V4H18V0Z" fill="#00D4BF"></path>
      <path
        d="M16.5141 14.9697L17.6379 12.4572C18.0459 11.8129 17.9958 11.0255 17.5449 10.5745C17.4876 10.5173 17.416 10.46 17.3444 10.4171C17.0366 10.2238 16.6572 10.1808 16.3065 10.2954C15.9199 10.4171 15.5835 10.6748 15.3687 11.0184C15.3687 11.0184 13.8297 14.6046 13.2642 16.2153C12.6987 17.8259 12.9206 20.7822 15.1254 22.987C17.4661 25.3277 20.8448 25.8575 23.0066 24.2397C23.0997 24.1967 23.1784 24.1395 23.2572 24.0751L29.9072 18.5202C30.2293 18.2554 30.7089 17.7042 30.2794 17.0743C29.8642 16.4586 29.0697 16.881 28.7404 17.0886L24.9107 19.8731C24.8391 19.9304 24.7318 19.9232 24.6673 19.8517C24.6673 19.8517 24.6673 19.8445 24.6602 19.8445C24.56 19.7228 24.5456 19.4079 24.696 19.2862L30.5657 14.304C31.074 13.8459 31.1456 13.1802 30.7304 12.7292C30.3295 12.2854 29.6924 12.2997 29.1842 12.7578L23.9157 16.881C23.8155 16.9597 23.6652 16.9454 23.5864 16.8452L23.5793 16.838C23.4719 16.7235 23.4361 16.5231 23.5506 16.4014L29.535 10.596C30.0074 10.1522 30.036 9.4149 29.5922 8.94245C29.3775 8.72054 29.084 8.59169 28.7762 8.59169C28.4612 8.59169 28.1606 8.70623 27.9387 8.92813L21.8255 14.6691C21.6823 14.8122 21.396 14.6691 21.3602 14.4973C21.3459 14.4328 21.3674 14.3684 21.4103 14.3255L26.0918 8.99972C26.5571 8.56306 26.5858 7.83292 26.1491 7.36763C25.7124 6.90234 24.9823 6.87371 24.517 7.31036C24.4955 7.32468 24.4812 7.34615 24.4597 7.36763L17.3659 15.2203C17.1082 15.478 16.736 15.4851 16.557 15.342C16.4425 15.2489 16.4282 15.0843 16.5141 14.9697Z"
        fill="white"
      ></path>
      <path
        d="M4.99195 43.6627H3.32946V40.8306C3.32946 40.1764 3.2488 39.6073 2.55423 39.6073C1.85966 39.6073 1.64905 40.2167 1.64905 41.0144V43.6627H0V36.112H1.64905V37.9045C1.64905 38.4512 1.64008 39.0427 1.64008 39.0427C1.89999 38.5632 2.38395 38.1689 3.13677 38.1689C4.61106 38.1689 4.99195 39.1637 4.99195 40.4766V43.6627Z"
        fill="#555555"
      ></path>
      <path
        d="M12.081 42.762C11.7181 43.1563 10.9652 43.7882 9.51337 43.7882C7.42069 43.7882 5.77612 42.3228 5.77612 39.8941C5.77612 37.4564 7.43861 36 9.50889 36C10.9742 36 11.7674 36.6453 11.9556 36.8514L11.4402 38.3167C11.3058 38.1285 10.544 37.5281 9.60299 37.5281C8.39757 37.5281 7.4655 38.3795 7.4655 39.8582C7.4655 41.337 8.43342 42.175 9.60299 42.175C10.4902 42.175 11.131 41.803 11.5209 41.3773L12.081 42.762Z"
        fill="#555555"
      ></path>
      <path
        d="M17.3016 43.6627H15.7242L15.6928 43.0936C15.4777 43.3221 15.0655 43.7837 14.2365 43.7837C13.3403 43.7837 12.3903 43.2684 12.3903 42.0674C12.3903 40.8665 13.4344 40.4587 14.3709 40.4139L15.6525 40.3601V40.2391C15.6525 39.67 15.2716 39.3743 14.6084 39.3743C13.9586 39.3743 13.3089 39.679 13.049 39.8538L12.6143 38.72C13.049 38.4915 13.8421 38.1733 14.7921 38.1733C15.7421 38.1733 16.2888 38.4019 16.6921 38.7962C17.082 39.1906 17.3016 39.7148 17.3016 40.6245V43.6627ZM15.657 41.2877L14.8414 41.3415C14.3351 41.3639 14.0348 41.5924 14.0348 41.9957C14.0348 42.4125 14.353 42.6634 14.8101 42.6634C15.2537 42.6634 15.5539 42.3587 15.657 42.1705V41.2877Z"
        fill="#555555"
      ></path>
      <path
        d="M21.6034 43.7792C20.8506 43.7792 20.3129 43.4835 19.9947 42.9816V45.6389H18.3456V38.2674H19.914L19.9051 38.9575H19.9275C20.2994 38.487 20.8461 38.1689 21.6213 38.1689C23.0867 38.1689 24.0142 39.3832 24.0142 40.9696C24.0142 42.5559 23.0777 43.7792 21.6034 43.7792ZM21.1284 39.549C20.4249 39.549 19.9409 40.1181 19.9409 40.9471C19.9409 41.7762 20.4249 42.3453 21.1284 42.3453C21.8409 42.3453 22.3249 41.7762 22.3249 40.9471C22.3249 40.1181 21.8409 39.549 21.1284 39.549Z"
        fill="#555555"
      ></path>
      <path
        d="M27.8321 39.6028H26.7074V41.5386C26.7074 42.0002 26.7701 42.1077 26.8508 42.2063C26.9225 42.296 27.0255 42.3363 27.2406 42.3363C27.4109 42.3318 27.5767 42.3004 27.738 42.2377L27.8187 43.6044C27.4378 43.7165 27.039 43.7747 26.6446 43.7792C26.0576 43.7792 25.6633 43.591 25.4079 43.2773C25.1524 42.9636 25.0449 42.511 25.0449 41.691V39.6028H24.3234V38.2809H25.0449V36.8156H26.7074V38.2809H27.8321V39.6028Z"
        fill="#555555"
      ></path>
      <path
        d="M32.7121 43.1339C32.6583 43.1787 32.1251 43.7792 30.7718 43.7792C29.3781 43.7792 28.0876 42.771 28.0876 40.9785C28.0876 39.1726 29.3961 38.1689 30.7897 38.1689C32.0892 38.1689 32.6762 38.738 32.6762 38.738L32.3133 40.0599C31.9458 39.7507 31.4843 39.5804 31.0048 39.5804C30.3013 39.5804 29.7456 40.0957 29.7456 40.9471C29.7456 41.7986 30.252 42.3363 31.0272 42.3363C31.8024 42.3363 32.3178 41.812 32.3178 41.812L32.7121 43.1339Z"
        fill="#555555"
      ></path>
      <path
        d="M38.3986 43.6627H36.7361V40.8306C36.7361 40.1764 36.6555 39.6073 35.9609 39.6073C35.2663 39.6073 35.0512 40.2212 35.0512 41.0188V43.6672H33.4067V36.112H35.0557V37.9045C35.0557 38.4512 35.0468 39.0427 35.0468 39.0427C35.3067 38.5632 35.7906 38.1689 36.5435 38.1689C38.0177 38.1689 38.3986 39.1637 38.3986 40.4766V43.6627Z"
        fill="#555555"
      ></path>
      <path
        d="M44 43.6627H42.4226L42.3913 43.0936C42.1762 43.3221 41.7639 43.7837 40.9349 43.7837C40.0387 43.7837 39.0887 43.2684 39.0887 42.0674C39.0887 40.8665 40.1328 40.4587 41.0693 40.4139L42.3509 40.3601V40.2391C42.3509 39.67 41.97 39.3743 41.3068 39.3743C40.6571 39.3743 40.0073 39.679 39.7474 39.8538L39.3127 38.7156C39.7474 38.487 40.5406 38.1689 41.4906 38.1689C42.4405 38.1689 42.9872 38.3974 43.3905 38.7917C43.7804 39.1861 44 39.7104 44 40.62V43.6627ZM42.3599 41.2877L41.5443 41.3415C41.038 41.3639 40.7377 41.5924 40.7377 41.9957C40.7377 42.4125 41.0559 42.6634 41.513 42.6634C41.9566 42.6634 42.2568 42.3587 42.3599 42.1705V41.2877V41.2877Z"
        fill="#555555"
      ></path>
    </svg>
  ),
};

export const OfficeLocationCardsData = {
  sectionCss: "px-16 py-14 flex flex-col items-center",
  heading: {
    text: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "Services de traduction en France",
    },
    css: "text-slate font-primary font-semibold text-4xl mb-7",
  },

  cardsContainerCss:
    "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-7 gap-y-6 h-auto",
  CardCss: {
    card: "w-full md:w-80 lg:w-72 xl:w-80 bg-prussian-blue  flex flex-col justify-start",
    imgCss: "w-full",
    textBoxCss: "p-6 flex flex-col h-full",
    titleCss: "mt-5 mb-4 font-primary font-semibold text-lg text-white",
    textCss: "grow text-slate font-opensans font-light text-sm leading-6 mb-5",
    emailCss: "mb-5 text-slate font-opensans font-light text-sm leading-6",
    emailSpanCss: "text-yellow mr-1",
    numberCss: "mb-5 text-slate font-opensans font-light text-sm leading-6",
    callSpanCss: "text-yellow mr-1",
    buttonCss:
      "bg-regal-blue w-full flex items-center justify-center p-2 text-white uppercase text-sm mt-auto hover:bg-turquoise-blue41",
  },

  cards: [
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/bordeaux.webp",
      altTag: {
        default: "Bordeaux City",
        en: "Bordeaux City",
        fr: "Bordeaux City",
      },

      cardData: {
        title: {
          default: "Bordeaux",
          en: "Bordeaux",
          fr: "Bordeaux",
        },
        text: {
          default:
            "Au cœur de la belle endormie, faites décoller votre activité dès aujourd’hui en contactant notre agence de traduction à Bordeaux.",
          en: "Add English translation",
          fr: "Au cœur de la belle endormie, faites décoller votre activité dès aujourd’hui en contactant notre agence de traduction à Bordeaux.",
        },

        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-bordeaux",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/lille.webp",
      altTag: {
        default: "Lille City",
        en: "Lille City",
        fr: "Lille City",
      },

      cardData: {
        title: {
          default: "Lille",
          en: "Lille",
          fr: "Lille",
        },
        text: {
          default: "Add default translation",
          en: "Add English translation",
          fr: "Des experts en linguistique à votre service, faites-vous accompagner par notre agence de traduction à Lille.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-lille",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/lyon.webp",
      altTag: {
        default: "Lyon City",
        en: "Lyon City",
        fr: "Lyon City",
      },

      cardData: {
        title: {
          default: "Lyon",
          en: "Lyon",
          fr: "Lyon",
        },
        text: {
          default:
            "Vous êtes localisés dans la ville des Lumières ? Contactez notre agence de traduction à Lyon.",
          en: "Add french translation",
          fr: "Vous êtes localisés dans la ville des Lumières ? Contactez notre agence de traduction à Lyon.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add french translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-lyon",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/marseille.webp",
      altTag: {
        default: "Marseille City",
        en: "Marseille City",
        fr: "Marseille City",
      },

      cardData: {
        title: {
          default: "Marseille",
          en: "Marseille",
          fr: "Marseille",
        },
        text: {
          default:
            "Des portes de l’Europe vers le Monde, entourez-vous des meilleurs, agence de traduction professionnelle à Marseille.",
          en: "Add french translation",
          fr: "Des portes de l’Europe vers le Monde, entourez-vous des meilleurs, agence de traduction professionnelle à Marseille.",
        },

        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-marseille",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/montpellier.webp",
      altTag: {
        default: "Montpellier City",
        en: "Montpellier City",
        fr: "Montpellier City",
      },

      cardData: {
        title: {
          default: "Montpellier",
          en: "Montpellier",
          fr: "Montpellier",
        },
        text: {
          default: "Add English translation",
          en: "Add English translation",
          fr: "Pour tous vos projets de traductions et besoins linguistique, contactez une agence de traduction à Montpellier",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-montpellier",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/nantes.webp",
      altTag: {
        default: "Nantes City",
        en: "Nantes City",
        fr: "Nantes City",
      },

      cardData: {
        title: {
          default: "Nantes",
          en: "Nantes",
          fr: "Nantes",
        },
        text: {
          default: "Add English translation",
          en: "Add English translation",
          fr: "La Cité des Ducs est l’une des villes les plus dynamiques de France. Contactez notre agence de traduction à Nantes.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-nantes",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/nice.webp",
      altTag: {
        default: "Nice City",
        en: "Nice City",
        fr: "Nice City",
      },

      cardData: {
        title: {
          default: "Nice",
          en: "Nice",
          fr: "Nice",
        },
        text: {
          default: "Add English translation",
          en: "Add English translation",
          fr: "Agence de traduction à Nice, poussez les frontières de Nissa Bella, disponible 24h24.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-nice",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/paris.webp",
      altTag: {
        default: "Paris City",
        en: "Paris City",
        fr: "Paris City",
      },

      cardData: {
        title: {
          default: "Paris",
          en: "Paris",
          fr: "Paris",
        },
        text: {
          default:
            "Notre agence de traduction à Paris vous accompagne dans votre stratégie linguistique.",
          en: "Add English translation",
          fr: "Notre agence de traduction à Paris vous accompagne dans votre stratégie linguistique.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-paris",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/strasbourg.webp",
      altTag: {
        default: "Strasbourg City",
        en: "Strasbourg City",
        fr: "Strasbourg City",
      },

      cardData: {
        title: {
          default: "Strasbourg",
          en: "Strasbourg",
          fr: "Strasbourg",
        },
        text: {
          default: "Add English translation",
          en: "Add English translation",
          fr: "De la capitale des institutions européennes au monde entier. Notre agence de traduction à Strasbourg est disponible 7j/7.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-strasbourg",
      },
    },
    {
      img: "https://skins.tomedes.com/frontend/images/reviews/french/toulouse.webp",
      altTag: {
        default: "Toulouse City",
        en: "Toulouse City",
        fr: "Toulouse City",
      },

      cardData: {
        title: {
          default: "Toulouse",
          en: "Toulouse",
          fr: "Toulouse",
        },
        text: {
          default: "Add English translation",
          en: "Add English translation",
          fr: "Au cœur de la ville rose, une agence de traduction professionnelle à Toulouse.",
        },
        emailText: {
          default: "Email:",
          en: "Email:",
          fr: "Email:",
        },
        emailAddress: {
          default: "info@tomedes.com",
          en: "info@tomedes.com",
          fr: "info@tomedes.com",
        },
        callText: {
          default: "Call:",
          en: "Call:",
          fr: "Call:",
        },
        number: {
          default: "+44 1615 096140",
          en: "+44 1615 096140",
          fr: "+44 1615 096140",
        },
      },
      button: {
        text: {
          default: "EN SAVOIR PLUS",
          en: "Add English translation",
          fr: "EN SAVOIR PLUS",
        },
        linkAddress: "agence-de-traduction-toulouse",
      },
    },
  ],
};

export const sideNavAndCardsData = {
  boxContainerCss: "pt-24 px-8 lg:px-24 pb-20",
  heading: {
    text: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "Tomedes, présent dans le monde entier",
    },
    highlightedText: {
      default: ["English"],
      en: ["English"],
      fr: ["Tomedes,"],
    },
    highlightedColor: "yellow",
    css: "text-36px text-slate text-primary text-center font-semibold leading-10 pb-12",
  },

  css: {
    title:
      "text-center pt-20 mb-12 text-slate font-primary font-light text-28px border-t border-grey38",
    sideNavAndCards: "flex items-start",
    sideNav: "",
    li: "md:flex items-start",
    liSpan: "mb-10 px-4 mr-28 lg:mr-44 text-26px cursor-pointer",
    selectedLi: "text-yellow",
    gridContainer: "",
    imageGrid:
      "grid grid-cols-2 500px:grid-cols-3 xl:grid-cols-4 gap-x-8 xl:gap-x-20 gap-y-10 pb-14",
    singleImage: {
      container: "relative w-24 350px:w-120px",
      image: "w-full rounded-30px box-shadow-off-white",
      span: "absolute bottom-0 text-center bg-black opacity-80 w-full p-2.5 text-14px rounded-b-30px",
    },

    mobileLiDiv: "cursor-pointer p-5 bg-light-blue mb-5 text-18px flex",
    mobileLiDivSpan: "flex items-center",
    mobileIcon: "bg-red mt-2 ml-6 h-0",
    mobileIconRotate: "bg-red mt-5 ml-3 h-0 rotate-180",
    mobileHighlight: "cursor-pointer p-5 mb-5 text-18px flex bg-yellow",
    mobileImageGrid:
      "pb-5 grid grid-cols-2 500px:grid-cols-3 xl:grid-cols-4 gap-x-8 xl:gap-x-20 gap-y-10",
  },

  europe: {
    title: {
      default: "Add English translaion",
      en: "Add English translaion",
      fr: "Tomedes en Europe",
    },
    sideNav: {
      default: ["Germany", "Spain", "Poland", "UK"],
      en: ["Germany", "Spain", "Poland", "UK"],
      fr: ["Allemagne", "Espagne", "Poland", "Royaume-Uni"],
    },
    content: {
      default: {
        Germany: [
          {
            name: "English of Berlin",
            img: "berlin",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-berlin",
          },
          {
            name: "English of Bremen",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-bremen",
          },
          {
            name: "English of Dortmund",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dortmund",
          },
          {
            name: "English of Dresde",
            img: "dresde",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dresden",
          },
          {
            name: "English of Dusseldorf",
            img: "dusseldorf",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-duesseldorf",
          },
          {
            name: "English of Frankfurt",
            img: "frankfurt",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-frankfurt",
          },
          {
            name: "English of Hamburg",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-hamburg",
          },
          {
            name: "English of Köln",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-koeln",
          },
          {
            name: "English of Munich",
            img: "munich",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-muenchen",
          },
          {
            name: "English of Stuttgart",
            img: "stuttgart",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-stuttgart",
          },
        ],
        Spain: [
          {
            name: "English of Bercelon",
            img: "barcelona",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-barcelona",
          },
          {
            name: "English of Bilbao",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/empresa-de-traduccion-bilbao",
          },
          {
            name: "English of La Coruña",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-la-coruna",
          },
          {
            name: "English of Madrid",
            img: "madrid",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-madrid",
          },
          {
            name: "English of Malaga",
            img: "malaga",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-malaga",
          },
          {
            name: "English of Murcia",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-murcia",
          },
          {
            name: "English of Palma de Mallorca",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-palma-de-mallorca",
          },
          {
            name: "English of Seville",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-sevilla",
          },
          {
            name: "English of Valence",
            img: "valencia",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-valencia",
          },
          {
            name: "English of Zaragoza",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-zaragoza",
          },
        ],
        Poland: [
          {
            name: "English of Katowice",
            img: "katowice",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-katowice",
          },
          {
            name: "English of Krakovie",
            img: "krakow",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-krakow",
          },
          {
            name: "English of Poznan",
            img: "poznan",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-poznan",
          },
          {
            name: "English of Varsovie",
            img: "warsaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-warszawa",
          },
          {
            name: "English of Wroclaw",
            img: "wroclaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-wroclaw",
          },
        ],
        UK: [
          {
            name: "English of London",
            img: Bremen,
            link: "https://www.tomedes.com/locations/london-translation-services",
          },
          {
            name: "English of Manchester",
            img: Berlin,
            link: "https://www.tomedes.com/locations/manchester-translation-services",
          },
        ],
      },

      en: {
        Germany: [
          {
            name: "English of Berlin",
            img: "berlin",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-berlin",
          },
          {
            name: "English of Bremen",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-bremen",
          },
          {
            name: "English of Dortmund",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dortmund",
          },
          {
            name: "English of Dresde",
            img: "dresde",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dresden",
          },
          {
            name: "English of Dusseldorf",
            img: "dusseldorf",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-duesseldorf",
          },
          {
            name: "English of Frankfurt",
            img: "frankfurt",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-frankfurt",
          },
          {
            name: "English of Hamburg",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-hamburg",
          },
          {
            name: "English of Köln",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-koeln",
          },
          {
            name: "English of Munich",
            img: "munich",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-muenchen",
          },
          {
            name: "English of Stuttgart",
            img: "stuttgart",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-stuttgart",
          },
        ],
        Spain: [
          {
            name: "English of Bercelon",
            img: "barcelona",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-barcelona",
          },
          {
            name: "English of Bilbao",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/empresa-de-traduccion-bilbao",
          },
          {
            name: "English of La Coruña",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-la-coruna",
          },
          {
            name: "English of Madrid",
            img: "madrid",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-madrid",
          },
          {
            name: "English of Malaga",
            img: "malaga",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-malaga",
          },
          {
            name: "English of Murcia",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-murcia",
          },
          {
            name: "English of Palma de Mallorca",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-palma-de-mallorca",
          },
          {
            name: "English of Seville",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-sevilla",
          },
          {
            name: "English of Valence",
            img: "valencia",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-valencia",
          },
          {
            name: "English of Zaragoza",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-zaragoza",
          },
        ],
        Poland: [
          {
            name: "English of Katowice",
            img: "katowice",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-katowice",
          },
          {
            name: "English of Krakovie",
            img: "krakow",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-krakow",
          },
          {
            name: "English of Poznan",
            img: "poznan",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-poznan",
          },
          {
            name: "English of Varsovie",
            img: "warsaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-warszawa",
          },
          {
            name: "English of Wroclaw",
            img: "wroclaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-wroclaw",
          },
        ],
        UK: [
          {
            name: "English of London",
            img: Bremen,
            link: "https://www.tomedes.com/locations/london-translation-services",
          },
          {
            name: "English of Manchester",
            img: Berlin,
            link: "https://www.tomedes.com/locations/manchester-translation-services",
          },
        ],
      },

      fr: {
        Allemagne: [
          {
            name: "Berlin",
            img: "berlin",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-berlin",
          },
          {
            name: "Bremen",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-bremen",
          },
          {
            name: "Dortmund",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dortmund",
          },
          {
            name: "Dresde",
            img: "dresde",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-dresden",
          },
          {
            name: "Düsseldorf",
            img: "dusseldorf",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-duesseldorf",
          },
          {
            name: "Frankfurt",
            img: "frankfurt",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-frankfurt",
          },
          {
            name: "Hamburg",
            img: Berlin,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-hamburg",
          },
          {
            name: "Köln",
            img: Bremen,
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-koeln",
          },
          {
            name: "Munich",
            img: "munich",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-muenchen",
          },
          {
            name: "Stuttgart",
            img: "stuttgart",
            link: "https://de.tomedes.com/standorte/uebersetzungsbuero-stuttgart",
          },
        ],
        Espagne: [
          {
            name: "Bercelon",
            img: "barcelona",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-barcelona",
          },
          {
            name: "Bilbao",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/empresa-de-traduccion-bilbao",
          },
          {
            name: "La Coruña",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-la-coruna",
          },
          {
            name: "Madrid",
            img: "madrid",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-madrid",
          },
          {
            name: "Malaga",
            img: "malaga",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-malaga",
          },
          {
            name: "Murcia",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-murcia",
          },
          {
            name: "Palma de Mallorca",
            img: Berlin,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-palma-de-mallorca",
          },
          {
            name: "Seville",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-sevilla",
          },
          {
            name: "Valence",
            img: "valencia",
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-valencia",
          },
          {
            name: "Zaragoza",
            img: Bremen,
            link: "https://es.tomedes.com/agencias/agencia-de-traduccion-zaragoza",
          },
        ],
        Poland: [
          {
            name: "Katowice",
            img: "katowice",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-katowice",
          },
          {
            name: "Krakovie",
            img: "krakow",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-krakow",
          },
          {
            name: "Poznan",
            img: "poznan",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-poznan",
          },
          {
            name: "Varsovie",
            img: "warsaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-warszawa",
          },
          {
            name: "Wroclaw",
            img: "wroclaw",
            link: "https://pl.tomedes.com/lokacje/biuro-tlumaczen-wroclaw",
          },
        ],
        "Royaume-Uni": [
          {
            name: "London",
            img: Bremen,
            link: "https://www.tomedes.com/locations/london-translation-services",
          },
          {
            name: "Manchester",
            img: Berlin,
            link: "https://www.tomedes.com/locations/manchester-translation-services",
          },
        ],
      },
    },
  },
  northAmerica: {
    title: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "Tomedes en Amérique du Nord",
    },
    sideNav: {
      default: ["USA", "Canada"],
      en: ["USA", "Canada"],
      fr: ["États-Unis", "Canada"],
    },
    content: {
      default: {
        USA: [
          {
            name: "English of Atlanta",
            img: "atlanta",
            link: "https://www.tomedes.com/locations/atlanta-translation-services",
          },
          {
            name: "English of Boston",
            img: "boston",
            link: "https://www.tomedes.com/locations/boston-translation-services",
          },
          {
            name: "English of Chicago",
            img: "chicago",
            link: "https://www.tomedes.com/locations/chicago-translation-services",
          },
          {
            name: "English of Dallas",
            img: "dallas",
            link: "https://www.tomedes.com/locations/dallas-translation-services",
          },
          {
            name: "English of Denver",
            img: "denver",
            link: "https://www.tomedes.com/locations/denver-translation-services",
          },
          {
            name: "English of Houston",
            img: "houston",
            link: "https://www.tomedes.com/locations/houston-translation-services",
          },
          {
            name: "English of Los Angeles",
            img: Berlin,
            link: "https://www.tomedes.com/locations/los-angeles-translation-services",
          },
          {
            name: "English of Miami",
            img: "miami",
            link: "https://www.tomedes.com/locations/miami-translation-services",
          },
          {
            name: "English of New York",
            img: "new-york",
            link: "https://www.tomedes.com/locations/nyc-translation-services",
          },
          {
            name: "English of Philadelphia",
            img: "philadelphia",
            link: "https://www.tomedes.com/locations/philadelphia-translation-services",
          },
          {
            name: "English of San Diego",
            img: "san-diego",
            link: "https://www.tomedes.com/locations/san-diego-translation-services",
          },
          {
            name: "English of San Francisco",
            img: "san-francisco",
            link: "https://www.tomedes.com/locations/san-francisco-translation-services",
          },
          {
            name: "English of Seattle",
            img: "seattle",
            link: "https://www.tomedes.com/locations/seattle-translation-services",
          },
        ],
        Canada: [
          {
            name: "English of Ottawa",
            img: "ottawa",
            link: "https://www.tomedes.com/locations/ottawa-translation-services",
          },
          {
            name: "English of Toronto",
            img: "toronto",
            link: "https://www.tomedes.com/locations/toronto-translation-services",
          },
        ],
      },
      en: {
        USA: [
          {
            name: "English of Atlanta",
            img: "atlanta",
            link: "https://www.tomedes.com/locations/atlanta-translation-services",
          },
          {
            name: "English of Boston",
            img: "boston",
            link: "https://www.tomedes.com/locations/boston-translation-services",
          },
          {
            name: "English of Chicago",
            img: "chicago",
            link: "https://www.tomedes.com/locations/chicago-translation-services",
          },
          {
            name: "English of Dallas",
            img: "dallas",
            link: "https://www.tomedes.com/locations/dallas-translation-services",
          },
          {
            name: "English of Denver",
            img: "denver",
            link: "https://www.tomedes.com/locations/denver-translation-services",
          },
          {
            name: "English of Houston",
            img: "houston",
            link: "https://www.tomedes.com/locations/houston-translation-services",
          },
          {
            name: "English of Los Angeles",
            img: Berlin,
            link: "https://www.tomedes.com/locations/los-angeles-translation-services",
          },
          {
            name: "English of Miami",
            img: "miami",
            link: "https://www.tomedes.com/locations/miami-translation-services",
          },
          {
            name: "English of New York",
            img: "new-york",
            link: "https://www.tomedes.com/locations/nyc-translation-services",
          },
          {
            name: "English of Philadelphia",
            img: "philadelphia",
            link: "https://www.tomedes.com/locations/philadelphia-translation-services",
          },
          {
            name: "English of San Diego",
            img: "san-diego",
            link: "https://www.tomedes.com/locations/san-diego-translation-services",
          },
          {
            name: "English of San Francisco",
            img: "san-francisco",
            link: "https://www.tomedes.com/locations/san-francisco-translation-services",
          },
          {
            name: "English of Seattle",
            img: "seattle",
            link: "https://www.tomedes.com/locations/seattle-translation-services",
          },
        ],
        Canada: [
          {
            name: "English of Ottawa",
            img: "ottawa",
            link: "https://www.tomedes.com/locations/ottawa-translation-services",
          },
          {
            name: "English of Toronto",
            img: "toronto",
            link: "https://www.tomedes.com/locations/toronto-translation-services",
          },
        ],
      },
      fr: {
        "États-Unis": [
          {
            name: "Atlanta",
            img: "atlanta",
            link: "https://www.tomedes.com/locations/atlanta-translation-services",
          },
          {
            name: "Boston",
            img: "boston",
            link: "https://www.tomedes.com/locations/boston-translation-services",
          },
          {
            name: "Chicago",
            img: "chicago",
            link: "https://www.tomedes.com/locations/chicago-translation-services",
          },
          {
            name: "Dallas",
            img: "dallas",
            link: "https://www.tomedes.com/locations/dallas-translation-services",
          },
          {
            name: "Denver",
            img: "denver",
            link: "https://www.tomedes.com/locations/denver-translation-services",
          },
          {
            name: "Houston",
            img: "houston",
            link: "https://www.tomedes.com/locations/houston-translation-services",
          },
          {
            name: "Los Angeles",
            img: Berlin,
            link: "https://www.tomedes.com/locations/los-angeles-translation-services",
          },
          {
            name: "Miami",
            img: "miami",
            link: "https://www.tomedes.com/locations/miami-translation-services",
          },
          {
            name: "New York",
            img: "new-york",
            link: "https://www.tomedes.com/locations/nyc-translation-services",
          },
          {
            name: "Philadelphia",
            img: "philadelphia",
            link: "https://www.tomedes.com/locations/philadelphia-translation-services",
          },
          {
            name: "San Diego",
            img: "san-diego",
            link: "https://www.tomedes.com/locations/san-diego-translation-services",
          },
          {
            name: "San Francisco",
            img: "san-francisco",
            link: "https://www.tomedes.com/locations/san-francisco-translation-services",
          },
          {
            name: "Seattle",
            img: "seattle",
            link: "https://www.tomedes.com/locations/seattle-translation-services",
          },
        ],
        Canada: [
          {
            name: "Ottawa",
            img: "ottawa",
            link: "https://www.tomedes.com/locations/ottawa-translation-services",
          },
          {
            name: "Toronto",
            img: "toronto",
            link: "https://www.tomedes.com/locations/toronto-translation-services",
          },
        ],
      },
    },
  },
  asiaAndAustralia: {
    title: {
      default: "Add English translation",
      en: "Add English translation",
      fr: "Tomedes en Asie et en Australie",
    },
    sideNav: {
      default: ["Israel", "Australia"],
      en: ["Israel", "Australia"],
      fr: ["Israel", "Australie"],
    },
    content: {
      default: {
        Israel: [
          {
            name: "Tel Aviv",
            img: "telaviv",
            link: "https://www.tomedes.co.il/",
          },
        ],
        Australia: [
          {
            name: "Melbourne",
            img: "melbourne",
            link: "https://www.tomedes.com/locations/melbourne-translation-services",
          },
          {
            name: "Sydney",
            img: "sydney",
            link: "https://www.tomedes.com/locations/sydney-translation-services",
          },
        ],
      },

      en: {
        Israel: [
          {
            name: "Tel Aviv",
            img: "telaviv",
            link: "https://www.tomedes.co.il/",
          },
        ],
        Australia: [
          {
            name: "Melbourne",
            img: "melbourne",
            link: "https://www.tomedes.com/locations/melbourne-translation-services",
          },
          {
            name: "Sydney",
            img: "sydney",
            link: "https://www.tomedes.com/locations/sydney-translation-services",
          },
        ],
      },

      fr: {
        Israel: [
          {
            name: "Tel Aviv",
            img: "telaviv",
            link: "https://www.tomedes.co.il/",
          },
        ],
        Australie: [
          {
            name: "Melbourne",
            img: "melbourne",
            link: "https://www.tomedes.com/locations/melbourne-translation-services",
          },
          {
            name: "Sydney",
            img: "sydney",
            link: "https://www.tomedes.com/locations/sydney-translation-services",
          },
        ],
      },
    },
  },
};

export const footerData = {
  footerlogo: "logo-footer",
  mainContent: {
    default:
      "Tomedes Translation Services is committed to broadening the horizons of individuals and businesses in the United States and internationally, through the effective use of professional translation services. <br><br> Our translation company provides fast and accurate translation services in more than 120 languages and 950+ language pairs and is available 24/7 via email, phone or chat.",
    en: "Tomedes Translation Services is committed to broadening the horizons of individuals and businesses in the United States and internationally, through the effective use of professional translation services. <br><br> Our translation company provides fast and accurate translation services in more than 120 languages and 950+ language pairs and is available 24/7 via email, phone or chat.",
    fr: "Add French Translation",
  },
  navigation: [
    {
      heading: {
        default: "Services",
        en: "Services",
        fr: "Add French Translation",
      },
      list: [
        {
          text: {
            default: "Traduction assermentée",
            en: "Traduction assermentée",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Traduction de document",
            en: "Traduction de document",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Autres services de traduction",
            en: "Autres services de traduction",
            fr: "Add French Translation",
          },
          href: "/",
        },
      ],
    },
    {
      heading: {
        default: "Langues les plus Populaires",
        en: "Langues les plus Populaires",
        fr: "Add French Translation",
      },
      list: [
        {
          text: {
            default: "Anglais",
            en: "Anglais",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Allemand",
            en: "Allemand",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Espagnol",
            en: "Espagnol",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Arabe",
            en: "Arabe",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Italien",
            en: "Italien",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Portugais",
            en: "Portugais",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Nos langues",
            en: "Nos langues",
            fr: "Add French Translation",
          },
          href: "/",
        },
      ],
    },
    {
      heading: {
        default: "Lien Utiles",
        en: "Lien Utiles",
        fr: "Add French Translation",
      },
      list: [
        {
          text: {
            default: "Blog",
            en: "Blog",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Dernières Réalisations",
            en: "Dernières Réalisations",
            fr: "Add French Translation",
          },
          href: "/",
        },
        {
          text: {
            default: "Démarche Qualité",
            en: "Démarche Qualité",
            fr: "Add French Translation",
          },
          href: "/",
        },
      ],
    },
  ],
  certificates: [
    {
      id: 1,
      title: {
        default: "ISO 9001:2015",
        en: "ISO 9001:2015",
        fr: "Add French Translation",
      },
      icon: "iso9001:2015gold",
      className: "px-2 w-20 sm:w-28 h-auto",
    },
    {
      id: 2,
      title: {
        default: "ISO 17100:2015",
        en: "ISO 17100:2015",
        fr: "Add French Translation",
      },
      icon: "iso17100:2015gold",
      className: "px-2 w-20 sm:w-28 h-auto",
    },
    {
      id: 3,
      title: {
        default: "ISO 18587:2017",
        en: "ISO 18587:2017",
        fr: "Add French Translation",
      },
      icon: "iso18587:2017gold",
      className: "px-2 w-20 sm:w-28 h-auto",
    },
  ],
  locationicon: "location-footer",
  address: {
    default:
      "Tomedes Ltd - Europe International House,  12 Constance St, London, E16 2DQ Call: +44 (0)16 1509 6140",
    en: "Tomedes Ltd - Europe International House,  12 Constance St, London, E16 2DQ Call: +44 (0)16 1509 6140",
    fr: "Add French Translation",
  },
  phoneicon: "phone-footer",
  tellist: [
    {
      text: {
        default: "FR: +0 000 000 0000",
        en: "FR: +0 000 000 0000",
        fr: "Add French Translation",
      },
    },
    {
      text: {
        default: "UK: +44 1615 096140",
        en: "UK: +44 1615 096140",
        fr: "Add French Translation",
      },
    },
  ],
  mailicon: "mail-footer",
  emailaddress: {
    default: "contact@tomedes.com",
    en: "contact@tomedes.com",
    fr: "Add French Translation",
  },
  socialMediaIcons: [
    {
      icon: "facebook",
      href: "https://www.facebook.com/Tomedes.translation/",
    },
    {
      icon: "twitter",
      href: "https://twitter.com/Tomedes",
    },
    {
      icon: "linkedin",
      href: "https://www.linkedin.com/company/tomedes.com",
    },
    {
      icon: "youtube",
      href: "https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw",
    },
    {
      icon: "instagram",
      href: "https://www.instagram.com/tomedes_translation/",
    },
    {
      icon: "twitter",
      href: "https://twitter.com/Tomedes",
    },
  ],
  agencyHeading: {
    default: "AGENCES",
    en: "AGENCES",
    fr: "Add French Translation",
  },
  agencyList: [
    {
      text: {
        default: "Paris",
        en: "Paris",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Lyon",
        en: "Lyon ",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Bordeaux",
        en: "Bordeaux",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Strasbourg",
        en: "Strasbourg",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Lille",
        en: "Lille",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Nantes",
        en: "Nantes",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Marseille",
        en: "Marseille",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Nice",
        en: "Nice",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Toulouse",
        en: "Toulouse",
        fr: "French",
      },
      href: "/",
    },
    {
      text: {
        default: "Montpellier",
        en: "Montpellier",
        fr: "French",
      },
      href: "/",
    },
  ],
  footerBottomLinks: [
    {
      text: {
        default: "Site Map",
        en: "Site Map",
        fr: "Add French Translation",
      },
      href: "/",
    },
    {
      text: {
        default: "Terms & Conditions",
        en: "Terms & Conditions",
        fr: "Add French Translation",
      },
      href: "/",
    },
    {
      text: {
        default: "Standards & Goals",
        en: "Standards & Goals",
        fr: "Add French Translation",
      },
      href: "/",
    },
    {
      text: {
        default: "Privacy",
        en: "Privacy",
        fr: "Add French Translation",
      },
      href: "/",
    },
  ],

  copyright: {
    default: "© Copyright 2007 - 2020 TOMEDES. All Rights Reserved.",
    en: "© Copyright 2007 - 2020 TOMEDES. All Rights Reserved.",
    fr: "Add French Translation",
  },
};

export const checkoutData = {
  orderSteps: {
    step1: {
      title: {
        default: "Step 1: Project Details",
        en: "Step 1: Project Details",
        fr: "Étape n°1 : Votre projet",
      },
      isActive: true,
      h1: {
        default: "What would you like to translate?",
        en: "What would you like to translate?",
        fr: "Que souhaitez-vous traduire ?",
      },
    },
    step2: {
      title: {
        default: "Step 2: Purchase Options",
        en: "Step 2: Purchase Options",
        fr: "Étape n°2 : Options d’achat",
      },
      isActive: true,
      h1: {
        default: "Choose your Translation Solution",
        en: "Choose your Translation Solution",
        fr: "Choisissez votre solution de traduction",
      },
    },
    step3: {
      title: {
        default: "Step 3: Place Order",
        en: "Step 3: Place Order",
        fr: "Étape n°3 : Passer commande",
      },
      isActive: true,
      h1: {
        default: "Order Details",
        en: "Order Details",
        fr: "Informations de la commande",
      },
    },

    step4: {
      title: {
        default: "Step 3: Place Order",
        en: "Step 3: Place Order",
        fr: "Étape n°3 : Passer commande",
      },
      isActive: false,
      h1: {
        default: "Create an Account",
        en: "Create an Account",
        fr: "Créer un compte",
      },
    },
  },

  mainHeading: {
    default: "What would you like to translate?",
    en: "What would you like to translate?",
    fr: "Que souhaitez-vous traduire ?",
  },

  subtitle: {
    text1: {
      default: "You can get an instant quote or",
      en: "You can get an instant quote or",
      fr: "Add french translation",
    },

    span: {
      default: " send us your contact details ",
      en: " send us your contact details ",
      fr: " Add french translation",
    },

    text2: {
      default:
        "and one of our team members will get back to you within a few minutes.",
      en: "and one of our team members will get back to you within a few minutes.",
      fr: "add french translation",
    },
  },

  translationForm: {
    translateFromLabel: {
      default: "Translate from",
      en: "Translate from",
      fr: "Traduire du/de",
    },

    translateToLabel: {
      default: "Translate to",
      en: "Translate to",
      fr: "Traduire en",
    },

    uploadLabel: {
      default: "Wordcount / Upload your file",
      en: "Wordcount / Upload your file",
      fr: "Nombre de mots/Téléchargez votre fichier",
    },

    uploadFileButtonText: {
      default: "EDIT FILE",
      en: "EDIT FILE",
      fr: "Add french translation",
    },

    editButtonText: {
      default: "UPLOAD FILE",
      en: "UPLOAD FILE",
      fr: "Charger fichier",
    },

    fileText: {
      default: "File",
      en: "File",
      fr: "Add french translation",
    },
  },

  projectDetailsHeading: {
    default: "Project Details (Optional)",
    en: "Project Details (Optional)",
    fr: "Add french translation",
  },

  projectDetailsFormLabel: {
    serviceLabel: {
      default: "Service",
      en: "Service",
      fr: "Add french translation",
    },

    subjectLabel: {
      default: "Subject",
      en: "Subject",
      fr: "Add french translation",
    },

    hearLabel: {
      default: "How did you hear about us?",
      en: "How did you hear about us?",
      fr: "Comment avez-vous entendu parler de nous ?",
    },
  },

  cta: {
    default: "Show Price and Time",
    en: "Show Price and Time",
    fr: "afficher le prix et l’heure",
  },

  languagePairsText: {
    default: "Language Pair (s):",
    en: "Language Pair (s):",
    fr: "Paire de langues :",
  },

  wordCountText: {
    default: "Word Count:",
    en: "Word Count:",
    fr: "Nombre de mots:",
  },

  orderStepTwoStaticData: {
    bestPrice: {
      heading: {
        default: "Best Price",
        en: "Best Price",
        fr: "Meilleur prix",
      },

      benifits: {
        default: "1 Year Guarantee | Professional Translators",
        en: "1 Year Guarantee | Professional Translators",
        fr: "1 an de garantie | Traducteurs professionnels",
      },
    },

    fastDelivery: {
      recommendedTag: {
        default: "Recommended",
        en: "Recommended",
        fr: "Recommandé",
      },

      heading: {
        default: "Fast Delivery",
        en: "Fast Delivery",
        fr: "Livraison ultrarapide",
      },

      benifits: {
        default: "1 Year Guarantee | Professional Translators",
        en: "1 Year Guarantee | Professional Translators",
        fr: "Garantie d’un an | Traducteurs professionnels",
      },
    },

    tailoredText: {
      heading: {
        default: "Tailored",
        en: "Tailored",
        fr: "Sur mesure",
      },

      subtitle: {
        default:
          "A Tomedes expert will analyze your request and get back to you in a short time",
        en: "A Tomedes expert will analyze your request and get back to you in a short time",
        fr: "Un expert Tomedes analysera votre demande et vous répondra dans les plus brefs délais",
      },

      emailPlaceholder: {
        default: "Email Address",
        en: "Email Address",
        fr: "Courriel*",
      },

      messageToUser: {
        default: "*will only be used to contact you once",
        en: "*will only be used to contact you once",
        fr: "*ne seront utilisées que pour vous contacter",
      },
    },

    maxDeliveryTimeText: {
      default: "Max Delivery Time",
      en: "Max Delivery Time",
      fr: "Délai de livraison maximum",
    },

    pricePerWordtext: {
      default: "Price per word",
      en: "Price per word",
      fr: "Prix par mot :",
    },

    continueButtonText: {
      default: "Continue",
      en: "Continue",
      fr: "Continuer",
    },

    saveQuoteText: {
      default: "Save Quote",
      en: "Save Quote",
      fr: "ENREGISTRER VOTRE DEVIS",
    },

    saveQuoteModal: {
      title: {
        default: "Enter your email and we will send the quote to you",
        en: "Enter your email and we will send the quote to you",
        fr: "Add french translation",
      },

      submitButton: {
        default: "Submit",
        en: "Submit",
        fr: "Add french translation",
      },
    },

    backButtonText: {
      default: "< Edit Project Details",
      en: "< Edit Project Details",
      fr: "< Modifier les détails du projet",
    },
  },

  uploadFileModal: {
    heading: {
      default: "Upload Your Files",
      en: "Upload Your Files",
      fr: "Téléchargez vos fichiers",
    },

    message: {
      default:
        "Click to add your files (.pdf, .docx, .txt) Maximum File upload",
      en: "Click to add your files (.pdf, .docx, .txt) Maximum File upload",
      fr: "Add french translation",
    },

    size: {
      default: "size: 200mb",
      en: "size: 200mb",
      fr: "Add french translation",
    },

    button: {
      default: "Continue",
      en: "Continue",
      fr: "Continuer",
    },
  },

  orderStepThreeStaticData: {
    user: {
      default: "You're signed in as",
      en: "You're signed in as",
      fr: "Add french translation",
    },

    signOutText: {
      default: "Sign Out",
      en: "Sign Out",
      fr: "Add french translation",
    },

    signIn: {
      text1: {
        default: "Have an account?",
        en: "Have an account?",
        fr: "Add french translation",
      },

      link: {
        default: "Sign in",
        en: "Sign in",
        fr: "Add french translation",
      },

      text2: {
        default: "here.",
        en: "here.",
        fr: "Add french translation.",
      },
    },

    projectName: {
      label: {
        default: "Project Name",
        en: "Project Name",
        fr: "Nom du projet",
      },

      placeholder: {
        default: "Tomedes Project",
        en: "Tomedes Project",
        fr: "Add french translation",
      },
    },

    emailAddress: {
      label: {
        default: "Email Address",
        en: "Email Address",
        fr: "Adresse e-mail*",
      },

      placeholder: {
        default: "e.g. example@example.com",
        en: "e.g. example@example.com",
        fr: "Add french translation",
      },
    },

    fieldRequired: {
      default: "This field is required",
      en: "This field is required",
      fr: "Add french translation",
    },

    notesText: {
      label: {
        default: "Notes (Optional)",
        en: "Notes (Optional)",
        fr: "Add french translation",
      },

      placeholder: {
        default: "Additional information",
        en: "Additional information",
        fr: "Informations complémentaires...",
      },
    },

    wordCount: {
      label: {
        default: "Wordcount / Upload your file",
        en: "Wordcount / Upload your file",
        fr: "Nombre de mots / Téléchargez votre fichier",
      },

      placeholder: {
        default: "Number of words",
        en: "Number of words",
        fr: "Add french translation",
      },
    },

    noFiles: {
      label: {
        default: "I don't have files yet",
        en: "I don't have files yet",
        fr: "Je n’ai aucun fichier pour le moment",
      },
    },

    orderSummery: {
      heading: {
        default: "Order Summary",
        en: "Order Summary",
        fr: "SYNTHÈSE DE LA COMMANDE",
      },

      languagePair: {
        default: "Language Pair:",
        en: "Language Pair:",
        fr: "Paire de langues :",
      },

      wordCount: {
        default: "Wordcount:",
        en: "Wordcount:",
        fr: "Nombre de mots",
      },
      serviceType: {
        default: "Service Type:",
        en: "Service Type:",
        fr: "Type de service :",
      },
      deliveryDate: {
        default: "Delivery date:",
        en: "Delivery date:",
        fr: "Date de livraison :",
      },
      promotionalCode: {
        default: "Promotional Code:",
        en: "Promotional Code:",
        fr: "Code promotionnel :",
      },
      promocodePlaceholder: {
        default: "Enter promo code here",
        en: "Enter promo code here",
        fr: "Entrez votre code promotionnel ici",
      },
      applyButtonText: {
        default: "Apply",
        en: "Apply",
        fr: "Appliquer",
      },
      subTotal: {
        default: "Sub Total",
        en: "Sub Total",
        fr: "Sous-total :",
      },
      discount: {
        default: "Discount :",
        en: "Discount :",
        fr: "Add french translation (discount) :",
      },
      taxAmount: {
        default: "Tax Amount :",
        en: "Tax Amount :",
        fr: "Add french translation (tax amount) :",
      },
      totalOrder: {
        default: "Total Order",
        en: "Total Order",
        fr: "Commande complète :",
      },
      backButton: {
        default: "< Return to Purchase Options",
        en: "< Return to Purchase Options",
        fr: "< Retour aux options d’achat",
      },
      placeOrderButton: {
        default: "Place Order",
        en: "Place Order",
        fr: "Passer commande",
      },
      continueButton: {
        default: "Continue",
        en: "Continue",
        fr: "Continuer",
      },
    },
  },

  signInModal: {
    title: {
      default: "Sign in",
      en: "Sign in",
      fr: "Connexion",
    },

    subtitle: {
      default: "Sign in to your Tomedes account.",
      en: "Sign in to your Tomedes account.",
      fr: "Connectez-vous à votre compte Tomedes.",
    },

    emailPlaceholder: {
      default: "Email Address",
      en: "Email Address",
      fr: "Courriel",
    },

    passwordPlaceholder: {
      default: "Password",
      en: "Password",
      fr: "Mot de passe",
    },

    rememberMe: {
      default: "Remember me",
      en: "Remember me",
      fr: "Add french translation",
    },

    forgotPassword: {
      default: "Forgot Password",
      en: "Forgot Password",
      fr: "Mot de passe oublié ?",
    },

    signInButton: {
      default: "Sign in and Place Order",
      en: "Sign in and Place Order",
      fr: "Connectez-vous et passez commande",
    },

    trustMsg: {
      default: "Your information will be kept confidential",
      en: "Your information will be kept confidential",
      fr: "Add french translation",
    },
  },

  additionalStepFourData: {
    asGuest: {
      default: "Continue as Guest",
      en: "Continue as Guest",
      fr: "Continuer en tant qu’invité",
    },

    passwordText: {
      label: {
        default: "Password",
        en: "Password",
        fr: "Mot de passe",
      },

      placeholder: {
        default: "Password",
        en: "Password",
        fr: "Mot de passe",
      },
    },

    returnToPurchase: {
      default: "< Return to Purchase Options",
      en: "< Return to Purchase Options",
      fr: "< Retour aux options d’achat",
    },

    placeOrder: {
      default: "Place Order",
      en: "Place Order",
      fr: "Passer commande",
    },
  },

  popUps: {
    thankYou: {
      default: "show thank you popup",
      en: "show thank you popup",
      fr: "Add french translation",
    },
  },
};

export const NewsletterStripData = {
  title: {
    default: "Pay after delivery",
    en: "Pay after delivery",
    fr: "Vous payez après la livraison",
  },
  highlightWords: {
    default: ["after", "delivery"],
    en: ["after", "delivery"],
    fr: ["french", "translation"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "No need to pay now. Just send your email or phone number and we’ll get to work.",
    en: "No need to pay now. Just send your email or phone number and we’ll get to work.",
    fr: "Pas besoin d’anticiper votre paiement. Nous avons juste besoin de votre courriel ou de votre numéro de téléphone pour lancer votre projet.",
  },

  emailPlaceholder: {
    default: "Email Address",
    en: "Email Address",
    fr: "Courriel",
  },
  emailErrorMessage: {
    default: "This field is required",
    en: "This field is required",
    fr: "Ce champ est obligatoire",
  },
  submitButton: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "ENVOYER",
  },
};

export const GetHelpStripData = {
  title: {
    default: "Do you need help getting a quote?",
    en: "Do you need help getting a quote?",
    fr: "Vous souhaitez obtenir un devis ?",
  },
  subtitle: {
    default: "Contact us and we'll get you sorted out",
    en: "Contact us and we'll get you sorted out",
    fr: "N’hésitez pas à nous contacter, nos équipes se tiennent à votre disposition.",
  },

  contact: {
    avatar: {
      default: "https://via.placeholder.com/98x98.png?text=Tomedes",
      en: "https://via.placeholder.com/98x98.png?text=Tomedes",
      fr: "https://via.placeholder.com/98x98.png?text=Tomedes",
    },

    name: {
      default: "Name Here",
      en: "Name Here",
      fr: "David Hart",
    },

    postInCompany: {
      default: "Account Manager",
      en: "Account Manager",
      fr: "Chargé de clientèle",
    },

    phone: {
      default: "US: +1 985 239 0142 | UK: +44 1615 096140",
      en: "US: +1 985 239 0142 | UK: +44 1615 096140",
      fr: " États-Unis : +1 985 239 0142 | ROYAUME-UNI : +44 1615 096140",
    },

    email: {
      default: "support@tomedes.com",
      en: "support@tomedes.com",
      fr: "support@tomedes.com",
    },
  },
};

export const contactForQuote = {
  title: {
    default: "Do you need help getting a quote?",
    en: "Do you need help getting a quote?",
    fr: "Vous souhaitez obtenir un devis ?",
  },

  subtitle: {
    default: "Contact us and we'll get you sorted out",
    en: "Contact us and we'll get you sorted out",
    fr: " N’hésitez pas à nous contacter, nos équipes se tiennent à votre disposition.",
  },

  manager: {
    imageSource: "",
    altTag: "",
    name: {
      default: "Name Here",
      en: "Name Here",
      fr: "David Hart",
    },

    post: {
      default: "- Account Manager",
      en: "- Account Manager",
      fr: "- Chargé de clientèle",
    },

    country1: {
      default: "US:",
      en: "US:",
      fr: " États-Unis : ",
    },

    phoneNumber1: "+1 985 239 0142",

    country2: {
      default: "UK:",
      en: "UK:",
      fr: "Add french translation:",
    },

    phoneNumber2: "+44 1615 096140",

    emailAddress: "support@tomedes.com",
  },
};

export const isoCertificationsData = {
  title: "Three ISO Certifications For Quality Translations Every Time",
  certificates: [
    {
      id: 1,
      title: "ISO 9001:2015",
      icon: "iso9001:2015gold",
      className: "w-24 h-24 md:w-36 md:h-36",
    },
    {
      id: 2,
      title: "ISO 17100:2015",
      icon: "iso17100:2015gold",
      className: "w-24 h-24 md:w-36 md:h-36",
    },
    {
      id: 1,
      title: "ISO 18587:2017",
      icon: "iso18587:2017gold",
      className: "w-24 h-24 md:w-36 md:h-36",
    },
  ],
};

export const isoCertificationsMidSectionData = {
  title: "ISO Standards Provide Evidence of Quality of Translation",
  highlightWords: ["ISO Standards"],
  highlightedColor: "yellow",
  title2: {
    text: "In the Field of Translation, Tomedes Gives You Endless Possibilities",
    highlightWords: ["Endless Possibilities"],
    highlightedColor: "yellow",
  },
  paragraphs: [
    {
      text: "At Tomedes, we pride ourselves on being able to deliver high-quality language services that meet the needs of clients from all over the world. To this end, we have strived to improve our systems and hire the best talent.",
    },
    {
      text: "Which is why we are happy to say that our translation services are backed by ISO-certification. ISO is recognized as the highest authoritative non-government body when it comes to developing international standards. An ISO accreditation means that your company or organization meets stringent operational requirements required for global operations.",
    },
    {
      text: "We at Tomedes have ISO accreditation in three categories:",
    },
  ],
  certificatesDetails: [
    {
      title: "ISO 9001:2015 – Quality Management Systems",
      paragraphs: [
        {
          text: "This ISO certification pertains to best practices in quality management across all industries.",
        },
        {
          text: "Our operations are consistent—we are able to provide results that are not only fully compliant with international regulations, but also rate highly in terms of customer satisfaction.",
        },
      ],
      imageMobile: {
        title: "ISO 9001:2015",
        icon: "iso9001:2015gold",
        className: "xs:inline-block sm:hidden",
      },
      imageDesktop: {
        title: "ISO 9001:2015",
        icon: "iso9001:2015certificate",
        className: "xs:hidden sm:inline-block",
        href: "https://tomedes.gumlet.io/assets/ISO2020_9001.pdf",
      },
    },
  ],
};

export const thankYouPopUpData = {
  title: {
    default: "Thank You",
    en: "Thank You",
    fr: "Merci",
  },
  message: {
    default: "A member of LexTranscribe will get in touch with you shortly.",
    en: "A member of LexTranscribe will get in touch with you shortly.",
    fr: "Un membre de LexTranscribe vous contactera sous peu",
  },
  buttonTitle: {
    default: "Ok",
    en: "Ok",
    fr: "d'accord",
  },
};

export const customerReviewsData = {
  title: {
    default: "Customer Reviews",
    en: "Customer Reviews",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["Customer"],
    en: ["Customer"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "This page shows the reviews of our 95,000+ clients, which range from private individuals to small and medium businesses to large corporations to national and local governments. We're rated 4.9 out of 5 stars in our overall effort to broaden the horizons of our clients.",
    en: "This page shows the reviews of our 95,000+ clients, which range from private individuals to small and medium businesses to large corporations to national and local governments. We're rated 4.9 out of 5 stars in our overall effort to broaden the horizons of our clients.",
    fr: "Add french translation",
  },
  starSvgs: (
    <>
      <svg
        width="75px"
        height="75px"
        className="w-10 md:w-[75px]"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
      >
        <polygon
          fill="#FFCA28"
          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
        />
        <g>
          <polygon fill="#F9A825" points="24,25 31,17 24,4 &#9;" />
          <polygon fill="#F9A825" points="45,19 24,25 35,29 &#9;" />
          <polygon fill="#F9A825" points="37,44 24,25 24,37 &#9;" />
          <polygon fill="#F9A825" points="13,29 11,44 24,25 &#9;" />
          <polygon fill="#F9A825" points="3,19 24,25 17,17 &#9;" />
        </g>
      </svg>
      <svg
        width="75px"
        height="75px"
        className="w-10 md:w-[75px]"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
      >
        <polygon
          fill="#FFCA28"
          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
        />
        <g>
          <polygon fill="#F9A825" points="24,25 31,17 24,4 &#9;" />
          <polygon fill="#F9A825" points="45,19 24,25 35,29 &#9;" />
          <polygon fill="#F9A825" points="37,44 24,25 24,37 &#9;" />
          <polygon fill="#F9A825" points="13,29 11,44 24,25 &#9;" />
          <polygon fill="#F9A825" points="3,19 24,25 17,17 &#9;" />
        </g>
      </svg>
      <svg
        width="75px"
        height="75px"
        className="w-10 md:w-[75px]"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
      >
        <polygon
          fill="#FFCA28"
          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
        />
        <g>
          <polygon fill="#F9A825" points="24,25 31,17 24,4 &#9;" />
          <polygon fill="#F9A825" points="45,19 24,25 35,29 &#9;" />
          <polygon fill="#F9A825" points="37,44 24,25 24,37 &#9;" />
          <polygon fill="#F9A825" points="13,29 11,44 24,25 &#9;" />
          <polygon fill="#F9A825" points="3,19 24,25 17,17 &#9;" />
        </g>
      </svg>
      <svg
        width="75px"
        height="75px"
        className="w-10 md:w-[75px]"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
      >
        <polygon
          fill="#FFCA28"
          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
        />
        <g>
          <polygon fill="#F9A825" points="24,25 31,17 24,4 &#9;" />
          <polygon fill="#F9A825" points="45,19 24,25 35,29 &#9;" />
          <polygon fill="#F9A825" points="37,44 24,25 24,37 &#9;" />
          <polygon fill="#F9A825" points="13,29 11,44 24,25 &#9;" />
          <polygon fill="#F9A825" points="3,19 24,25 17,17 &#9;" />
        </g>
      </svg>
      <svg
        width="75px"
        height="75px"
        className="w-10 md:w-[75px]"
        x="0px"
        viewBox="0 0 48 48"
        enableBackground="new 0 0 48 48"
      >
        <polygon
          fill="#FFCA28"
          points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
        />
        <g>
          <polygon fill="#F9A825" points="24,25 31,17 24,4 &#9;" />
          <polygon fill="#F9A825" points="45,19 24,25 35,29 &#9;" />
          <polygon fill="#F9A825" points="37,44 24,25 24,37 &#9;" />
          <polygon fill="#F9A825" points="13,29 11,44 24,25 &#9;" />
          <polygon fill="#F9A825" points="3,19 24,25 17,17 &#9;" />
        </g>
      </svg>
    </>
  ),
  ratingText: {
    default: "4.9 out of 5 stars (1,798 overall reviews)",
    en: "4.9 out of 5 stars (1,798 overall reviews)",
    fr: "Add french translation",
  },
  testimonials: [
    {
      id: 1,
      title: {
        default: `"Speedy return & reasonably priced"`,
        en: '"Speedy return & reasonably priced"',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "A translation company well equipped with knowledge of hundreds of different languages - speedy return & reasonably priced.",
        en: "A translation company well equipped with knowledge of hundreds of different languages - speedy return & reasonably priced.",
        fr: "Add french translation",
      },
      user: {
        default: "Katherine Lindsay",
        en: "Katherine Lindsay",
        fr: "Add french translation",
      },
      link: "https://www.trustpilot.com/users/60db02325f811c001128d575",
      icon: {
        title: {
          default: "Ashrena Ali",
          en: "Ashrena Ali",
          fr: "Add french translation",
        },
        icon: "bbc-white",
      },
    },
    {
      id: 2,
      title: {
        default:
          '"Tomedes has been nothing but kind, knowledgeable and efficient!"',
        en: '"Tomedes has been nothing but kind, knowledgeable and efficient!"',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "Tomedes has been nothing but kind, knowledgeable and efficient!...Everything was seamless! I trusted Tomedes so much they’re now working...with an even bigger project: interpreting a multi-language Zoom meeting!",
        en: "Tomedes has been nothing but kind, knowledgeable and efficient!...Everything was seamless! I trusted Tomedes so much they’re now working...with an even bigger project: interpreting a multi-language Zoom meeting!",
        fr: "Add french translation",
      },
      user: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      link: "https://www.trustpilot.com/users/60945782a8fc63001b6f847b",
      icon: {
        title: {
          default: "Ashrena Ali",
          en: "Ashrena Ali",
          fr: "Add french translation",
        },
        icon: "ashrena",
        className: "w-9 h-9",
      },
    },
    {
      id: 3,
      title: {
        default: '"Efficient and very good customer service."',
        en: '"Efficient and very good customer service."',
        fr: '"Add french translation"',
      },
      description: {
        default:
          "The Tomedes team was very responsive and quick to help us address any issues related to timeline and quality of translation...I would recommend the Tomedes team to any computer science curriculum providers.",
        en: "The Tomedes team was very responsive and quick to help us address any issues related to timeline and quality of translation...I would recommend the Tomedes team to any computer science curriculum providers.",
        fr: "Add french translation",
      },
      user: {
        default: "Jorge Castro",
        en: "Jorge Castro",
        fr: "Add french translation",
      },
      link: "https://www.trustpilot.com/reviews/61b11ffd2b49257fe29a48fa",
      icon: {
        title: {
          default: "Ashrena Ali",
          en: "Ashrena Ali",
          fr: "Add french translation",
        },
        icon: "code",
        className: "w-9 h-9",
      },
    },
  ],
};

export const languesCustomerReviewsData = {
  title: {
    default: "Add default translation",
    en: "Add English translation",
    fr: "Nos clients en parlent le mieux",
  },
  highlightWords: {
    default: ["default"],
    en: ["English"],
    fr: [" "],
  },
  highlightedColor: "yellow",
  overAllRating: {
    rating: 4.9,
    subtitle: {
      default: "Add default translation",
      en: "Add English translation",
      fr: "sur 5 étoiles",
    },
  },
  starSvgs: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="260.06"
        height="46.535"
        viewBox="0 0 260.06 46.535"
      >
        <g transform="translate(0.03 0.034)">
          <path
            className="a"
            fill="#ffd511"
            d="M580.842,259.432l2.431-16.555L572.1,230.936l15.73-2.678,7.358-14.859,7.286,14.891,15.71,2.756-11.225,11.888,2.36,16.568L595.1,251.95l-14.261,7.481Z"
            transform="translate(-518.593 -213.231)"
          />
          <path
            className="b"
            fill="#ffd511"
            d="M663.092,259.446,665.53,242.9,654.35,230.97l15.736-2.678,7.351-14.852,7.286,14.885,15.723,2.756-11.225,11.882,2.366,16.555-14.228-7.546-14.26,7.475Z"
            transform="translate(-547.382 -213.245)"
          />
          <path
            className="b"
            fill="#ffd511"
            d="M745.352,259.742l2.431-16.555-11.173-11.94,15.73-2.678L759.7,213.71l7.286,14.891,15.716,2.756-11.225,11.888,2.359,16.568-14.221-7.566-14.3,7.481Z"
            transform="translate(-576.174 -213.339)"
          />
          <path
            className="b"
            fill="#ffd511"
            d="M852.093,257.1l-10.25-5.434-14.261,7.475h0l2.438-16.549-11.18-11.94L834.589,228l7.351-14.859L849.227,228l2.73.474"
            transform="translate(-604.956 -213.14)"
          />
          <path
            className="c"
            fill="#cfb53b"
            d="M869.79,236.74l13,2.281L871.551,250.91l2.366,16.549-3.991-2.1"
            transform="translate(-622.789 -221.4)"
          />
          <path
            className="a"
            fill="#ffd511"
            d="M512.913,213.41l-7.358,14.807-15.775,2.71,11.232,11.908-2.424,16.555,14.228-7.455,14.235,7.553-2.327-16.555,11.232-11.908-15.782-2.71-7.26-14.9Z"
            transform="translate(-489.78 -213.234)"
          />
        </g>
      </svg>
    </>
  ),
  ratingText: {
    default: "Add default tranlation",
    en: "Add English translation",
    fr: "Overall rating of 1798 reviews",
  },
  testimonials: [
    {
      id: 1,
      comment: {
        default: "Add default translation",
        en: "Add English translation",
        fr: `"J'ai sollicité Tomedes pour traduire un document très complexe du japonais à l'anglais. Le service était très compétent et les prix très abordables malgré la complexité du projet. Je n'aurais pas pu demander mieux !"`,
      },
      name: {
        default: "Marie M.",
        en: "Marie M.",
        fr: "Marie M.",
      },
      date: "21/12/2020",
      starRating: 5,
    },
    {
      id: 2,
      comment: {
        default: "Add default translation",
        en: "Add English translation",
        fr: `"Tomedes a été génial ! J'avais des délais à respecter. L'équipe était toujours disponible lorsque j'avais des questions. Service rapide, efficace et fiable. Je recommande vivement."`,
      },
      name: {
        default: "Karen W.",
        en: "Karen W.",
        fr: "Karen W.",
      },
      date: "01/12/2020",
      starRating: 5,
    },
    {
      id: 3,
      comment: {
        default: "Add default translation",
        en: "Add English translation",
        fr: `"Dommage que je n'aie pas sollicité le service de Tomedes plus tôt. C'est à cela que doit ressembler une agence de traduction. Pas de retard, problèmes de qualité ou malentendus. Je recommande donc chaleureusement et ferai appel à leur service à nouveau."`,
      },
      name: {
        default: "Paul F.",
        en: "Paul F.",
        fr: "Paul F.",
      },
      date: "20/11/2020",
      starRating: 5,
    },
  ],
};

export const checkOurReviewsData = {
  heading: {
    default: "Check us out in all our External Review Platforms",
    en: "Check us out in all our External Review Platforms",
    fr: "Add french translation",
  },
};

export const allReviewsData = {
  title: {
    text: {
      default: "All Reviews",
      en: "All Reviews",
      fr: "Add french translation",
    },
    highlightWords: ["All"],
    highlightedColor: "yellow",
  },
  subtitle: {
    default:
      "Our client satisfaction rate is 98%, specifically because we put the client at the heart of our philosophy. These are the reviews of the customers who have been satisfied with our service",

    en: "Our client satisfaction rate is 98%, specifically because we put the client at the heart of our philosophy. These are the reviews of the customers who have been satisfied with our service",

    fr: "Add french translation",
  },
};

export const qualityPolicyData = {
  banner: {
    title: {
      default: "Quality at Every Step: The Tomedes Guarantee",
      en: "Quality at Every Step: The Tomedes Guarantee",
      fr: "Add french translation",
    },
    description: {
      default:
        "At Tomedes, ensuring that our clients are satisfied with our work is not just a passion, but an obsession. This is why we have continuously strived to bring the quality of our language services up to exacting, institutionally-recognized global standards. With 95,000+ clients served and a 98% satisfaction rate, we can confidently say that we have the foundation to provide you with services of the highest quality, every single time.",
      en: "At Tomedes, ensuring that our clients are satisfied with our work is not just a passion, but an obsession. This is why we have continuously strived to bring the quality of our language services up to exacting, institutionally-recognized global standards. With 95,000+ clients served and a 98% satisfaction rate, we can confidently say that we have the foundation to provide you with services of the highest quality, every single time.",
      fr: "Add french translation",
    },
    buttonTitle: {
      default: "Contact us",
      en: "Contact us",
      fr: "Add french",
    },
  },
  isoCertifications: {
    title: {
      default: "Fully ISO-Certified",
      en: "Fully ISO-Certified",
      fr: "Add french translation",
    },
    highlightWords: {
      default: ["Certified"],
      en: ["Certified"],
      fr: ["french"],
    },
    highlightedColor: "yellow",
    description: {
      default:
        "Our commitment to quality is recognized by ISO, the International Organization for Standardization. ISO is the highest authoritative body in developing global industry standards and bestowing accreditation on companies and institutions that meet them around the world.",
      en: "Our commitment to quality is recognized by ISO, the International Organization for Standardization. ISO is the highest authoritative body in developing global industry standards and bestowing accreditation on companies and institutions that meet them around the world.",
      fr: "Add french translation",
    },
    subDescription1: {
      default:
        "Tomedes is fully ISO-certified in three categories relevant to language service providers.",
      en: "Tomedes is fully ISO-certified in three categories relevant to language service providers.",
      fr: "Add french translation",
    },
    href: "/iso-certifications",
    subDescription2: {
      default: "to learn more.",
      en: "to learn more.",
      fr: "Add french translation",
    },
  },
  qualityAssurance: {
    title: {
      default: "Our three-part approach to quality assurance",
      en: "Our three-part approach to quality assurance",
      fr: "Add french translation",
    },
    highlightWords: {
      default: ["quality assurance"],
      en: ["quality assurance"],
      fr: ["french"],
    },
    highlightedColor: "yellow",
    description: {
      default:
        "At Tomedes, we believe that the pursuit of quality requires a holistic perspective. Quality is something that can only be gained by seeking it at every step of the process—in line with this principle, we take a three-part approach to quality assurance that covers not only the duration of the project, but also what comes before and after.",
      en: "At Tomedes, we believe that the pursuit of quality requires a holistic perspective. Quality is something that can only be gained by seeking it at every step of the process—in line with this principle, we take a three-part approach to quality assurance that covers not only the duration of the project, but also what comes before and after.",
      fr: "Add french translation",
    },
    imgurl: "https://tomedes.gumlet.io/assets/quality-policy/image_1.webp",
    items: [
      {
        title: {
          default: "Comprehensive vendor management process",
          en: "Comprehensive vendor management process",
          fr: "Add french translation",
        },
        highlightWords: {
          default: ["Comprehensive"],
          en: ["Comprehensive"],
          fr: ["french"],
        },
        highlightedColor: "yellow",
        description: {
          default:
            "Before the project has even begun, we already set the stage for quality through rigorous and comprehensive vendor management. Our vendor management team has scouted some of the best linguistic talent out there, creating our network of 20,000+ language professionals with a diverse repertoire of language skills and professional backgrounds.</br>This allows us to vet and select the right people for your project with accuracy and ease. Each one has been carefully verified with appropriate background checks to attest their qualifications and routine skill tests to determine the quality of their work.",
          en: "Before the project has even begun, we already set the stage for quality through rigorous and comprehensive vendor management. Our vendor management team has scouted some of the best linguistic talent out there, creating our network of 20,000+ language professionals with a diverse repertoire of language skills and professional backgrounds.</br>This allows us to vet and select the right people for your project with accuracy and ease. Each one has been carefully verified with appropriate background checks to attest their qualifications and routine skill tests to determine the quality of their work.",
          fr: "Add french translation",
        },
      },
      {
        title: {
          default: "Our project  quality assurance cycle",
          en: "Our project  quality assurance cycle",
          fr: "Add french translation",
        },
        highlightWords: {
          default: ["quality assurance cycle"],
          en: ["quality assurance cycle"],
          fr: ["french"],
        },
        highlightedColor: "yellow",
        description: {
          default:
            "Attention to quality is maintained in our language projects through the QA cycle proper. Our standard QA process involves multiple automated and human checks before the final documents are handed back to the client. We use top-of-the-line language QA management tools like xBench as well as our own proprietary tools to conduct automated checks and manage revisions.</br>Our full QA suite includes options for further review by another language professional. You can view the entire process below:",
          en: "Attention to quality is maintained in our language projects through the QA cycle proper. Our standard QA process involves multiple automated and human checks before the final documents are handed back to the client. We use top-of-the-line language QA management tools like xBench as well as our own proprietary tools to conduct automated checks and manage revisions.</br>Our full QA suite includes options for further review by another language professional. You can view the entire process below:",
          fr: "Add french translation",
        },
      },
    ],
    steps: [
      {
        title: {
          default: "Translation",
          en: "Translation",
          fr: "Add french",
        },
      },
    ],
  },
};

export const servicePagFAQsData = {
  title: {
    default: "FAQs",
    en: "FAQs",
    fr: "Add french",
  },
  description: {
    default:
      " Got a question? No problem. We’ve covered the most common queries below.",
    en: " Got a question? No problem. We’ve covered the most common queries below.",
    fr: "Add french",
  },
  accordionItems: [
    {
      heading: {
        default:
          "How are we able to provide you with translation services on a 24/7 basis?",
        en: "How are we able to provide you with translation services on a 24/7 basis?",
        fr: "Add french",
      },
      description: {
        default:
          "Globalization and modern technology are wonderful, aren’t they? As our team works largely remotely, we are free to strategically recruit our translators, customer support staff and other team members from locations around the world. This means that we can follow the sun, with team members online in different time zones at different times.</br></br> As such, our online translation services are available 24/7. We work around the clock, so that whenever you need us, we’re right here, working on your translations and providing full support. Goodbye, old fashioned eight-hour day. Hello, seamless 24/7 service.",
        en: "Globalization and modern technology are wonderful, aren’t they? As our team works largely remotely, we are free to strategically recruit our translators, customer support staff and other team members from locations around the world. This means that we can follow the sun, with team members online in different time zones at different times.</br></br> As such, our online translation services are available 24/7. We work around the clock, so that whenever you need us, we’re right here, working on your translations and providing full support. Goodbye, old fashioned eight-hour day. Hello, seamless 24/7 service.",
        fr: "Add french",
      },
    },
    {
      heading: {
        default: "What does our one-year guarantee mean?",
        en: "What does our one-year guarantee mean?",
        fr: "Add french",
      },
      description: {
        default:
          "Our one-year guarantee means you can enjoy peace of mind. It applies to every translation we provide. If there’s anything you’re unhappy with about your translation, for up to a year after we deliver it to you, just let us know and we’ll correct it right away. It’s part of our commitment to being a translation company that provides a thorough, attentive service every step of the way.",
        en: "Our one-year guarantee means you can enjoy peace of mind. It applies to every translation we provide. If there’s anything you’re unhappy with about your translation, for up to a year after we deliver it to you, just let us know and we’ll correct it right away. It’s part of our commitment to being a translation company that provides a thorough, attentive service every step of the way.",
        fr: "Add french",
      },
    },
  ],
};

export const privacyData = {
  title: {
    default: "PRIVACY",
    en: "PRIVACY",
    fr: "Add french translation",
  },
  subtitle: {
    default:
      "PLEASE READ THE FOLLOWING CAREFULLY. THE AFOREMENTIONED IS THE PRIVACY POLICY THAT GOVERNS YOUR USE OF ANY TOMEDES SERVIC",
    en: "PLEASE READ THE FOLLOWING CAREFULLY. THE AFOREMENTIONED IS THE PRIVACY POLICY THAT GOVERNS YOUR USE OF ANY TOMEDES SERVIC",
    fr: "Add french translation",
  },
  description: {
    default:
      "Our email privacy policy demonstrates our firm commitment to your privacy and the protection of your information.<br /><br />This Privacy Policy ('Privacy Policy') applies to Tomedes.com <br /><br />As revised on: November 1, 2020 <br /><br />At Tomedes, we recognize the privacy needs of our Customers. You should be able to choose what information you want to share and decide what will happen to that information once it has been shared. Protecting your personal information is vitally important. Please read the following Privacy Policy to understand how your personal information will be treated as you make full use of our many offerings. This policy may change from time to time without notice so please check back periodically. We hope this will increase your awareness about online privacy.",
    en: "Our email privacy policy demonstrates our firm commitment to your privacy and the protection of your information.<br /><br />This Privacy Policy ('Privacy Policy') applies to Tomedes.com <br /><br />As revised on: November 1, 2020 <br /><br />At Tomedes, we recognize the privacy needs of our Customers. You should be able to choose what information you want to share and decide what will happen to that information once it has been shared. Protecting your personal information is vitally important. Please read the following Privacy Policy to understand how your personal information will be treated as you make full use of our many offerings. This policy may change from time to time without notice so please check back periodically. We hope this will increase your awareness about online privacy.",
    fr: "Add french translation",
  },
  items: [
    {
      title: {
        default: "Collected Information",
        en: "Collected Information",
        fr: "Add french translation",
      },
      description: {
        default:
          "If you choose to use and or purchase a Tomedes product or place an order with us, we may ask you to provide us with certain personal information, such as your name, physical and electronic mail ('e-mail') addresses, phone number, domain name and other information that by itself, or in combination with other information, may be identifiable to you as a specific individual. We may also ask for financial information, such as account or credit card numbers, and demographic information, such as your zip code. <br /><br />Please be aware that Tomedes advertisers, and web sites that have links on our sites, and provider/distributor partners may also collect personally identifiable information about you. The information practices of these Internet access partners, advertisers, and web sites linked to Tomedes and provider/distributor partners, are not governed by this Privacy Policy. What these other sites do with that information is governed by the privacy policy for that site and not this policy. You are encouraged to review the privacy policy on any site you visit.",
        en: "If you choose to use and or purchase a Tomedes product or place an order with us, we may ask you to provide us with certain personal information, such as your name, physical and electronic mail ('e-mail') addresses, phone number, domain name and other information that by itself, or in combination with other information, may be identifiable to you as a specific individual. We may also ask for financial information, such as account or credit card numbers, and demographic information, such as your zip code. <br /><br />Please be aware that Tomedes advertisers, and web sites that have links on our sites, and provider/distributor partners may also collect personally identifiable information about you. The information practices of these Internet access partners, advertisers, and web sites linked to Tomedes and provider/distributor partners, are not governed by this Privacy Policy. What these other sites do with that information is governed by the privacy policy for that site and not this policy. You are encouraged to review the privacy policy on any site you visit.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Information Requests",
        en: "Information Requests",
        fr: "Add french translation",
      },
      description: {
        default:
          "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        en: "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Security",
        en: "Security",
        fr: "Add french translation",
      },
      description: {
        default:
          "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer ('SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        en: "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer ('SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Children's Guidelines",
        en: "Children's Guidelines",
        fr: "Add french translation",
      },
      description: {
        default:
          "Although some of Tomedes sites are not geared towards children, Tomedes nonetheless attempts to protect children. Tomedes must, however, rely on the information provided to us by visitors to our sites. As a result, it is impossible for us to guarantee with absolute certainty that the information collected and utilized by Tomedes is not derived from a child.",
        en: "Although some of Tomedes sites are not geared towards children, Tomedes nonetheless attempts to protect children. Tomedes must, however, rely on the information provided to us by visitors to our sites. As a result, it is impossible for us to guarantee with absolute certainty that the information collected and utilized by Tomedes is not derived from a child.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Disclosure",
        en: "Disclosure",
        fr: "Add french translation",
      },
      description: {
        default:
          "Tomedes <br />will not sell, rent, trade, or disclose individual Customer information to any third parties or outside companies who will use the information to contact you or who will share the information with others without your permission. It may be necessary to disclose information in special cases when we have reason to believe that disclosing the information is necessary to identify, contact or bring legal action against someone who may be violating Tomedes policies or may be causing injury to or interference with (either intentionally or unintentionally) the rights or property of Tomedes, other Tomedes users, or anyone else that could be harmed by such activities. Tomedes may disclose or access account information when we believe in good faith that the law requires it or for administrative and other purposes that we deem necessary to maintain, service, and improve our products and Services.",
        en: "Tomedes <br />will not sell, rent, trade, or disclose individual Customer information to any third parties or outside companies who will use the information to contact you or who will share the information with others without your permission. It may be necessary to disclose information in special cases when we have reason to believe that disclosing the information is necessary to identify, contact or bring legal action against someone who may be violating Tomedes policies or may be causing injury to or interference with (either intentionally or unintentionally) the rights or property of Tomedes, other Tomedes users, or anyone else that could be harmed by such activities. Tomedes may disclose or access account information when we believe in good faith that the law requires it or for administrative and other purposes that we deem necessary to maintain, service, and improve our products and Services.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Use of Information",
        en: "Use of Information",
        fr: "Add french translation",
      },
      description: {
        default:
          "The use of an individual's e-mail address is necessary to keep our Customers well informed of maintenance issues, escalated critical issues and problem resolutions that may arise with your Tomedes Service. We may also use e-mail addresses to provide our Customers with informative newsletters.<br /><br />We like to keep our Customers informed via e-mail and other means. Sometimes Tomedes uses personal and demographic information to help us determine which Tomedes products and Services are most likely to be of interest to you or help diagnose problems with our servers or administration of our sites. We also use demographic information to gather general interest in our products, to help in the analysis of product usage, purchasing, and target markets.<br /><br />Please note that Tomedes does provide information to outside companies (such as a credit card processing company) who perform certain functions on our behalf for billing purposes. We will not permit those companies to use the gathered information for other than the stated purpose.",
        en: "The use of an individual's e-mail address is necessary to keep our Customers well informed of maintenance issues, escalated critical issues and problem resolutions that may arise with your Tomedes Service. We may also use e-mail addresses to provide our Customers with informative newsletters.<br /><br />We like to keep our Customers informed via e-mail and other means. Sometimes Tomedes uses personal and demographic information to help us determine which Tomedes products and Services are most likely to be of interest to you or help diagnose problems with our servers or administration of our sites. We also use demographic information to gather general interest in our products, to help in the analysis of product usage, purchasing, and target markets.<br /><br />Please note that Tomedes does provide information to outside companies (such as a credit card processing company) who perform certain functions on our behalf for billing purposes. We will not permit those companies to use the gathered information for other than the stated purpose.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Correct/Update",
        en: "Correct/Update",
        fr: "Add french translation",
      },
      description: {
        default:
          "If you would like to change or modify information you have previously provided to us, please contact us",
        en: "If you would like to change or modify information you have previously provided to us, please contact us",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Cookies",
        en: "Cookies",
        fr: "Add french translation",
      },
      description: {
        default:
          "Some of the websites we host place small bits of text or 'cookies' onto your computer's hard drive. Cookies enable us to deliver content specific to your interests and keep track of your password so you do not have to re-enter it each time you visit our web sites. After you accept a cookie, it is passed from your browser to our servers each time you request a page. This cookie consists of a unique token that anonymously identifies to the server so that you can more easily access the features of the Tomedes Service. Please note that you may configure your web browser to warn you before you accept a cookie.",
        en: "Some of the websites we host place small bits of text or 'cookies' onto your computer's hard drive. Cookies enable us to deliver content specific to your interests and keep track of your password so you do not have to re-enter it each time you visit our web sites. After you accept a cookie, it is passed from your browser to our servers each time you request a page. This cookie consists of a unique token that anonymously identifies to the server so that you can more easily access the features of the Tomedes Service. Please note that you may configure your web browser to warn you before you accept a cookie.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Customer E-mails",
        en: "Customer E-mails",
        fr: "Add french translation",
      },
      description: {
        default:
          "Tomedes will not read or disclose e-mail content to others unless required by law or deemed necessary to operate our services.",
        en: "Tomedes will not read or disclose e-mail content to others unless required by law or deemed necessary to operate our services.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Contacting the Web Site",
        en: "Contacting the Web Site",
        fr: "Add french translation",
      },
      description: {
        default:
          "If you have any questions about Tomedes privacy policy or the privacy practices of our web sites, please contact us",
        en: "If you have any questions about Tomedes privacy policy or the privacy practices of our web sites, please contact us",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "Changes to the Privacy Policy",
        en: "Changes to the Privacy Policy",
        fr: "Add french translation",
      },
      description: {
        default:
          "In the event our Privacy Policy needs to be modified, those changes will be reflected in the next revision of this Privacy Policy which will be posted on the Tomedes web site. Please check back often to review any revisions.",
        en: "In the event our Privacy Policy needs to be modified, those changes will be reflected in the next revision of this Privacy Policy which will be posted on the Tomedes web site. Please check back often to review any revisions.",
        fr: "Add french translation",
      },
    },
  ],
};

export const recentTranslationHeroBannerData = {
  title: {
    default: "Professional Translation Services On A Global Scale",
    en: "Professional Translation Services On A Global Scale",
    fr: "Nos derniers projets de traduction",
  },
  description: {
    default:
      "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    en: "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    fr: "Traductions assermentées, traductions juridiques ou médicales, traduction de certificat de mariage, processus de localisation d'application mobile, traduction de sous-titres, découvrez quelques uns de nos récents projets.",
  },
  buttonDetails: {
    text: {
      default: "TRANSLATE NOW",
      en: "TRANSLATE NOW",
      fr: "DEMANDE DE DEVIS",
    },
    link: "/quote",
  },
  svgsTitle: {
    default: "Trusted by Satisfied Clients Worldwide",
    en: "Trusted by Satisfied Clients Worldwide",
    fr: "Add french translation",
  },
  seal: [
    {
      icon: "guarantee",
      text: {
        default: "1 Year Guarantee",
        en: "1 Year Guarantee",
        fr: "1 an de garantie",
      },
    },
    {
      icon: "availability",
      text: {
        default: "24/7 Availability",
        en: "24/7 Availability",
        fr: "Service client 24h/24 - 7j/7",
      },
    },
    {
      icon: "rapid-delivery",
      text: {
        default: "Rapid Delivery",
        en: "Rapid Delivery",
        fr: "Livraison express",
      },
    },
  ],
  enquiry_form: {
    title: {
      default: "Parlez-nous de vous et de votre projet",
      en: "Add english translation",
      fr: "Obtenez votre devis gratuit",
    },
    highlightWords: {
      default: ["Parlez-nous"],
      en: ["Parlez-nous"],
      fr: ["Obtenez"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default:
        "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
      en: "Add english translation",
      fr: "Un projet en cours, un besoin spécifique? Envoyez-nous un message, nous vous répondons en moins de 30 minutes !",
    },
    placeholder: {
      name: {
        default: "Name",
        en: "Name",
        fr: "Nom complet",
      },
      email: {
        default: "Email Address",
        en: "Email Address",
        fr: "Adresse e-mail",
      },
      tellUs: {
        default: "Tell us more about your needs",
        en: "Tell us more about your needs",
        fr: "En quoi pouvons-nous vous aider ?",
      },
    },
    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "ENVOYER",
    },
  },
};

export const recentTranslationServiceClientsData = {
  title: {
    default: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
    en: "Trusted by 95,000+ Satisfied </br> Clients Worldwide",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["95,000"],
    en: ["95,000"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
    en: "At Tomedes, we work round the clock to provide you with the right service. Each member of our translation team ensures consistent quality across languages. Each linguist handles thousands of projects each year. This dedication to each translation project is shown in our 98% customer satisfaction rate from 95,000 clients.",
    fr: "Add french translation",
  },
  clients: [
    {
      id: 1,
      title: {
        default: "Amazon",
        en: "Amazon",
        fr: "Add french translation",
      },
      icon: "amazon-white",
      className: "w-32 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Google",
        en: "Google",
        fr: "Add french translation",
      },
      icon: "google",
      className: "w-24 h-auto",
    },
    {
      id: 3,
      title: {
        default: "Microsoft",
        en: "Microsoft",
        fr: "Add french translation",
      },
      icon: "microsoft-white",
      className: "w-28 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Youtube",
        en: "Youtube",
        fr: "Add french translation",
      },
      icon: "youtube-white",
      className: "w-24 h-auto",
    },
    {
      id: 5,
      title: {
        default: "Hp",
        en: "Hp",
        fr: "Add french translation",
      },
      icon: "hp",
      className: "w-10 h-auto",
    },
    {
      id: 6,
      title: {
        default: "SAP",
        en: "SAP",
        fr: "Add french translation",
      },
      icon: "sap",
      className: "w-12 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Bloomberg",
        en: "Bloomberg",
        fr: "Add french translation",
      },
      icon: "bloomberg-white",
      className: "w-24 h-auto",
    },
    {
      id: 8,
      title: {
        default: "Spotify",
        en: "Spotify",
        fr: "Add french translation",
      },
      icon: "spotify",
      className: "w-28 h-auto",
    },
    {
      id: 9,
      title: {
        default: "Wix",
        en: "Wix",
        fr: "Add french translation",
      },
      icon: "wix-white",
      className: "w-24 h-auto",
    },
    {
      id: 10,
      title: {
        default: "HSBC",
        en: "HSBC",
        fr: "Add french translation",
      },
      icon: "hsbc-white",
      className: "w-24 h-auto",
    },
    {
      id: 11,
      title: {
        default: "MGM",
        en: "MGM",
        fr: "Add french translation",
      },
      icon: "mgm",
      className: "w-12 h-auto",
    },
  ],
};
export const reviewsServiceClientsData = {
  title: {
    default: "Trusted by Business Customers Worldwide",
    en: "Trusted by Business Customers Worldwide",
    fr: "Add french translation",
  },
  highlightWords: {
    default: ["Worldwide"],
    en: ["Worldwide"],
    fr: ["french"],
  },
  highlightedColor: "regal-blue",
  subtitle: {
    default:
      "95,000 clients have entrusted Tomedes with their business. These include private individuals, small to medium businesses, and the largest corporations, leading brands, national and local governments. But most importantly: we're here for you. Right now.",
    en: "95,000 clients have entrusted Tomedes with their business. These include private individuals, small to medium businesses, and the largest corporations, leading brands, national and local governments. But most importantly: we're here for you. Right now.",
    fr: "Add french translation",
  },
  clients: [
    {
      id: 1,
      title: {
        default: "Amazon",
        en: "Amazon",
        fr: "Add french translation",
      },
      icon: "amazon-white",
      className: "w-28 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Google",
        en: "Google",
        fr: "Add french translation",
      },
      icon: "google",
      className: "w-24 h-auto",
    },
    {
      id: 3,
      title: {
        default: "Microsoft",
        en: "Microsoft",
        fr: "Add french translation",
      },
      icon: "microsoft-white",
      className: "w-28 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Youtube",
        en: "Youtube",
        fr: "Add french translation",
      },
      icon: "youtube-white",
      className: "w-24 h-auto",
    },
    {
      id: 5,
      title: {
        default: "Hp",
        en: "Hp",
        fr: "Add french translation",
      },
      icon: "hp",
      className: "w-10 h-10 h-auto",
    },
    {
      id: 6,
      title: {
        default: "SAP",
        en: "SAP",
        fr: "Add french translation",
      },
      icon: "sap",
      className: "w-12 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Bloomberg",
        en: "Bloomberg",
        fr: "Add french translation",
      },
      icon: "bloomberg-white",
      className: "w-24 h-auto",
    },
    {
      id: 8,
      title: {
        default: "Spotify",
        en: "Spotify",
        fr: "Add french translation",
      },
      icon: "spotify",
      className: "w-28 h-auto",
    },
    {
      id: 9,
      title: {
        default: "Wix",
        en: "Wix",
        fr: "Add french translation",
      },
      icon: "wix-white",
      className: "w-24 h-auto",
    },
    {
      id: 10,
      title: {
        default: "HSBC",
        en: "HSBC",
        fr: "Add french translation",
      },
      icon: "hsbc-white",
      className: "w-24 h-auto",
    },
    {
      id: 11,
      title: {
        default: "MGM",
        en: "MGM",
        fr: "Add french translation",
      },
      icon: "mgm",
      className: "w-11 h-auto",
    },
    {
      id: 12,
      title: {
        default: "Canon",
        en: "Canon",
        fr: "Add french translation",
      },
      icon: "canon-white",
      className: "w-24 h-auto",
    },
  ],
};

export const userAgreementData = {
  title: {
    default: "USER AGREEMENT",
    en: "USER AGREEMENT",
    fr: "Add french translation",
  },
  subtitle: {
    default: "STANDARD USER AGREEMENT",
    en: "STANDARD USER AGREEMENT",
    fr: "Add french translation",
  },
  description: {
    default:
      "This document is a legal agreement between you, the 'User' (as defined below) and Tomedes. These User's Terms and Conditions ('Agreement') sets forth the provisions under which the User may register and use the web-site for the purpose of responding to solicitations for the acquisition of solutions, services, and products ,providing these solutions, services, and products and taking care of requested revisions of the software solutions, services, and products.<br /><br />DEFINITIONS Site (s): Tomedes Ltd: (if applicable) is the parent company and owner of the site hereinafter referred to as Tomedes. User: Individual (s) or a Company posting a project.<br /><br />Provider: Individual (s) or a Company providing a service.",
    en: "",
    fr: "Add french translation",
  },
  items: [
    {
      title: {
        default: "1. TERM",
        en: "1. TERM",
        fr: "Add french translation",
      },
      description: {
        default:
          "The initial term of this Agreement shall be a period of one (1) year from the Effective Date. Thereafter, the Agreement shall automatically renew for subsequent one (1) year terms. At any time, either party may terminate this agreement, with or without cause, upon thirty (30) days prior written notice. Tomedes reserves the right to immediately terminate any User who commits fraud, slander, a denial-of-service attack, or commits any other action which it deems inappropriate. Neither party has made any commitments regarding the duration or renewal of this Agreement beyond those stated herein.",
        en: "The initial term of this Agreement shall be a period of one (1) year from the Effective Date. Thereafter, the Agreement shall automatically renew for subsequent one (1) year terms. At any time, either party may terminate this agreement, with or without cause, upon thirty (30) days prior written notice. Tomedes reserves the right to immediately terminate any User who commits fraud, slander, a denial-of-service attack, or commits any other action which it deems inappropriate. Neither party has made any commitments regarding the duration or renewal of this Agreement beyond those stated herein.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "2. SCOPE",
        en: "2. SCOPE",
        fr: "Add french translation",
      },
      description: {
        default:
          "Upon completion of the Registration Form and after accepting the site Terms of Service and this agreement, the User is authorized to postTranslation Requests. This is a master agreement between User and Tomedes and shall apply to all transactions and business conducted between the parties.",
        en: "Upon completion of the Registration Form and after accepting the site Terms of Service and this agreement, the User is authorized to postTranslation Requests. This is a master agreement between User and Tomedes and shall apply to all transactions and business conducted between the parties.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "3. User's OBLIGATIONS",
        en: "3. User's OBLIGATIONS",
        fr: "Add french translation",
      },
      description: {
        default:
          "The User will post a translation request, including all relevant information and/or documents in relation with his request. The User will process payment as requested by Tomedes before starting the translation process.",
        en: "The User will post a translation request, including all relevant information and/or documents in relation with his request. The User will process payment as requested by Tomedes before starting the translation process.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: " ",
        en: " ",
        fr: " ",
      },
      description: {
        default:
          "4. This Agreement shall govern the business relationship between Tomedes and User despite any different or conflicting terms and conditions in User's forms or other documents.",
        en: "4. This Agreement shall govern the business relationship between Tomedes and User despite any different or conflicting terms and conditions in User's forms or other documents.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "4.1. GENERAL",
        en: "4.1. GENERAL",
        fr: "Add french translation",
      },
      description: {
        default:
          "o The User authorizes Tomedes to treat any person using User's password pair (username and password), and any resulting transactions, obligations and liabilities as if User used the website and/or services itself.<br /><br />o User must not try to expose the identity of other Users or of Providers. The identity of Providers and of other Users is not visible to the Users. The User must not post any information which may reveal his identity to Providers or other Users. Posting contact information including but not limited to phone #s, email addresses, Internet URL's, Yahoo Messenger Ids, ICQ ids is strictly prohibited.",
        en: "o The User authorizes Tomedes to treat any person using User's password pair (username and password), and any resulting transactions, obligations and liabilities as if User used the website and/or services itself.<br /><br />o User must not try to expose the identity of other Users or of Providers. The identity of Providers and of other Users is not visible to the Users. The User must not post any information which may reveal his identity to Providers or other Users. Posting contact information including but not limited to phone #s, email addresses, Internet URL's, Yahoo Messenger Ids, ICQ ids is strictly prohibited.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "4.2. REGISTRATION",
        en: "4.2. REGISTRATION",
        fr: "Add french translation",
      },
      description: {
        default:
          "o User's information shall be true, accurate and up-to-date at all times.",
        en: "o User's information shall be true, accurate and up-to-date at all times.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "4.3. PAYMENT",
        en: "4.3. PAYMENT",
        fr: "Add french translation",
      },
      description: {
        default:
          "o Payment will be processed by the User prior to commencing the translation process. Missing or incomplete payment will cause a delay in starting and therefore a delay in delivering the completed translation.<br /><br />o The User is the only responsible party for a delay caused by the above reason.<br /><br />Violators of any of these terms can have all of their Tomedes accounts terminated, suspended or revoked at the discretion of Tomedes.",
        en: "o Payment will be processed by the User prior to commencing the translation process. Missing or incomplete payment will cause a delay in starting and therefore a delay in delivering the completed translation.<br /><br />o The User is the only responsible party for a delay caused by the above reason.<br /><br />Violators of any of these terms can have all of their Tomedes accounts terminated, suspended or revoked at the discretion of Tomedes.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "5. Refund/Cancellation policy",
        en: "5. Refund/Cancellation policy",
        fr: "Add french translation",
      },
      description: {
        default:
          "1. Any cancellation request after an order has been processed must be submitted in writing to the following email address: support@tomedes.com<br /><br />2. If the company has not yet started the translation a full cancellation and refund will be granted. Should the translation already be in process, it will be stopped at the earliest opportunity (taking possible time zone hour differences into consideration). The client will only be charged for the part of the translation which has been completed.<br /><br />3. Our goal is to provide a service of exceptional quality at a great value. For this reason, we offer a 1 year guarantee on all of our language services. Should you have any concern or are not satisfied with the final product, please contact our customer service at 'email' or 'phone Nr.' Our translator will review the translation according to the client’s comments and offer feedback. Any agreed upon errors will be edited at no extra charge to the client. In certain cases, where we fail to meet an agreement with the client, a partial or full refund may be offered.",
        en: "1. Any cancellation request after an order has been processed must be submitted in writing to the following email address: support@tomedes.com<br /><br />2. If the company has not yet started the translation a full cancellation and refund will be granted. Should the translation already be in process, it will be stopped at the earliest opportunity (taking possible time zone hour differences into consideration). The client will only be charged for the part of the translation which has been completed.<br /><br />3. Our goal is to provide a service of exceptional quality at a great value. For this reason, we offer a 1 year guarantee on all of our language services. Should you have any concern or are not satisfied with the final product, please contact our customer service at 'email' or 'phone Nr.' Our translator will review the translation according to the client’s comments and offer feedback. Any agreed upon errors will be edited at no extra charge to the client. In certain cases, where we fail to meet an agreement with the client, a partial or full refund may be offered.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "6. User's REPRESENTATIONS.",
        en: "6. User's REPRESENTATIONS.",
        fr: "Add french translation",
      },
      description: {
        default:
          "User represents that it has the full power and authority to execute this Agreement. User is the owner of, and/or has received all appropriate consent from the owners of, any and all material, information, intellectual property in any form, or other data that User makes available to Tomedes.",
        en: "User represents that it has the full power and authority to execute this Agreement. User is the owner of, and/or has received all appropriate consent from the owners of, any and all material, information, intellectual property in any form, or other data that User makes available to Tomedes.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "7. TAXES",
        en: "7. TAXES",
        fr: "Add french translation",
      },
      description: {
        default:
          "Tomedes does not collect taxes, duties, fees or other governmentally imposed excises, so User and Provider agree to assume their respective responsibilities under the law",
        en: "Tomedes does not collect taxes, duties, fees or other governmentally imposed excises, so User and Provider agree to assume their respective responsibilities under the law",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "8. TRADEMARKS AND CONFIDENTIAL INFORMATION.",
        en: "8. TRADEMARKS AND CONFIDENTIAL INFORMATION.",
        fr: "Add french translation",
      },
      description: {
        default:
          "Any information the User disclosed to the providers is considered confidential unless indicated otherwise<br /><br />Return of Confidential Information. In any event of termination or expiration of this Agreement, each party will, within five (5) business days, return to the other party such party's Confidential Information.",
        en: "Any information the User disclosed to the providers is considered confidential unless indicated otherwise<br /><br />Return of Confidential Information. In any event of termination or expiration of this Agreement, each party will, within five (5) business days, return to the other party such party's Confidential Information.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "9. INTELLECTUAL PROPERTY INFRINGEMENT INDEMNITY",
        en: "9. INTELLECTUAL PROPERTY INFRINGEMENT INDEMNITY",
        fr: "Add french translation",
      },
      description: {
        default:
          "Infringement Claims. The Provider will defend and hold Tomedes harmless in any suit or proceeding based on a claim that any equipment, products or services transacted under this Agreement, constitutes infringement of any copyright, patent or trademark. Provider will pay all settlements or damages awarded against Tomedes, provided that Tomedes (i) informs Provider of such suit or proceeding in writing and within thirty (30) days of actual notice of a claim, and provides Provider with all related information, (ii) grants Provider the authority to settle or litigate such suit or proceeding, and (iii) provides all necessary assistance to Provider.",
        en: "Infringement Claims. The Provider will defend and hold Tomedes harmless in any suit or proceeding based on a claim that any equipment, products or services transacted under this Agreement, constitutes infringement of any copyright, patent or trademark. Provider will pay all settlements or damages awarded against Tomedes, provided that Tomedes (i) informs Provider of such suit or proceeding in writing and within thirty (30) days of actual notice of a claim, and provides Provider with all related information, (ii) grants Provider the authority to settle or litigate such suit or proceeding, and (iii) provides all necessary assistance to Provider.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "10. LIMITATION OF LIABILITY; INDEMNITY.",
        en: "10. LIMITATION OF LIABILITY; INDEMNITY.",
        fr: "Add french translation",
      },
      description: {
        default:
          "IN NO EVENT SHALL TOMEDES BE LIABLE TO BUYERS, PROVIDERS OR ANY OTHER PERSON FOR EXEMPLARY, INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION THE COST OF COVER, LOSS OF PROFIT, USE, SAVINGS OR REVENUE, OR THE CLAIMS OF THIRD PARTIES, WHETHER OR NOT TOMEDES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS. THE LIMITATIONS IN THIS SECTION SHALL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.<br /><br />Indemnification by Provider.Provider shall indemnify, defend (with counsel approved in writing by Tomedes) and hold Tomedes, its officers, directors, shareholders, employees, insurers, attorneys, successors and assigns harmless against any and all claims for cost, damage, expense (including reasonable attorneys - fees) or liability arising out of or related to the acts or omissions of Provider, its employees, representatives or agents.",
        en: "IN NO EVENT SHALL TOMEDES BE LIABLE TO BUYERS, PROVIDERS OR ANY OTHER PERSON FOR EXEMPLARY, INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION THE COST OF COVER, LOSS OF PROFIT, USE, SAVINGS OR REVENUE, OR THE CLAIMS OF THIRD PARTIES, WHETHER OR NOT TOMEDES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS. THE LIMITATIONS IN THIS SECTION SHALL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.<br /><br />Indemnification by Provider.Provider shall indemnify, defend (with counsel approved in writing by Tomedes) and hold Tomedes, its officers, directors, shareholders, employees, insurers, attorneys, successors and assigns harmless against any and all claims for cost, damage, expense (including reasonable attorneys - fees) or liability arising out of or related to the acts or omissions of Provider, its employees, representatives or agents.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "11. DEFAULT AND TERMINATION.",
        en: "11. DEFAULT AND TERMINATION.",
        fr: "Add french translation",
      },
      description: {
        default:
          "Default. Should the User default, their account may be terminated by Tomedes. User shall be considered to have defaulted under the Agreement for any failure to perform its obligations and/or if Tomedes discovers any material misrepresentation or omission that User has made in this Agreement or its Registration. In the case of either party, the failure by such party to observe or perform any material covenant or obligation under this Agreement shall constitute default. User may also be considered in default if they violate the site terms of service.<br /><br />Survival. The parties' obligations under Sections 6, 7 and 8 shall survive any termination and/or expiration of this Agreement.",
        en: "Default. Should the User default, their account may be terminated by Tomedes. User shall be considered to have defaulted under the Agreement for any failure to perform its obligations and/or if Tomedes discovers any material misrepresentation or omission that User has made in this Agreement or its Registration. In the case of either party, the failure by such party to observe or perform any material covenant or obligation under this Agreement shall constitute default. User may also be considered in default if they violate the site terms of service.<br /><br />Survival. The parties' obligations under Sections 6, 7 and 8 shall survive any termination and/or expiration of this Agreement.",
        fr: "Add french translation",
      },
    },
    {
      title: {
        default: "12. GENERAL.",
        en: "12. GENERAL.",
        fr: "Add french translation",
      },
      description: {
        default:
          "Assignment. User shall not assign or transfer this Agreement without Tomedes's prior written consent, which shall not be unreasonably withheld. Any attempted assignment shall be null and void.<br /><br />Relationship of the Parties. This Agreement does not create a franchise, joint venture or partnership between the parties. Neither party hereunder is the agent, broker, partner, employee, or legal representative of the other for any purpose.<br /><br />Excused Performance. Neither party shall be liable for failure to perform its obligations under this Agreement for causes beyond its reasonable control.<br /><br />No Waiver. The failure of either party to enforce any of the provisions hereof shall not be construed to be a waiver of the right of such party to thereafter enforce any such provision.<br /><br />Unenforceable Provisions. If any term of this Agreement is found to be illegal or unenforceable, the remaining portions of this Agreement shall remain in effect, provided that the parties agree to negotiate in good faith substitute enforceable term<br /><br />Modifications; Special Agreements; Entire Agreement. Note that Tomedes reserves the right from time to time to amend, modify or change this agreement. Due to the majority of parties requesting not to be contacted via email about updates to the site, email notice will not always be given. Additionally, due to the financial costs associated with written notices...written notice will not always be given. If you are interested in keeping abreast of the latest changes to this agreement, then please bookmark this page and review it from time to time.<br /><br />IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS AGREEMENT BY PROVIDING NOTICE TO US. YOUR CONTINUED PARTICIPATION IN THE PROGRAM FOLLOWING OUR POSTING OF A CHANGE NOTICE OR NEW AGREEMENT ON OUR SITE WILL CONSTITUTE BINDING ACCEPTANCE OF THE CHANGE.<br /><br />Should Tomedes and the User come to a special understanding not outlined in this agreement it will be laid out in writing and signed by both parties.<br /><br />This Agreement is the entire understanding between User and Tomedes with respect to the subject matter of this Agreement, and supersedes all (i) proposals, oral or written, (ii) negotiations, conversations or discussions between the parties and (iii) industry custom or past course of dealing, relating to the subject matter.",
        en: "Assignment. User shall not assign or transfer this Agreement without Tomedes's prior written consent, which shall not be unreasonably withheld. Any attempted assignment shall be null and void.<br /><br />Relationship of the Parties. This Agreement does not create a franchise, joint venture or partnership between the parties. Neither party hereunder is the agent, broker, partner, employee, or legal representative of the other for any purpose.<br /><br />Excused Performance. Neither party shall be liable for failure to perform its obligations under this Agreement for causes beyond its reasonable control.<br /><br />No Waiver. The failure of either party to enforce any of the provisions hereof shall not be construed to be a waiver of the right of such party to thereafter enforce any such provision.<br /><br />Unenforceable Provisions. If any term of this Agreement is found to be illegal or unenforceable, the remaining portions of this Agreement shall remain in effect, provided that the parties agree to negotiate in good faith substitute enforceable term<br /><br />Modifications; Special Agreements; Entire Agreement. Note that Tomedes reserves the right from time to time to amend, modify or change this agreement. Due to the majority of parties requesting not to be contacted via email about updates to the site, email notice will not always be given. Additionally, due to the financial costs associated with written notices...written notice will not always be given. If you are interested in keeping abreast of the latest changes to this agreement, then please bookmark this page and review it from time to time.<br /><br />IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS AGREEMENT BY PROVIDING NOTICE TO US. YOUR CONTINUED PARTICIPATION IN THE PROGRAM FOLLOWING OUR POSTING OF A CHANGE NOTICE OR NEW AGREEMENT ON OUR SITE WILL CONSTITUTE BINDING ACCEPTANCE OF THE CHANGE.<br /><br />Should Tomedes and the User come to a special understanding not outlined in this agreement it will be laid out in writing and signed by both parties.<br /><br />This Agreement is the entire understanding between User and Tomedes with respect to the subject matter of this Agreement, and supersedes all (i) proposals, oral or written, (ii) negotiations, conversations or discussions between the parties and (iii) industry custom or past course of dealing, relating to the subject matter.",
        fr: "Add french translation",
      },
    },
  ],
};

export const translationCost = {
  title: "Pay the Right Translation Price",
  images: images,
  paraghraph: [
    {
      id: 1,
      text: "Tomedes translation service provides professional translation for business customers and individuals across the globe. We aim for transparency in our business, and this applies to translation cost as well as to other areas of our work. Your translation price will be confirmed during your initial discussions with Tomedes, so that you know from the outset what the cost will be.",
    },
    {
      id: 2,
      text: "Translation cost can vary based on a range of factors. The laws of supply and demand impact translation price, just as they do almost all goods and services. That means that commonly paired languages, such as Spanish and English, which have an abundance of translators available, will command a lower price per word than less commonly sought language pairings. A language from Kannada to Zulu (for example) will cost more per word than one from English to Spanish, simply due to the fact that there are fewer translators available (and those that are available can command higher rates).",
    },
  ],

  paraghraph1: [
    {
      id: 1,
    },
    {
      id: 2,
      text1:
        "Translation price can also vary based on the type of content being translated. Topics with complex terminology, such as medical translation and legal translation, require specialist translators to work on them. Thus they tend to command higher translation rates than more general content. Once more this is the result of simple economics – the translation cost for niche services is higher as there are fewer translators available to work on them.",
    },
    {
      id: 3,
      text1:
        "The urgency with which a document is required can also impact on the translation cost. If an urgent translation service is required, this will usually command a price premium.",
    },
    {
      id: 4,
      text1:
        "To get an initial idea of the translation price for your document, please use the Tomedes instant quote service. This service provides an indicative translation cost based on the language pairing that you require and the number of words to be translated. You can also speak to the helpful Tomedes team to discuss your translation requirements in more detail and confirm the translation price that will apply to your document.",
    },
  ],
};

export const leaveAReviewData = {
  title: {
    text: {
      default: "Leave A Review",
      en: "Leave A Review",
      fr: "Add french translation",
    },
    highlightWords: {
      default: ["Review"],
      en: ["Review"],
      fr: ["french"],
    },
    highlightColor: "yellow",
  },

  subtitle: {
    default:
      "If you're a new client or a returning client, feel free to assess the experience you've had with us and leave a review here.",
    en: "If you're a new client or a returning client, feel free to assess the experience you've had with us and leave a review here.",
    fr: "Add french translation",
  },

  name: {
    label: {
      default: "Name",
      en: "Name",
      fr: "Add french translation",
    },
    placeholder: {
      default: "Enter your name",
      en: "Enter your name",
      fr: "Enter your name",
    },
  },
  company: {
    label: {
      default: "Company/Business",
      en: "Company/Business",
      fr: "Add french translation",
    },
  },
  email: {
    label: {
      default: "Email Address",
      en: "Email Address",
      fr: "Add french translation",
    },
    placeholder: {
      default: "Enter your email",
      en: "Enter your email",
      fr: "Add french translation",
    },
  },
  selectRating: {
    label: {
      default: "Select Rating",
      en: "Select Rating",
      fr: "Add french translation",
    },
  },
  review: {
    label: {
      default: "Reviews",
      en: "Reviews",
      fr: "Add french translation",
    },
    placeholder: {
      default: "Please write your review here",
      en: "Please write your review here",
      fr: "Add french translation",
    },
  },
  submitButton: {
    text: {
      default: "Submit",
      en: "Submit",
      fr: "Add french translation",
    },
  },
  verifyCaptcha: {
    text: {
      default: "Please verify captcha",
      en: "Please verify captcha",
      fr: "Add french translation",
    },
  },
  submittedSuccessfully: {
    text: {
      default: "Review submitted successfully",
      en: "Review submitted successfully",
      fr: "Add french translation (Review submitted sucessfully)",
    },
  },
};

export const readyToGetStartedData = {
  title: {
    text: {
      default: "Ready to Get Started?",
      en: "Ready to Get Started?",
      fr: "Add french translation",
    },
    highlightWords: {
      default: ["Ready"],
      en: ["Ready"],
      fr: ["french"],
    },
    highlightColor: "yellow",
  },
  subtitle: {
    default:
      "If you're a new client looking to broaden your horizons with Tomedes, here's your chance to partner with us. Contact us today, or get a free quote right now.",
    en: "If you're a new client looking to broaden your horizons with Tomedes, here's your chance to partner with us. Contact us today, or get a free quote right now.",
    fr: "Add french translation",
  },
  translateNow: {
    default: "TRANSLATE NOW",
    en: "TRANSLATE NOW",
    fr: "Add french translation",
  },
  contactUs: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "Add french translation",
  },
};

export const featuredInData = {
  title: {
    default: "Featured In",
    en: "Featured In",
    fr: "Nous collaborons avec",
  },

  highlightWords: {
    default: [""],
    en: [""],
    fr: ["french"],
  },

  highlightedColor: "yellow",

  clients: [
    {
      id: 1,
      title: {
        default: "Yahoo",
        en: "Yahoo",
        fr: "Add french translation",
      },
      icon: "yahoofin",

      className: "w-44 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Reuters",
        en: "Reuters",
        fr: "Add french translation",
      },
      icon: "reuters",

      className: "w-44 h-auto",
    },
    {
      id: 3,
      title: {
        default: "CBS",
        en: "CBS",
        fr: "Add french translation",
      },
      icon: "cbs",
      className: "w-44 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Daily Herald",
        en: "Daily Herald",
        fr: "Add french translation",
      },
      icon: "daily",
      className: "w-44 h-auto",
    },
    {
      id: 5,
      title: {
        default: "StarTribune",
        en: "StarTribune",
        fr: "Add french translation",
      },
      icon: "startrib",
      className: "w-48 h-auto",
    },
    {
      id: 6,
      title: {
        default: "Entrepreneur",
        en: "Entrepreneur",
        fr: "Add french translation",
      },
      icon: "entre",
      className: "w-44 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Harvard University",
        en: "Harvard University",
        fr: "Add french translation",
      },
      icon: "harvard",
      className: "w-44 h-auto",
    },
    {
      id: 8,
      title: {
        default: "towards data science",
        en: "towards data science",
        fr: "Add french translation",
      },
      icon: "towards",
      className: "w-44 h-auto",
    },
    {
      id: 9,
      title: {
        default: "lulu blog",
        en: "lulu blog",
        fr: "Add french translation",
      },
      icon: "lulu",
      className: "w-44 h-auto",
    },
  ],
};

//----services all data--------------------
export const ServiceData = {
  title: {
    default: "Professional Translation Services On A Global Scale",
    en: "Professional Translation Services On A Global Scale",
    fr: "Services de traduction",
  },
  description: {
    default:
      "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    en: "At Tomedes, we’ve made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you need, standard document or certified. We speak your language to convey your meaning to the world easily.",
    fr: "Quels que soient la nature et le volume de vos documents, nos solutions de traduction professionnelles s’adaptent à vos besoins linguistiques, dans toutes les langues.",
  },

  buttonDetails: {
    text: {
      default: "TRANSLATE NOW",
      en: "TRANSLATE NOW",
      fr: "Demande de devis",
    },
    link: "/quote",
  },
  svgsTitle: {
    default: "Trusted by Satisfied Clients Worldwide",
    en: "Trusted by Satisfied Clients Worldwide",
    fr: "Add french translation",
  },
  seal: [
    {
      icon: "guarantee",
      text: {
        default: "1 Year Guarantee",
        en: "1 Year Guarantee",
        fr: " 1 an de garantie |",
      },
    },
    {
      icon: "availability",
      text: {
        default: "24/7 Availability",
        en: "24/7 Availability",
        fr: " Service client 24h/24 - 7j/7 |",
      },
    },
    {
      icon: "rapid-delivery",
      text: {
        default: "Rapid Delivery",
        en: "Rapid Delivery",
        fr: " Livraison express",
      },
    },
  ],
  enquiry_form: {
    title: {
      default: "Parlez-nous de vous et de votre projet",
      en: "Add english translation",
      fr: "Parlez-nous de vous et de votre projet",
    },
    highlightWords: {
      default: ["Parlez-nous"],
      en: ["Parlez-nous"],
      fr: ["Parlez-nous"],
    },
    highlightedColor: "yellow",
    subtitle: {
      default:
        "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
      en: "Add english translation",
      fr: "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
    },

    placeholder: {
      name: {
        default: "Name",
        en: "Name",
        fr: "Add french translation",
      },
      email: {
        default: "Email Address",
        en: "Email Address",
        fr: "Add french translation",
      },
      tellUs: {
        default: "Tell us more about your needs",
        en: "Tell us more about your needs",
        fr: "Add french translation",
      },
    },

    submitButtonText: {
      default: "SUBMIT",
      en: "SUBMIT",
      fr: "Add french translation",
    },
  },
};

// ------ServiceCard---------
export const ServicesCard = {
  service: [
    {
      title: {
        default: "Pourquoi choisir Tomedes",
        en: "Add English translation",
        fr: "Traduction professionnelle: Toutes nos prestations",
      },
      highlightWords: {
        default: ["Pourquoi"],
        en: ["English"],
        fr: ["Pourquoi"],
      },
      description: {
        default: "",
        en: "",
        fr: "Présentation des services de traduction par métiers",
      },
      services: [
        {
          id: 1,
          title: {
            default: "24/7 Customer Service",
            en: "24/7 Customer Service",
            fr: "Traduction assermentée",
          },
        },

        {
          id: 2,
          title: {
            default: "1-year guarantee",
            en: "1-year guarantee",
            fr: "Traduction juridique",
          },
        },
        {
          id: 3,
          title: {
            default: "Fast Delivery",
            en: "Fast Delivery",
            fr: "Traduction médicale",
          },
        },
        {
          id: 4,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Traduction technique",
          },
        },
        {
          id: 5,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Traduction financière",
          },
        },
        {
          id: 6,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Traduction de documents",
          },
        },
        {
          id: 7,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Traduction marketing",
          },
        },
        {
          id: 8,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "voir tous nos services de traduction",
          },
        },
      ],
    },
    {
      title: {
        default: "Pourquoi choisir Tomedes",
        en: "Add English translation",
        fr: "Tous Services linguistiques",
      },
      highlightWords: {
        default: ["Pourquoi"],
        en: ["English"],
        fr: ["Pourquoi"],
      },
      description: {
        default: "",
        en: "",
        fr: "Présentation des services de traduction par spécialité",
      },

      services: [
        {
          id: 1,
          title: {
            default: "",
            en: "",
            fr: "Rédaction de contenu",
          },
        },
        {
          id: 2,
          title: {
            default: "1-year guarantee",
            en: "1-year guarantee",
            fr: "interprétation",
          },
        },
        {
          id: 3,
          title: {
            default: "Fast Delivery",
            en: "Fast Delivery",
            fr: "Voix-off",
          },
        },
        {
          id: 4,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Sous-titrage multilingue",
          },
        },
        {
          id: 5,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "PAO Multillingue",
          },
        },
        {
          id: 6,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Relecture et révision de texte",
          },
        },
        {
          id: 7,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Transcription",
          },
        },
        {
          id: 8,
          title: {
            default: "75,000 Business Customers",
            en: "75,000 Business Customers",
            fr: "Toutes nos prestations",
          },
        },
      ],
    },
  ],
};

export const VosTraductions = {
  css1: "bg-[#010E27] flex justify-center items-center lg:py-16 xl:pl-6 ",
  css: "grid grid-cols-1 md:grid-cols-2 gap-x-5 py-7 xs:mx-5 sm:mx-10 md:mx-16 xl:w-[1157px]",
  imgurl: Img,
  headingContainerCss: "md:basis-1/2",
  heading: {
    text1: {
      default: "Un réseau de",
      en: "Add English translation",
      fr: "Nos services",
    },
    highlightedText: {
      default: ["Un"],
      en: ["English"],
      fr: ["traductions"],
    },
    text2: {
      default: "traducteurs natifs",
      en: "Add English translation",
      fr: "d'internationalisation",
    },
    headingContainerCss: "flex flex-col",
    css: "text-primary text-slate text-4xl leading-snug font-medium",
  },
  paraContainerCss: "md:basis-1/2 md:pl-4 pt-10 md:pt-0",
  para1: {
    text: {
      default: "Add English transaltion",
      en: "Add English translation",
      fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
    },
    css: "text-mediumGrey text-base font-opensans mb-12",
  },
  para2: {
    text: {
      default:
        "Tous nos traducteurs, linguistes et interprètes sont spécialistes de leur langue natale. Vous êtes certain de bénéficier de la meilleure qualité de traduction, dans les meilleurs délais.",
      en: "Add English translation",
      fr: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. ",
    },
    css: "text-mediumGrey text-base font-opensans mb-11",
  },

  button: {
    text: {
      default: "EN SAVOIR PLUS",
      en: "Add English translation",
      fr: "LEARN MORE",
    },
    css: " bg-[#FB7C32] px-10 text-white py-4 font-opensans, rounded-3xl text-sm ",
    link: "/",
  },
};

export const serviceDataTraduction2 = {
  title: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Nos traducteurs professionnels dans plus de 120 Langues",
  },
  highlightWords: ["Traduction"],
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    fr: "Sur 5 continents. Plus de 120 langues et 950 combinaisons disponibles. Nos traducteurs natifs, bilingues, certifiés et experts en linguistique sont prêts à travailler sur tous vos projets. Qualité et excellence des services",
  },
  clients: [
    {
      id: 1,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Anglais",
      },
    },
    {
      id: 2,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Portugais",
      },
    },
    {
      id: 3,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Arabe",
      },
    },
    {
      id: 4,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Japonais",
      },
    },
    {
      id: 5,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Allemand",
      },
    },
    {
      id: 6,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Italien",
      },
    },
    {
      id: 7,

      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Néerlandais",
      },
    },
    {
      id: 8,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Turc",
      },
    },
    {
      id: 9,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Espangnol",
      },
    },
    {
      id: 10,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Chinois",
      },
    },
    {
      id: 12,
      title: {
        default: "Add english translation",
        en: "Add english translation",
        fr: "Russe",
      },
    },
  ],
  heading: {
    default: "add english translation",
    en: "add english translation",
    fr: "Plus de 950 combinaisons de language pour tous vos documents",
  },
  para: {
    default: "add english translation",
    en: "add english translation",
    fr: " Donner des exemples de combination de langues",
  },
  linkText: {
    default: "add english translation",
    en: "add english translation",
    fr: " LEARN MORE",
  },
};

export const ServicesData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Nos serices de traduction a bordeaux",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint nostrum ipsum neque suscipit maxime, similique nam vero quibusdam repudiandae sapiente.",
  },
  image:
    "https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/business-translation.webp?width=512",
  services: [
    {
      serviceTitle: {
        default: "Add English",
        en: "Add English",
        fr: "Nos Services",
      },
      serviceItems: [
        {
          id: 1,
          title: {
            default: "Technical translation",
            en: "Technical translation",
            fr: "Traduction techniqu",
          },
          description: {
            default: "Personal project manager",
            en: "Personal project manager",
            fr: "Add to french translation",
          },
        },
        {
          id: 2,
          title: {
            default: "Medical translation",
            en: "Medical translation",
            fr: "Traduction médicale",
          },
          description: {
            default: "Post-completion project support",
            en: "Post-completion project support",
            fr: "Add to french translation",
          },
        },
        {
          id: 3,
          title: {
            default: "Fast Delivery",
            en: "Fast Delivery",
            fr: "Traduction juridique",
          },
          description: {
            default: "Availability for urgent orders",
            en: "Availability for urgent orders",
            fr: "Add to french translation",
          },
        },
      ],
    },
    {
      serviceTitle: {
        default: "Add English",
        en: "Add English",
        fr: "Nos Services",
      },
      serviceItems: [
        {
          id: 1,
          title: {
            default: "Technical translation",
            en: "Technical translation",
            fr: "Traduction techniqu",
          },
          description: {
            default: "Personal project manager",
            en: "Personal project manager",
            fr: "Add to french translation",
          },
        },
        {
          id: 2,
          title: {
            default: "Medical translation",
            en: "Medical translation",
            fr: "Traduction médicale",
          },
          description: {
            default: "Post-completion project support",
            en: "Post-completion project support",
            fr: "Add to french translation",
          },
        },
        {
          id: 3,
          title: {
            default: "Fast Delivery",
            en: "Fast Delivery",
            fr: "Traduction juridique",
          },
          description: {
            default: "Availability for urgent orders",
            en: "Availability for urgent orders",
            fr: "Add to french translation",
          },
        },
      ],
    },
  ],
};

export const learnMoreDarkData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nostrum, reprehenderit!",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minus porro necessitatibus sapiente veritatis impedit praesentium quaerat nihil. Sit cumque repellat ratione a omnis odio sed molestias dolorem repudiandae. Eaque, delectus?",
  },
  cta: {
    text: {
      default: "LEARN MORE",
      en: "LEARN MORE",
      fr: "EN SAVOIR PLUS",
    },
    href: "/",
  },
};
export const learnMoreLightData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nostrum, reprehenderit!",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  description: {
    default: "Add English",
    en: "Add English",
    fr: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minus porro necessitatibus sapiente veritatis impedit praesentium quaerat nihil. Sit cumque repellat ratione a omnis odio sed molestias dolorem repudiandae. Eaque, delectus?",
  },
  cta: {
    text: {
      default: "LEARN MORE",
      en: "LEARN MORE",
      fr: "EN SAVOIR PLUS",
    },
    href: "/",
  },
};

export const enquiryFormData = {
  title: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Parlez-nous de vous et de votre projet",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["Parlez-nous"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
  },

  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Nom complet",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Adresse e-mail",
    },
    message: {
      default: "Tell us more about your needs",
      en: "Tell us more about your needs",
      fr: "En quoi pouvons-nous vous aider ?",
    },
  },

  fieldRequired: {
    default: "This field is required",
    en: "This field is required",
    fr: "Ce champ est obligatoire",
  },

  submitButtonText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "ENVOYER",
  },
};

export const LocationContactUsData = {
  title: {
    default: "Add English",
    en: "Add English",
    fr: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  },
  highlightWords: {
    default: ["Contact Us 24/7"],
    en: ["Contact Us 24/7"],
    fr: ["Add french translation"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "Add English",
    en: "Add English",
    fr: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus, doloremque atque repudiandae, eligendi ipsam quibusdam quasi assumenda autem quidem ea distinctio temporibus explicabo aperiam recusandae expedita voluptatem quis obcaecati corrupti ducimus ratione itaque molestiae consectetur delectus! A, facere, incidunt fugit aut maiores officiis adipisci laboriosam eligendi quo aperiam neque ipsam!",
  },
  cta: {
    text: {
      default: "Submit",
      en: "Submit",
      fr: "contactez-nous",
    },
    href: "/contactus.php",
  },
};

// ------------------Legal translation services data-------------
export const ServiceStatsTwoData = {
  title: {
    default: "add english",
    en: "add english",
    fr: "Legal Transcription Company + Main Markets",
  },
  highlightWords: {
    default: ["document"],
    en: ["document"],
    fr: ["french"],
  },
  highlightedColor: "yellow",
  stats: [
    {
      icon: "security",
      title: {
        default: "add english",
        en: "add english",
        fr: "Lawyers and Law Firms",
      },
      description: {
        default: "add english",
        en: "add english",
        fr: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui.",
      },
    },
    {
      icon: "security",
      title: {
        default: "add english",
        en: "add english",
        fr: "Legal Courts",
      },
      description: {
        default: "add english",
        en: "add english",
        fr: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui.",
      },
    },
    {
      icon: "security",
      title: {
        default: "add english",
        en: "add english",
        fr: "Businesses",
      },
      description: {
        default: "add english",
        en: "add english",
        fr: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui.",
      },
    },
    {
      icon: "security",
      title: {
        default: "add english",
        en: "add english",
        fr: "Law Enforcement",
      },
      description: {
        default: "add english",
        en: "add english",
        fr: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui.",
      },
    },
  ],
};

export const MachineTransData = {
  title: "MT + Marketing Messages (Why choose us)",
  // highlightWords: [""],
  // highlightedColor: "yellow",
  stats: [
    {
      icon: "security",
      title: "95,000 Business Customers",
      description:
        "Tomedes is delighted to count over 95,000 businesses worldwide among our clients. Our years of dedication and commitment to every project has led us to work hand-in-hand with Fortune 500 companies as well as small-to-medium businesses all around the globe.",
    },
    {
      icon: "security",
      title: "98% Customer Satisfaction Rate",
      description:
        "Tomedes’ exceptional reputation is built on years of exceptional services and high-quality solutions for all types of corporate translation needs around the world.",
    },
    {
      icon: "security",
      title: "ISO Certified Providing High Quality",
      description:
        "As an ISO-certified translation provider, you can be sure that your project is of the highest level of quality assurance and care. This includes certification for all of our online translations, from human and machine alike.",
    },
    {
      icon: "security",
      title: "Fast Delivery",
      description:
        "Do you have an urgent project? No worries! Tomedes guarantees fast, dependable delivery for translations of any size or complexity. Just sit back, relax, and let us do the work.",
    },
  ],
};

export const DoubleColTwoData = {
  title: {
    default: "add english",
    en: "add english",
    fr: "Legal Transcription Services (What we do)",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["What we do"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "add english",
    en: "add english",
    fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architect.",
  },
  maindata: [
    {
      id: 1,
      icon: "security",
      heading: {
        default: "add english",
        default: "add english",
        fr: "Arbitration (Pillar Page 1)",
      },
      maintext: {
        default: "add english",
        en: "add english",
        fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium",
      },
    },
    {
      id: 1,
      icon: "security",
      heading: {
        default: "add english",
        default: "add english",
        fr: "Arbitration (Pillar Page 1)",
      },
      maintext: {
        default: "add english",
        en: "add english",
        fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium",
      },
    },
    {
      id: 1,
      icon: "security",
      heading: {
        default: "add english",
        default: "add english",
        fr: "Arbitration (Pillar Page 1)",
      },
      maintext: {
        default: "add english",
        en: "add english",
        fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium",
      },
    },
    {
      id: 1,
      icon: "security",
      heading: {
        default: "add english",
        default: "add english",
        fr: "Arbitration (Pillar Page 1)",
      },
      maintext: {
        default: "add english",
        en: "add english",
        fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium",
      },
    },
  ],
};
export const twoColGridNewData = {
  title: {
    default: "Add English translation",
    en: "Add English translation",
    fr: "Legal Transcription Company + Main Markets",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  items: [
    {
      image: {
        default:
          "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        en: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        fr: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
      },

      heading: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Sed ut perspiciatis unde (for Lawyers & Law Firms)",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          },
          highlightWords: {
            default: [""],
            en: [""],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        en: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        fr: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
      },

      heading: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Sed ut perspiciatis unde (for Lawyers & Law Firms)",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          },
          highlightWords: {
            default: [""],
            en: [""],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        en: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        fr: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
      },

      heading: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Sed ut perspiciatis unde (for Lawyers & Law Firms)",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          },
          highlightWords: {
            default: [""],
            en: [""],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        en: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
        fr: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170",
      },

      heading: {
        default: "Add English translation",
        en: "Add English translation",
        fr: "Sed ut perspiciatis unde (for Lawyers & Law Firms)",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
        {
          text: {
            default: "Add English translation",
            en: "Add English translation",
            fr: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          },
          highlightWords: {
            default: [""],
            en: [""],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
  ],
};

// export const bannerData = {
//   logoIcon: SecurityIcon,
//   logoText: {
//     default: "legal transcription",
//     en: "legal transcription",
//     fr: "",
//   },
//   navList: [
//     {
//       id: 1,
//       text: {
//         default: "Services",
//         en: "Services",
//         fr: "",
//       },
//     },
//     {
//       id: 2,
//       text: {
//         default: "Company",
//         en: "Company",
//         fr: "",
//       },
//     },
//     {
//       id: 3,
//       text: {
//         default: "Contact Us",
//         en: "Contact Us",
//         fr: "",
//       },
//     },
//   ],

//   heading: {
//     default: "Legal Transcription Services",
//     en: "Legal Transcription Services",
//     fr: "",
//   },
//   description: {
//     default:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.",
//     en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.",
//     fr: "",
//   },
//   btnText: {
//     default: "GET STARTED",
//     en: "GET STARTED",
//     fr: "",
//   },
//   imgurl: "https://tomedes.gumlet.io/assets/quality-policy/image_1.webp",
// };

export const Uspdata = {
  imgurl: "",
  title: {
    default: "Three Simple Steps to Get Your Transcription Done!",
    en: "Three Simple Steps to Get Your Transcription Done!",
    fr: "",
  },
  listData: {
    default:
      " 1. Send us your files <br /> 2. Pay online <br />3. Get Transcript",
    en: " 1. Send us your files <br /> 2. Pay online <br />3. Get Transcript",
    fr: "",
  },
  btnText: {
    default: "GET STARTED TODAY",
    en: "GET STARTED TODAY",
    fr: "",
  },
  icon: "",
  securityText: {
    default: "Security, Privacy and Confidentiality Guarantee",
    en: "Security, Privacy and Confidentiality Guarantee",
    fr: "",
  },
  securityText2: {
    default: "Your information is protected by 256-bit SSL encryption.",
    en: "Your information is protected by 256-bit SSL encryption.",
    fr: "",
  },
};

export const onsidedata = {
  heading: {
    default:
      "On-Site Legal <br/> Transcription Anywhere <br/> in the United States",
    en: "On-Site Legal  <br/> Transcription Anywhere  <br/> in the United States",
    fr: "",
  },
  highlightWords: {
    default: ["United", " States"],
    en: ["United", " States"],
    fr: [""],
  },
  highlightedColor: "text-yellow",
  description: {
    default: "",
    en: "",
    fr: " Sed ut perspiciatis unde omnis iste natus error sit <br/> voluptatem accusantium doloremque laudantium, totam <br/>rem aperiam, eaque ipsa quae ab illo inventore veritatis et <br/> quasi architecto beatae vitae dicta sunt explicabo.",
  },
};

export const ctaWithFormData = {
  title: {
    default: "add english",
    en: "add english",
    fr: "Insert CTA content here",
  },
  policyAgreement: {
    default: "add english",
    en: "add english",
    fr: "*By submitting, you agree to Tomedes' Pivacy Policy.",
  },
};
export const certificationSampleData = {
  imgurl: {
    default:
      "https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/business-translation.webp",
    en: "https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/business-translation.webp",
    fr: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170?width=572",
  },
  title: {
    default: "add english",
    en: "add english",
    fr: "Legal Transcription plus Marketing Messages here",
  },
  highlightWords: {
    default: ["english"],
    en: ["Messages"],
    fr: ["Messages"],
  },
  highlightedColor: "yellow",
  description: {
    default: "add english",
    en: "add english",
    fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
  },
};
